export const europeCitiesEN = [
        {
            "code": 10,
            "country_code": "DE",
            "label": "A-Burg",
            "names": {
                "de": "Aschaffenburg / Bayern",
                "en": "A-Burg",
                "pl": "Aschaffenburg",
                "ru": "Ашаффенбург"
            },
            "geotag": "2955272",
            "post_code": "63739"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Aachen",
            "names": {
                "de": "Kreisfreie Stadt Aachen",
                "en": "Aachen",
                "pl": "Akwizgran",
                "ru": "Ахен"
            },
            "geotag": "3247449",
            "post_code": "52062"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Aalen",
            "names": {
                "en": "Aalen",
                "de": "Aalen",
                "pl": "Aalen",
                "ru": "Ален"
            },
            "geotag": "2959927",
            "post_code": "73430"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Aalsmeer",
            "names": {
                "de": "Aalsmeer",
                "pl": "Aalsmeer",
                "en": "Aalsmeer",
                "ru": "Алсмер"
            },
            "geotag": "2760134",
            "post_code": "1431"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Abano Terme",
            "names": {
                "en": "Abano Terme",
                "pl": "Abano Terme",
                "de": "Abano Terme",
                "ru": "Абано-Терме"
            },
            "geotag": "3183587",
            "post_code": "35031"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Abbiategrasso",
            "names": {
                "pl": "Abbiategrasso",
                "de": "Abbiategrasso",
                "en": "Abbiategrasso",
                "ru": "Аббиатеграссо"
            },
            "geotag": "3183573",
            "post_code": "20081"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Achern",
            "names": {
                "de": "Achern",
                "pl": "Achern",
                "en": "Achern",
                "ru": "Ахерн"
            },
            "geotag": "2959686",
            "post_code": "77855"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Afragola",
            "names": {
                "pl": "Afragola",
                "en": "Afragola",
                "ru": "Афрагола"
            },
            "geotag": "3183455",
            "post_code": "80021"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Agrigento",
            "names": {
                "en": "Agrigento",
                "pl": "Agrigento",
                "de": "Agrigent",
                "ru": "Агридженто"
            },
            "geotag": "2525764",
            "post_code": "92100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Ahlen",
            "names": {
                "de": "Ahlen",
                "pl": "Ahlen",
                "en": "Ahlen",
                "ru": "Ален"
            },
            "geotag": "2959223",
            "post_code": "59227"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Ajka",
            "names": {
                "pl": "Ajka",
                "de": "Eickau",
                "en": "Ajka",
                "ru": "Айка"
            },
            "geotag": "3056357",
            "post_code": "8400"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Akhisar",
            "names": {
                "de": "Thyatira",
                "en": "Akhisar",
                "pl": "Akhisar",
                "ru": "Акхисар"
            },
            "geotag": "324698",
            "post_code": "02000"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Aksaray",
            "names": {
                "pl": "Aksaray",
                "de": "Aksaray",
                "en": "Aksaray",
                "ru": "Аксарай"
            },
            "geotag": "324496",
            "post_code": "23050"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Alba",
            "names": {
                "de": "Alba",
                "en": "Alba",
                "ru": "Альбом"
            },
            "geotag": "3183364",
            "post_code": "44395"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Alcamo",
            "names": {
                "en": "Alcamo",
                "pl": "Alcamo",
                "de": "Alcamo",
                "ru": "Алькамо"
            },
            "geotag": "2525755",
            "post_code": "91011"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Aleksandrów Łódzki",
            "names": {
                "pl": "Aleksandrów Łódzki",
                "de": "Aleksandrów Łódzki",
                "en": "Aleksandrów Łódzki",
                "ru": "Александрув-Лодзинский"
            },
            "geotag": "3104132",
            "post_code": "95-069"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Alessandria",
            "names": {
                "de": "Alessandria",
                "pl": "Alessandria",
                "en": "Alessandria",
                "ru": "Алессандрия"
            },
            "geotag": "3183299",
            "post_code": "15100"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Alkmaar",
            "names": {
                "de": "Alkmaar",
                "en": "Alkmaar",
                "pl": "Alkmaar",
                "ru": "Алкмар"
            },
            "geotag": "2759899",
            "post_code": "1811"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Almelo",
            "names": {
                "de": "Almelo",
                "en": "Almelo",
                "pl": "Almelo",
                "ru": "Алмело"
            },
            "geotag": "2759887",
            "post_code": "7601"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Altamura",
            "names": {
                "pl": "Altamura",
                "en": "Altamura",
                "ru": "Алтамура"
            },
            "geotag": "3183178",
            "post_code": "70022"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Altenburg",
            "names": {
                "de": "Altenburg",
                "pl": "Altenburg",
                "en": "Altenburg",
                "ru": "Альтенбург"
            },
            "geotag": "2957773",
            "post_code": "3591"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Amberg",
            "names": {
                "en": "Amberg",
                "de": "Amberg",
                "pl": "Amberg",
                "ru": "Амберг"
            },
            "geotag": "2956656",
            "post_code": "9761"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Amersfoort",
            "names": {
                "de": "Amersfoort",
                "en": "Amersfoort",
                "pl": "Amersfoort",
                "ru": "Амерсфорт"
            },
            "geotag": "2759821",
            "post_code": "3811"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Amstelveen",
            "names": {
                "de": "Amstelveen",
                "en": "Amstelveen",
                "ru": "Амстелвен"
            },
            "geotag": "2759798",
            "post_code": "1181"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Ancona",
            "names": {
                "de": "Ancona",
                "en": "Ancona",
                "pl": "Ankona",
                "ru": "Анкона"
            },
            "geotag": "3183089",
            "post_code": "60100"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Andenne",
            "names": {
                "en": "Andenne",
                "de": "Andenne",
                "ru": "Анденн"
            },
            "geotag": "2803204",
            "post_code": "5300"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Anderlecht",
            "names": {
                "en": "Anderlecht",
                "pl": "Anderlecht",
                "de": "Anderlecht",
                "ru": "Андерлехт"
            },
            "geotag": "2803201",
            "post_code": "1070"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Andria",
            "names": {
                "pl": "Andria",
                "de": "Andria",
                "en": "Andria",
                "ru": "Андрия"
            },
            "geotag": "3183072",
            "post_code": "76123"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Ans",
            "names": {
                "en": "Ans",
                "de": "Ans",
                "ru": "Анс"
            },
            "geotag": "2803160",
            "post_code": "4430"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Ansbach",
            "names": {
                "en": "Ansbach",
                "de": "Ansbach",
                "pl": "Ansbach",
                "ru": "Ансбах"
            },
            "geotag": "2955936",
            "post_code": "91522"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Antwerp",
            "names": {
                "de": "Antwerpen",
                "en": "Antwerp",
                "pl": "Antwerpia",
                "ru": "Антверпен"
            },
            "geotag": "2803138",
            "post_code": "2000"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Anzio",
            "names": {
                "en": "Anzio",
                "pl": "Anzio",
                "de": "Anzio",
                "ru": "Анцио"
            },
            "geotag": "3183005",
            "post_code": "00042"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Aosta",
            "names": {
                "de": "Aosta",
                "en": "Aosta",
                "pl": "Aosta",
                "ru": "Аоста"
            },
            "geotag": "3182997",
            "post_code": "11100"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Apeldoorn",
            "names": {
                "de": "Apeldoorn",
                "en": "Apeldoorn",
                "pl": "Apeldoorn",
                "ru": "Апелдорн"
            },
            "geotag": "2759706",
            "post_code": "7311"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Aprilia",
            "names": {
                "pl": "Aprilia",
                "de": "Aprilia",
                "en": "Aprilia",
                "ru": "Априлия"
            },
            "geotag": "3182957",
            "post_code": "04011"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Ardea",
            "names": {
                "pl": "Ardea",
                "de": "Ardea",
                "en": "Ardea",
                "ru": "Ардеа"
            },
            "geotag": "3182897",
            "post_code": "00040"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Arezzo",
            "names": {
                "ru": "Ареццо",
                "en": "Arezzo",
                "de": "Arezzo"
            },
            "geotag": "3182884",
            "post_code": "52100"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Arlon",
            "names": {
                "de": "Arel",
                "en": "Arlon",
                "pl": "Arlon",
                "ru": "Арлон"
            },
            "geotag": "2803073",
            "post_code": "6700"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Arnhem",
            "names": {
                "pl": "Arnhem",
                "de": "Arnhem",
                "en": "Arnhem",
                "ru": "Арнем"
            },
            "geotag": "2759661",
            "post_code": "6811"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Arnsberg",
            "names": {
                "de": "Arnsberg",
                "pl": "Arnsberg",
                "en": "Arnsberg",
                "ru": "Арнсберг"
            },
            "geotag": "2955471",
            "post_code": "59755"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Arnstadt",
            "names": {
                "de": "Arnstadt",
                "pl": "Arnstadt",
                "en": "Arnstadt",
                "ru": "Арнштадт"
            },
            "geotag": "2955439",
            "post_code": "99310"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Arzignano",
            "names": {
                "pl": "Arzignano",
                "en": "Arzignano",
                "ru": "Арциньяно"
            },
            "geotag": "3182757",
            "post_code": "36071"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Aschersleben",
            "names": {
                "de": "Aschersleben",
                "en": "Aschersleben",
                "ru": "Ашерслебен"
            },
            "geotag": "2955168",
            "post_code": "06449"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Ascoli Piceno",
            "names": {
                "pl": "Ascoli Piceno",
                "en": "Ascoli Piceno",
                "de": "Ascoli Piceno",
                "ru": "Асколи-Пичено"
            },
            "geotag": "3182749",
            "post_code": "63100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Assemini",
            "names": {
                "pl": "Assemini",
                "en": "Assemini",
                "ru": "Ассемини"
            },
            "geotag": "2525655",
            "post_code": "09032"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Assen",
            "names": {
                "de": "Assen",
                "en": "Assen",
                "pl": "Assen",
                "ru": "Ассен"
            },
            "geotag": "2759633",
            "post_code": "9401"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Asti",
            "names": {
                "en": "Asti",
                "de": "Asti",
                "pl": "Asti",
                "ru": "Асти"
            },
            "geotag": "3182714",
            "post_code": "14100"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Ath",
            "names": {
                "en": "Ath",
                "de": "Ath",
                "ru": "Ат"
            },
            "geotag": "2803010",
            "post_code": "7800"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Auderghem",
            "names": {
                "de": "Auderghem/Oudergem",
                "en": "Auderghem",
                "ru": "Одергем"
            },
            "geotag": "2802960",
            "post_code": "1160"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Augsburg",
            "names": {
                "de": "Augsburg",
                "en": "Augsburg",
                "pl": "Augsburg",
                "ru": "Аугсбург"
            },
            "geotag": "2954172",
            "post_code": "86150"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Augustów",
            "names": {
                "en": "Augustów",
                "ru": "Августов",
                "pl": "Augustów",
                "de": "Augustów"
            },
            "geotag": "776597",
            "post_code": "59-430"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Avellino",
            "names": {
                "de": "Avellino",
                "en": "Avellino",
                "pl": "Avellino",
                "ru": "Авеллино"
            },
            "geotag": "3182650",
            "post_code": "83100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Aversa",
            "names": {
                "pl": "Aversa",
                "en": "Aversa",
                "de": "Aversa",
                "ru": "Аверса"
            },
            "geotag": "3182640",
            "post_code": "81031"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Avezzano",
            "names": {
                "pl": "Avezzano",
                "en": "Avezzano",
                "de": "Avezzano",
                "ru": "Авеццано"
            },
            "geotag": "3182636",
            "post_code": "67051"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Baarn",
            "names": {
                "de": "Baarn",
                "en": "Baarn",
                "ru": "Барн"
            },
            "geotag": "2759544",
            "post_code": "3741"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bad Homburg",
            "names": {
                "de": "Bad Homburg vor der Höhe",
                "pl": "Bad Homburg vor der Höhe",
                "en": "Bad Homburg",
                "ru": "Бад-Хомбург"
            },
            "geotag": "2953436",
            "post_code": "61348"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bad Kissingen",
            "names": {
                "de": "Bad Kissingen",
                "pl": "Bad Kissingen",
                "en": "Bad Kissingen",
                "ru": "Бад-Киссинген"
            },
            "geotag": "2953424",
            "post_code": "97688"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Badalona",
            "names": {
                "en": "Badalona",
                "de": "Badalona",
                "pl": "Badalona",
                "ru": "Бадалона"
            },
            "geotag": "3129028",
            "post_code": "08910"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Baden bei Wien",
            "names": {
                "en": "Baden bei Wien",
                "de": "Baden",
                "ru": "Баден",
                "pl": "Baden bei Wien"
            },
            "geotag": "2782067",
            "post_code": "2500"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Baden-Baden",
            "names": {
                "de": "Baden-Baden",
                "en": "Baden-Baden",
                "pl": "Baden-Baden",
                "ru": "Баден-Баден"
            },
            "geotag": "2953504",
            "post_code": "76530"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Bagheria",
            "names": {
                "en": "Bagheria",
                "pl": "Bagheria",
                "de": "Bagheria",
                "ru": "Багерия"
            },
            "geotag": "2525628",
            "post_code": "90011"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Baja",
            "names": {
                "pl": "Baja",
                "de": "Baja",
                "en": "Baja",
                "ru": "Байя"
            },
            "geotag": "3055685",
            "post_code": "6500"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bamberg",
            "names": {
                "en": "Bamberg",
                "de": "Bamberg",
                "pl": "Bamberg",
                "ru": "Бамберг"
            },
            "geotag": "2952984",
            "post_code": "5143"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Barbastro",
            "names": {
                "de": "Barbastro",
                "en": "Barbastro",
                "ru": "Барбастро"
            },
            "geotag": "3128795",
            "post_code": "22300"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Barcelona",
            "names": {
                "de": "Barcelona",
                "en": "Barcelona",
                "pl": "Barcelona",
                "ru": "Барселона"
            },
            "geotag": "3128760",
            "post_code": "08001"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Bari",
            "names": {
                "en": "Bari",
                "pl": "Bari",
                "de": "Bari",
                "ru": "Бари"
            },
            "geotag": "3182351",
            "post_code": "70100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Barletta",
            "names": {
                "pl": "Barletta",
                "de": "Barletta",
                "en": "Barletta",
                "ru": "Барлетта"
            },
            "geotag": "3182340",
            "post_code": "76121"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Bartoszyce",
            "names": {
                "de": "Bartoszyce",
                "en": "Bartoszyce",
                "pl": "Bartoszyce",
                "ru": "Бартошице"
            },
            "geotag": "776337",
            "post_code": "11-200"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Bautzen",
            "names": {
                "de": "Bautzen",
                "pl": "Budziszyn",
                "en": "Bautzen",
                "ru": "Баутцен"
            },
            "geotag": "2951881",
            "post_code": "02625"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bayreuth",
            "names": {
                "de": "Bayreuth",
                "en": "Bayreuth",
                "pl": "Bayreuth",
                "ru": "Байройт"
            },
            "geotag": "2951825",
            "post_code": "95444"
        },
        {
            "code": 7,
            "country_code": "SK",
            "label": "Belek",
            "names": {
                "ru": "Белек",
                "en": "Belek",
                "de": "Belek"
            },
            "geotag": "321580",
            "post_code": "07506"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Belluno",
            "names": {
                "pl": "Belluno",
                "de": "Belluno",
                "en": "Belluno",
                "ru": "Беллуно"
            },
            "geotag": "3182210",
            "post_code": "32100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Benevento",
            "names": {
                "en": "Benevento",
                "de": "Benevent",
                "pl": "Benewent",
                "ru": "Беневенто"
            },
            "geotag": "3182179",
            "post_code": "82100"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Benešov",
            "names": {
                "de": "Benešov",
                "pl": "Benešov",
                "en": "Benešov",
                "ru": "Бенешов"
            },
            "geotag": "3079508",
            "post_code": "679 53"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bensheim",
            "names": {
                "de": "Bensheim",
                "en": "Bensheim",
                "pl": "Bensheim",
                "ru": "Бенсхайм"
            },
            "geotag": "2950978",
            "post_code": "64625"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Bergamo",
            "names": {
                "de": "Bergamo",
                "en": "Bergamo",
                "pl": "Bergamo",
                "ru": "Бергамо"
            },
            "geotag": "3182164",
            "post_code": "24100"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Bergen op Zoom",
            "names": {
                "en": "Bergen op Zoom",
                "de": "Bergen op Zoom",
                "pl": "Bergen op Zoom",
                "ru": "Берген-оп-Зом"
            },
            "geotag": "2759145",
            "post_code": "4611"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bergisch Gladbach",
            "names": {
                "de": "Bergisch Gladbach",
                "en": "Bergisch Gladbach",
                "pl": "Bergisch Gladbach",
                "ru": "Бергиш Гладбах"
            },
            "geotag": "2950349",
            "post_code": "51427"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Beringen",
            "names": {
                "en": "Beringen",
                "de": "Beringen",
                "ru": "Берингене"
            },
            "geotag": "2802170",
            "post_code": "3580"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Berlin",
            "names": {
                "de": "Berlin",
                "en": "Berlin",
                "pl": "Berlin",
                "ru": "Берлин"
            },
            "geotag": "2950159",
            "post_code": "10115"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Bernburg",
            "names": {
                "de": "Bernburg",
                "pl": "Bernburg",
                "en": "Bernburg",
                "ru": "Бернбург"
            },
            "geotag": "2950073",
            "post_code": "06406"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Beveren",
            "names": {
                "en": "Beveren",
                "pl": "Beveren",
                "de": "Beveren",
                "ru": "Беверен"
            },
            "geotag": "2802031",
            "post_code": "8791"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Beverwijk",
            "names": {
                "de": "Beverwijk",
                "en": "Beverwijk",
                "ru": "Бевервейк"
            },
            "geotag": "2758998",
            "post_code": "1941"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Bełchatów",
            "names": {
                "pl": "Bełchatów",
                "de": "Bełchatów",
                "en": "Bełchatów",
                "ru": "Белхатув"
            },
            "geotag": "3103709",
            "post_code": "97-400"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Bialystok",
            "names": {
                "de": "Białystok",
                "pl": "Białystok",
                "en": "Bialystok",
                "ru": "Белосток"
            },
            "geotag": "776069",
            "post_code": "22-540"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Biała Podlaska",
            "names": {
                "en": "Biała Podlaska",
                "ru": "Бяла-Подляска",
                "pl": "Biała Podlaska",
                "de": "Biała Podlaska"
            },
            "geotag": "776175",
            "post_code": "21-500"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Białogard",
            "names": {
                "pl": "Białogard",
                "en": "Białogard",
                "de": "Białogard",
                "ru": "Бялогард"
            },
            "geotag": "3103556",
            "post_code": "78-200"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Biberach an der Riss",
            "names": {
                "de": "Biberach an der Riß",
                "en": "Biberach an der Riss",
                "ru": "Биберах-на-Рисе"
            },
            "geotag": "2949423",
            "post_code": "88400"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Bielefeld",
            "names": {
                "de": "Bielefeld",
                "en": "Bielefeld",
                "pl": "Bielefeld",
                "ru": "Билефельд"
            },
            "geotag": "2949186",
            "post_code": "33519"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Biella",
            "names": {
                "pl": "Biella",
                "de": "Biella",
                "en": "Biella",
                "ru": "Бьелла"
            },
            "geotag": "3182043",
            "post_code": "13900"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Bilzen",
            "names": {
                "en": "Bilzen",
                "de": "Bilzen",
                "ru": "Билзен"
            },
            "geotag": "2801924",
            "post_code": "3740"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Binche",
            "names": {
                "en": "Binche",
                "de": "Binche",
                "pl": "Binche",
                "ru": "Бенш"
            },
            "geotag": "2801922",
            "post_code": "7130"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bingen am Rhein",
            "names": {
                "de": "Bingen am Rhein",
                "en": "Bingen am Rhein",
                "ru": "Бинген-на-Рейне"
            },
            "geotag": "2948825",
            "post_code": "55411"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Bisceglie",
            "names": {
                "pl": "Bisceglie",
                "en": "Bisceglie",
                "ru": "Бишеллье"
            },
            "geotag": "3182007",
            "post_code": "76011"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Biłgoraj",
            "names": {
                "pl": "Biłgoraj",
                "de": "Biłgoraj",
                "en": "Biłgoraj",
                "ru": "Билгорай"
            },
            "geotag": "775922",
            "post_code": "23-400"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Blanes",
            "names": {
                "de": "Blanes",
                "en": "Blanes",
                "pl": "Blanes",
                "ru": "Бланес"
            },
            "geotag": "3127978",
            "post_code": "17300"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Blankenberge",
            "names": {
                "de": "Blankenberge",
                "en": "Blankenberge",
                "pl": "Blankenberge",
                "ru": "Бланкенберге"
            },
            "geotag": "2801858",
            "post_code": "8370"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Blansko",
            "names": {
                "pl": "Blansko",
                "de": "Blansko",
                "en": "Blansko",
                "ru": "Бланско"
            },
            "geotag": "3079273",
            "post_code": "678 01"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Bochnia",
            "names": {
                "pl": "Bochnia",
                "de": "Bochnia",
                "en": "Bochnia",
                "ru": "Бохня"
            },
            "geotag": "775758",
            "post_code": "32-700"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bocholt",
            "names": {
                "de": "Bocholt",
                "pl": "Bocholt",
                "en": "Bocholt",
                "ru": "Бохольт"
            },
            "geotag": "2947421",
            "post_code": "3950"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bochum",
            "names": {
                "de": "Bochum",
                "en": "Bochum",
                "pl": "Bochum",
                "ru": "Бохум"
            },
            "geotag": "2947416",
            "post_code": "44787"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Bogatynia",
            "names": {
                "de": "Bogatynia",
                "pl": "Bogatynia",
                "en": "Bogatynia",
                "ru": "Богатыня"
            },
            "geotag": "3103096",
            "post_code": "59-916"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Boguszów-Gorce",
            "names": {
                "de": "Boguszów-Gorce",
                "pl": "Boguszów-Gorce",
                "en": "Boguszów-Gorce",
                "ru": "Богушув-Горце"
            },
            "geotag": "3103034",
            "post_code": "58-370"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Bolesławiec",
            "names": {
                "de": "Bunzlau",
                "pl": "Bolesławiec",
                "en": "Bolesławiec",
                "ru": "Болеславец"
            },
            "geotag": "3102987",
            "post_code": "59-700"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Bologna",
            "names": {
                "de": "Bologna",
                "en": "Bologna",
                "pl": "Bolonia",
                "ru": "Болонья"
            },
            "geotag": "3181928",
            "post_code": "11391"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Bolzano",
            "names": {
                "de": "Bozen",
                "pl": "Bolzano",
                "en": "Bolzano",
                "ru": "Больцано"
            },
            "geotag": "3181913",
            "post_code": "39100"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Bor",
            "names": {
                "de": "Bor",
                "en": "Bor",
                "pl": "Bor",
                "ru": "Бор"
            },
            "geotag": "792456",
            "post_code": "382 32"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Borne",
            "names": {
                "de": "Borne",
                "en": "Borne",
                "ru": "Борне"
            },
            "geotag": "2758598",
            "post_code": "39435"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Borssele",
            "names": {
                "en": "Borssele",
                "de": "Borssele",
                "ru": "Борссель"
            },
            "geotag": "2758587",
            "post_code": "4454"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Boscoreale",
            "names": {
                "pl": "Boscoreale",
                "de": "Boscoreale",
                "en": "Boscoreale",
                "ru": "Боскореале"
            },
            "geotag": "3181683",
            "post_code": "80041"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bottrop",
            "names": {
                "de": "Bottrop",
                "en": "Bottrop",
                "pl": "Bottrop",
                "ru": "Ботроп"
            },
            "geotag": "2945756",
            "post_code": "46236"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Boxtel",
            "names": {
                "en": "Boxtel",
                "de": "Boxtel",
                "ru": "Бокстел"
            },
            "geotag": "2758460",
            "post_code": "5281"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Braniewo",
            "names": {
                "de": "Braunsberg/Ermland",
                "en": "Braniewo",
                "pl": "Braniewo",
                "ru": "Бранево"
            },
            "geotag": "3102677",
            "post_code": "14-500"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Breda",
            "names": {
                "de": "Breda",
                "en": "Breda",
                "pl": "Breda",
                "ru": "Бреда"
            },
            "geotag": "2758401",
            "post_code": "17400"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Bregenz",
            "names": {
                "de": "Bregenz",
                "en": "Bregenz",
                "pl": "Bregencja",
                "ru": "Брегенц"
            },
            "geotag": "2781503",
            "post_code": "6900"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Bremen",
            "names": {
                "de": "Bremen",
                "en": "Bremen",
                "pl": "Brema",
                "ru": "Бремен"
            },
            "geotag": "2944388",
            "post_code": "28195"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Bremerhaven",
            "names": {
                "de": "Kreisfreie Stadt Bremerhaven",
                "en": "Bremerhaven",
                "pl": "Bremerhaven",
                "ru": "Бремерхафен"
            },
            "geotag": "2944368",
            "post_code": "27568"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Brescia",
            "names": {
                "de": "Brescia",
                "pl": "Brescia",
                "en": "Brescia",
                "ru": "Брешиа"
            },
            "geotag": "3181554",
            "post_code": "25100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Bresso",
            "names": {
                "pl": "Bresso",
                "en": "Bresso",
                "ru": "Брессо"
            },
            "geotag": "3181548",
            "post_code": "20091"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Brindisi",
            "names": {
                "de": "Brindisi",
                "en": "Brindisi",
                "pl": "Brindisi",
                "ru": "Бриндизи"
            },
            "geotag": "3181528",
            "post_code": "72100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Brixen",
            "names": {
                "de": "Brixen in Südtirol",
                "pl": "Bressanone",
                "en": "Brixen",
                "ru": "Брессаноне"
            },
            "geotag": "3181550",
            "post_code": "39042"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Brodnica",
            "names": {
                "en": "Brodnica",
                "pl": "Brodnica",
                "de": "Brodnica",
                "ru": "Бродница"
            },
            "geotag": "3102627",
            "post_code": "87-300"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Bronte",
            "names": {
                "en": "Bronte",
                "pl": "Bronte",
                "de": "Bronte",
                "ru": "Бронте"
            },
            "geotag": "2525498",
            "post_code": "95034"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Bruchsal",
            "names": {
                "de": "Bruchsal",
                "en": "Bruchsal",
                "ru": "Брухзаль"
            },
            "geotag": "2943560",
            "post_code": "76646"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Bruges",
            "names": {
                "de": "Brügge",
                "en": "Bruges",
                "pl": "Brugia",
                "ru": "Брюгге"
            },
            "geotag": "2800931",
            "post_code": "24582"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Brugherio",
            "names": {
                "pl": "Brugherio",
                "en": "Brugherio",
                "ru": "Бругерио"
            },
            "geotag": "3181495",
            "post_code": "20861"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Brunssum",
            "names": {
                "en": "Brunssum",
                "de": "Brunssum",
                "ru": "Брюнссуме"
            },
            "geotag": "2758174",
            "post_code": "6441"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Brunswick",
            "names": {
                "de": "Braunschweig",
                "en": "Brunswick",
                "pl": "Brunszwik",
                "ru": "Брауншвейг"
            },
            "geotag": "2945024",
            "post_code": "38023"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Brzeg",
            "names": {
                "de": "Brieg",
                "pl": "Brzeg",
                "en": "Brzeg",
                "ru": "Бжег"
            },
            "geotag": "3102459",
            "post_code": "99-235"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Budapest",
            "names": {
                "de": "Budapest",
                "en": "Budapest",
                "pl": "Budapeszt",
                "ru": "Будапешт"
            },
            "geotag": "3054643",
            "post_code": "1007"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Burgdorf, Hanover",
            "names": {
                "ru": "Бургдорф (Ганновер)",
                "de": "Burgdorf",
                "en": "Burgdorf, Hanover"
            },
            "geotag": "2941405",
            "post_code": "31303"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Burgos",
            "names": {
                "de": "Burgos",
                "en": "Burgos",
                "pl": "Burgos",
                "ru": "Бургос"
            },
            "geotag": "3127461",
            "post_code": "09001"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Busko-Zdrój",
            "names": {
                "pl": "Busko-Zdrój",
                "de": "Busko-Zdrój",
                "en": "Busko-Zdrój",
                "ru": "Буско-Здруй"
            },
            "geotag": "774747",
            "post_code": "28-100"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Bussum",
            "names": {
                "en": "Bussum",
                "de": "Bussum",
                "ru": "Бюссюм"
            },
            "geotag": "2758064",
            "post_code": "1401"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Bydgoszcz",
            "names": {
                "pl": "Bydgoszcz",
                "de": "Bydgoszcz",
                "en": "Bydgoszcz",
                "ru": "Быдгощ"
            },
            "geotag": "3102014",
            "post_code": "85-000"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Bytom",
            "names": {
                "de": "Bytom",
                "pl": "Bytom",
                "en": "Bytom",
                "ru": "Бытом"
            },
            "geotag": "3101950",
            "post_code": "41-900"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Bytów",
            "names": {
                "pl": "Bytów",
                "en": "Bytów",
                "de": "Bytów",
                "ru": "Бытув"
            },
            "geotag": "3101943",
            "post_code": "77-100"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Békés",
            "names": {
                "pl": "Békés",
                "en": "Békés",
                "de": "Bekesch",
                "ru": "Бекеш"
            },
            "geotag": "722439",
            "post_code": "5630"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Békéscsaba",
            "names": {
                "de": "Tschabe",
                "en": "Békéscsaba",
                "pl": "Békéscsaba",
                "ru": "Бекешчаба"
            },
            "geotag": "722437",
            "post_code": "5600"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Böblingen",
            "names": {
                "de": "Böblingen",
                "en": "Böblingen",
                "ru": "Бёблинген"
            },
            "geotag": "2947444",
            "post_code": "71032"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Będzin",
            "names": {
                "pl": "Będzin",
                "de": "Będzin",
                "en": "Będzin",
                "ru": "Бендзин"
            },
            "geotag": "3103719",
            "post_code": "56-416"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Břeclav",
            "names": {
                "de": "Břeclav",
                "pl": "Brzecław",
                "en": "Břeclav",
                "ru": "Бржецлав"
            },
            "geotag": "3078773",
            "post_code": "690 02"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Cagliari",
            "names": {
                "en": "Cagliari",
                "de": "Cagliari",
                "pl": "Cagliari",
                "ru": "Кальяри"
            },
            "geotag": "2525473",
            "post_code": "09100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Caivano",
            "names": {
                "pl": "Caivano",
                "de": "Caivano",
                "en": "Caivano",
                "ru": "Кайвано"
            },
            "geotag": "3181258",
            "post_code": "80023"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Calatayud",
            "names": {
                "de": "Calatayud",
                "en": "Calatayud",
                "ru": "Калатаюд"
            },
            "geotag": "3127047",
            "post_code": "50300"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Caltagirone",
            "names": {
                "pl": "Caltagirone",
                "de": "Caltagirone",
                "en": "Caltagirone",
                "ru": "Кальтаджироне"
            },
            "geotag": "2525450",
            "post_code": "95041"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Caltanissetta",
            "names": {
                "pl": "Caltanissetta",
                "de": "Caltanissetta",
                "en": "Caltanissetta",
                "ru": "Кальтаниссетта"
            },
            "geotag": "2525448",
            "post_code": "93100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Calw",
            "names": {
                "de": "Calw",
                "en": "Calw",
                "ru": "Кальв"
            },
            "geotag": "2940383",
            "post_code": "75365"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Camaiore",
            "names": {
                "pl": "Camaiore",
                "de": "Camaiore",
                "en": "Camaiore",
                "ru": "Камайоре"
            },
            "geotag": "3181125",
            "post_code": "55041"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Cambrils",
            "names": {
                "en": "Cambrils",
                "de": "Cambrils",
                "ru": "Камбрильс"
            },
            "geotag": "3126888",
            "post_code": "43850"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Campobasso",
            "names": {
                "de": "Campobasso",
                "en": "Campobasso",
                "pl": "Campobasso",
                "ru": "Кампобассо"
            },
            "geotag": "3180991",
            "post_code": "86100"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Capannori",
            "names": {
                "pl": "Capannori",
                "de": "Capannori",
                "en": "Capannori",
                "ru": "Капаннори"
            },
            "geotag": "3180733",
            "post_code": "55012"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Capelle aan den IJssel",
            "names": {
                "en": "Capelle aan den IJssel",
                "de": "Capelle aan den IJssel",
                "ru": "Капелле-ан-ден-Эйссел"
            },
            "geotag": "2758012",
            "post_code": "2901"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Carbonia",
            "names": {
                "pl": "Carbonia",
                "en": "Carbonia",
                "ru": "Карбония"
            },
            "geotag": "2525362",
            "post_code": "09013"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Carini",
            "names": {
                "pl": "Carini",
                "de": "Carini",
                "en": "Carini",
                "ru": "Карина"
            },
            "geotag": "2525350",
            "post_code": "90044"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Carmagnola",
            "names": {
                "pl": "Carmagnola",
                "de": "Carmagnola",
                "en": "Carmagnola",
                "ru": "Карманьола"
            },
            "geotag": "3180496",
            "post_code": "10022"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Carrara",
            "names": {
                "pl": "Carrara",
                "de": "Carrara",
                "en": "Carrara",
                "ru": "Каррара"
            },
            "geotag": "3180423",
            "post_code": "04013"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Caserta",
            "names": {
                "de": "Caserta",
                "en": "Caserta",
                "pl": "Caserta",
                "ru": "Казерта"
            },
            "geotag": "3179866",
            "post_code": "81100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Cassino",
            "names": {
                "pl": "Cassino",
                "en": "Cassino",
                "ru": "Кассино"
            },
            "geotag": "3179781",
            "post_code": "03043"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Castelvetrano",
            "names": {
                "pl": "Castelvetrano",
                "de": "Castelvetrano",
                "en": "Castelvetrano",
                "ru": "Кастельветрано"
            },
            "geotag": "2525083",
            "post_code": "91022"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Castricum",
            "names": {
                "en": "Castricum",
                "de": "Castricum",
                "ru": "Кастрикюм"
            },
            "geotag": "2757991",
            "post_code": "1901"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Castrovillari",
            "names": {
                "pl": "Castrovillari",
                "de": "Castrovillari",
                "en": "Castrovillari",
                "ru": "Кастровиллари"
            },
            "geotag": "2525070",
            "post_code": "87012"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Catania",
            "names": {
                "de": "Catania",
                "en": "Catania",
                "pl": "Katania",
                "ru": "Катания"
            },
            "geotag": "2525068",
            "post_code": "95100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Catanzaro",
            "names": {
                "de": "Catanzaro",
                "en": "Catanzaro",
                "pl": "Catanzaro",
                "ru": "Катандзаро"
            },
            "geotag": "2525059",
            "post_code": "88100"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Cecina",
            "names": {
                "pl": "Cecina",
                "de": "Cecina",
                "en": "Cecina",
                "ru": "Чечина"
            },
            "geotag": "3179235",
            "post_code": "57023"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Celle",
            "names": {
                "de": "Celle",
                "en": "Celle",
                "pl": "Celle",
                "ru": "Целле"
            },
            "geotag": "2940213",
            "post_code": "29221"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Cento",
            "names": {
                "pl": "Cento",
                "de": "Cento",
                "en": "Cento",
                "ru": "Ченто"
            },
            "geotag": "3179162",
            "post_code": "44042"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Cerveteri",
            "names": {
                "pl": "Cerveteri",
                "en": "Cerveteri",
                "ru": "Черветери"
            },
            "geotag": "3178999",
            "post_code": "00052"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Cervia",
            "names": {
                "pl": "Cervia",
                "de": "Cervia",
                "en": "Cervia",
                "ru": "Червиа"
            },
            "geotag": "3178998",
            "post_code": "48015"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Cesenatico",
            "names": {
                "pl": "Cesenatico",
                "de": "Cesenatico",
                "en": "Cesenatico",
                "ru": "Чезенатико"
            },
            "geotag": "3178956",
            "post_code": "47042"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Charleroi",
            "names": {
                "de": "Charleroi",
                "en": "Charleroi",
                "pl": "Charleroi",
                "ru": "Шарлеруа"
            },
            "geotag": "2800481",
            "post_code": "6000"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Cheb",
            "names": {
                "de": "Eger",
                "en": "Cheb",
                "pl": "Cheb",
                "ru": "Хеб"
            },
            "geotag": "3077835",
            "post_code": "350 02"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Chemnitz",
            "names": {
                "de": "Chemnitz",
                "en": "Chemnitz",
                "pl": "Chemnitz",
                "ru": "Хемниц"
            },
            "geotag": "2940132",
            "post_code": "09111"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Chełm",
            "names": {
                "pl": "Chełm",
                "de": "Chełm",
                "en": "Chełm",
                "ru": "Хелм"
            },
            "geotag": "774558",
            "post_code": "50-305"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Chełmno",
            "names": {
                "en": "Chełmno",
                "pl": "Chełmno",
                "de": "Chełmno",
                "ru": "Хелмно"
            },
            "geotag": "3101795",
            "post_code": "86-200"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Chełmża",
            "names": {
                "en": "Chełmża",
                "pl": "Chełmża",
                "de": "Chełmża",
                "ru": "Хелмжа"
            },
            "geotag": "3101787",
            "post_code": "87-140"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Chiavari",
            "names": {
                "pl": "Chiavari",
                "de": "Chiavari",
                "en": "Chiavari",
                "ru": "Киавари"
            },
            "geotag": "3178832",
            "post_code": "16043"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Chieti",
            "names": {
                "pl": "Chieti",
                "de": "Chieti",
                "en": "Chieti",
                "ru": "Кьети"
            },
            "geotag": "3178796",
            "post_code": "66100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Chivasso",
            "names": {
                "pl": "Chivasso",
                "de": "Chivasso",
                "en": "Chivasso",
                "ru": "Кивассо"
            },
            "geotag": "3178745",
            "post_code": "10034"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Chodzież",
            "names": {
                "pl": "Chodzież",
                "de": "Chodzież",
                "en": "Chodzież",
                "ru": "Ходзеж"
            },
            "geotag": "3101680",
            "post_code": "64-800"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Chojnice",
            "names": {
                "de": "Conitz",
                "pl": "Chojnice",
                "en": "Chojnice",
                "ru": "Хойнице"
            },
            "geotag": "3101672",
            "post_code": "89-600"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Chomutov",
            "names": {
                "de": "Chomutov",
                "en": "Chomutov",
                "pl": "Chomutov",
                "ru": "Хомутов"
            },
            "geotag": "3077685",
            "post_code": "430 01"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Chorzów",
            "names": {
                "pl": "Chorzów",
                "en": "Chorzów",
                "de": "Chorzów",
                "ru": "Хожув"
            },
            "geotag": "3101619",
            "post_code": "37-560"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Chrzanów",
            "names": {
                "pl": "Chrzanów",
                "de": "Chrzanów",
                "en": "Chrzanów",
                "ru": "Хшанув"
            },
            "geotag": "3101547",
            "post_code": "55-040"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Ciampino",
            "names": {
                "pl": "Ciampino",
                "de": "Ciampino",
                "en": "Ciampino",
                "ru": "Чампино"
            },
            "geotag": "3178738",
            "post_code": "00043"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Cieszyn",
            "names": {
                "pl": "Cieszyn",
                "de": "Teschen",
                "en": "Cieszyn",
                "ru": "Цешин"
            },
            "geotag": "3101321",
            "post_code": "22-425"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Civitanova Marche",
            "names": {
                "pl": "Civitanova Marche",
                "de": "Civitanova Marche",
                "en": "Civitanova Marche",
                "ru": "Чивитанова-Марке"
            },
            "geotag": "3170102",
            "post_code": "62012"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Civitavecchia",
            "names": {
                "pl": "Civitavecchia",
                "en": "Civitavecchia",
                "de": "Civitavecchia",
                "ru": "Чивитавеккья"
            },
            "geotag": "3178587",
            "post_code": "00053"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Colleferro",
            "names": {
                "pl": "Colleferro",
                "en": "Colleferro",
                "ru": "Коллеферро"
            },
            "geotag": "3178398",
            "post_code": "00034"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Collegno",
            "names": {
                "pl": "Collegno",
                "de": "Collegno",
                "en": "Collegno",
                "ru": "Колленьо"
            },
            "geotag": "3178388",
            "post_code": "10093"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Cologne",
            "names": {
                "de": "Köln",
                "en": "Cologne",
                "pl": "Kolonia",
                "ru": "Кёльн"
            },
            "geotag": "2886242",
            "post_code": "50667"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Comiso",
            "names": {
                "pl": "Comiso",
                "de": "Comiso",
                "en": "Comiso",
                "ru": "Комизо"
            },
            "geotag": "2524955",
            "post_code": "97013"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Como",
            "names": {
                "de": "Como",
                "en": "Como",
                "pl": "Como",
                "ru": "Комо"
            },
            "geotag": "3178229",
            "post_code": "22100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Conegliano",
            "names": {
                "pl": "Conegliano",
                "de": "Conegliano",
                "en": "Conegliano",
                "ru": "Конельяно"
            },
            "geotag": "3178197",
            "post_code": "31015"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Conversano",
            "names": {
                "pl": "Conversano",
                "en": "Conversano",
                "ru": "Конверсано"
            },
            "geotag": "3178147",
            "post_code": "70014"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Corato",
            "names": {
                "pl": "Corato",
                "en": "Corato",
                "ru": "Корато"
            },
            "geotag": "3178131",
            "post_code": "70033"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Correggio",
            "names": {
                "pl": "Correggio",
                "de": "Correggio",
                "en": "Correggio",
                "ru": "Корреджо"
            },
            "geotag": "3178019",
            "post_code": "42015"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Corsico",
            "names": {
                "pl": "Corsico",
                "en": "Corsico",
                "ru": "Корсико"
            },
            "geotag": "3178004",
            "post_code": "20094"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Cosenza",
            "names": {
                "de": "Cosenza",
                "en": "Cosenza",
                "pl": "Cosenza",
                "ru": "Козенца"
            },
            "geotag": "2524907",
            "post_code": "87100"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Cottbus",
            "names": {
                "de": "Cottbus",
                "en": "Cottbus",
                "pl": "Chociebuż",
                "ru": "Котбус"
            },
            "geotag": "2939811",
            "post_code": "03042"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Crema",
            "names": {
                "pl": "Crema",
                "de": "Crema",
                "en": "Crema",
                "ru": "Крема"
            },
            "geotag": "3177841",
            "post_code": "26013"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Cremona",
            "names": {
                "de": "Cremona",
                "en": "Cremona",
                "pl": "Cremona",
                "ru": "Кремона"
            },
            "geotag": "3177838",
            "post_code": "26100"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Cuxhaven",
            "names": {
                "de": "Cuxhaven",
                "pl": "Cuxhaven",
                "en": "Cuxhaven",
                "ru": "Куксхафен"
            },
            "geotag": "2939658",
            "post_code": "27472"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Częstochowa",
            "names": {
                "de": "Czenstochau",
                "pl": "Częstochowa",
                "en": "Częstochowa",
                "ru": "Ченстохова"
            },
            "geotag": "3100946",
            "post_code": "42-130"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Dachau",
            "names": {
                "pl": "Dachau",
                "ru": "Дахау",
                "en": "Dachau",
                "de": "Dachau"
            },
            "geotag": "2939623",
            "post_code": "85221"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Dalfsen",
            "names": {
                "de": "Dalfsen",
                "en": "Dalfsen",
                "ru": "Дальфсен"
            },
            "geotag": "2757850",
            "post_code": "7721"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Dalmine",
            "names": {
                "pl": "Dalmine",
                "en": "Dalmine",
                "ru": "Дальмине"
            },
            "geotag": "3177650",
            "post_code": "24044"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Darmstadt",
            "names": {
                "de": "Darmstadt",
                "en": "Darmstadt",
                "pl": "Darmstadt",
                "ru": "Дармштадт"
            },
            "geotag": "2938913",
            "post_code": "64283"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Debrecen",
            "names": {
                "pl": "Debreczyn",
                "en": "Debrecen",
                "de": "Debrecen",
                "ru": "Дебрецен"
            },
            "geotag": "721472",
            "post_code": "4000"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Deggendorf",
            "names": {
                "de": "Deggendorf",
                "pl": "Deggendorf",
                "en": "Deggendorf",
                "ru": "Деггендорф"
            },
            "geotag": "2938540",
            "post_code": "94469"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Delft",
            "names": {
                "de": "Delft",
                "en": "Delft",
                "pl": "Delft",
                "ru": "Делфт"
            },
            "geotag": "2757345",
            "post_code": "2611"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Delfzijl",
            "names": {
                "en": "Delfzijl",
                "de": "Delfzijl",
                "pl": "Delfzijl",
                "ru": "Делфзейл"
            },
            "geotag": "2757340",
            "post_code": "9931"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Delmenhorst",
            "names": {
                "de": "Delmenhorst",
                "pl": "Delmenhorst",
                "en": "Delmenhorst",
                "ru": "Дельменхорст"
            },
            "geotag": "2938323",
            "post_code": "27749"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Den Helder",
            "names": {
                "en": "Den Helder",
                "de": "Den Helder",
                "pl": "Den Helder",
                "ru": "Ден-Хелдер"
            },
            "geotag": "2757220",
            "post_code": "1781"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Dendermonde",
            "names": {
                "en": "Dendermonde",
                "pl": "Dendermonde",
                "de": "Dendermonde",
                "ru": "Дендермонде"
            },
            "geotag": "2799645",
            "post_code": "9200"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Denizli",
            "names": {
                "de": "Denizli",
                "en": "Denizli",
                "pl": "Denizli",
                "ru": "Денизли"
            },
            "geotag": "317109",
            "post_code": "19300"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Desio",
            "names": {
                "pl": "Desio",
                "de": "Desio",
                "en": "Desio",
                "ru": "Дезио"
            },
            "geotag": "3177608",
            "post_code": "20832"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Dessau",
            "names": {
                "en": "Dessau",
                "de": "Dessau",
                "pl": "Dessau",
                "ru": "Дессау"
            },
            "geotag": "2937959",
            "post_code": "06842"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Detmold",
            "names": {
                "de": "Detmold",
                "pl": "Detmold",
                "en": "Detmold",
                "ru": "Детмольд"
            },
            "geotag": "2937936",
            "post_code": "32756"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Deventer",
            "names": {
                "en": "Deventer",
                "de": "Deventer",
                "pl": "Deventer",
                "ru": "Девентер"
            },
            "geotag": "2756987",
            "post_code": "7411"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Diemen",
            "names": {
                "en": "Diemen",
                "de": "Diemen",
                "ru": "Димен"
            },
            "geotag": "2756888",
            "post_code": "1111"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Dilbeek",
            "names": {
                "en": "Dilbeek",
                "pl": "Dilbeek",
                "de": "Dilbeek",
                "ru": "Дилбек"
            },
            "geotag": "2799365",
            "post_code": "1700"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Dinslaken",
            "names": {
                "en": "Dinslaken",
                "de": "Dinslaken",
                "ru": "Динслакен"
            },
            "geotag": "2936871",
            "post_code": "46535"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Doetinchem",
            "names": {
                "de": "Doetinchem",
                "en": "Doetinchem",
                "ru": "Дутинхем"
            },
            "geotag": "2756767",
            "post_code": "7001"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Donaueschingen",
            "names": {
                "de": "Donaueschingen",
                "pl": "Donaueschingen",
                "en": "Donaueschingen",
                "ru": "Донауэшинген"
            },
            "geotag": "2936267",
            "post_code": "78166"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Donauwörth",
            "names": {
                "de": "Donauwoerth",
                "pl": "Donauwörth",
                "en": "Donauwörth",
                "ru": "Донаувёрт"
            },
            "geotag": "2936253",
            "post_code": "86609"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Dongen",
            "names": {
                "en": "Dongen",
                "de": "Dongen",
                "ru": "Донген"
            },
            "geotag": "2756723",
            "post_code": "5101"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Dormagen",
            "names": {
                "de": "Dormagen",
                "pl": "Dormagen",
                "en": "Dormagen",
                "ru": "Дормаген"
            },
            "geotag": "2935825",
            "post_code": "41539"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Dornbirn",
            "names": {
                "de": "Dornbirn",
                "en": "Dornbirn",
                "ru": "Дорнбирн"
            },
            "geotag": "2780741",
            "post_code": "6850"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Dorsten",
            "names": {
                "de": "Dorsten",
                "en": "Dorsten",
                "pl": "Dorsten",
                "ru": "Дорстен"
            },
            "geotag": "2935530",
            "post_code": "46282"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Dortmund",
            "names": {
                "de": "Dortmund",
                "en": "Dortmund",
                "pl": "Dortmund",
                "ru": "Дортмунд"
            },
            "geotag": "2935517",
            "post_code": "44135"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Dresden",
            "names": {
                "de": "Dresden",
                "en": "Dresden",
                "pl": "Drezno",
                "ru": "Дрезден"
            },
            "geotag": "2935022",
            "post_code": "01067"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Dronten",
            "names": {
                "en": "Dronten",
                "de": "Dronten",
                "ru": "Дронтен"
            },
            "geotag": "2756559",
            "post_code": "8251"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Duisburg",
            "names": {
                "de": "Duisburg",
                "en": "Duisburg",
                "pl": "Duisburg",
                "ru": "Дуйсбург"
            },
            "geotag": "2934691",
            "post_code": "3080"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Duna Pentele",
            "names": {
                "de": "Dunaújváros",
                "en": "Duna Pentele",
                "pl": "Dunaújváros",
                "ru": "Дунауйварош"
            },
            "geotag": "3053438",
            "post_code": "2400"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Düren",
            "names": {
                "de": "Düren",
                "en": "Düren",
                "ru": "Дюрен"
            },
            "geotag": "2934486",
            "post_code": "52349"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Düsseldorf",
            "names": {
                "de": "Düsseldorf",
                "en": "Düsseldorf",
                "pl": "Düsseldorf",
                "ru": "Дюссельдорф"
            },
            "geotag": "2934246",
            "post_code": "40210"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Dąbrowa Górnicza",
            "names": {
                "pl": "Dąbrowa Górnicza",
                "en": "Dąbrowa Górnicza",
                "de": "Dąbrowa Górnicza",
                "ru": "Домброва-Гурнича"
            },
            "geotag": "3100796",
            "post_code": "41-300"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Eberswalde",
            "names": {
                "de": "Eberswalde",
                "pl": "Eberswalde",
                "en": "Eberswalde",
                "ru": "Эберсвальде"
            },
            "geotag": "2933882",
            "post_code": "16225"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Eger",
            "names": {
                "de": "Eger",
                "pl": "Eger",
                "en": "Eger",
                "ru": "Эгер"
            },
            "geotag": "721239",
            "post_code": "3300"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Eindhoven",
            "names": {
                "de": "Eindhoven",
                "en": "Eindhoven",
                "pl": "Eindhoven",
                "ru": "Эйндховен"
            },
            "geotag": "2756253",
            "post_code": "5611"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Eisenach",
            "names": {
                "en": "Eisenach",
                "de": "Wartburgstadt",
                "pl": "Eisenach",
                "ru": "Айзенах"
            },
            "geotag": "2931574",
            "post_code": "54298"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Eisenhüttenstadt",
            "names": {
                "de": "Eisenhüttenstadt",
                "pl": "Eisenhüttenstadt",
                "en": "Eisenhüttenstadt",
                "ru": "Айзенхюттенштадт"
            },
            "geotag": "2931481",
            "post_code": "15890"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Elblag",
            "names": {
                "en": "Elblag",
                "ru": "Эльблонг",
                "de": "Elbing",
                "pl": "Elbląg"
            },
            "geotag": "3099759",
            "post_code": "82-300"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Emden",
            "names": {
                "de": "Emden",
                "en": "Emden",
                "pl": "Emden",
                "ru": "Эмден"
            },
            "geotag": "2930596",
            "post_code": "26721"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Enna",
            "names": {
                "pl": "Enna",
                "de": "Enna",
                "en": "Enna",
                "ru": "Энна"
            },
            "geotag": "2524819",
            "post_code": "94100"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Enschede",
            "names": {
                "de": "Enschede",
                "en": "Enschede",
                "pl": "Enschede",
                "ru": "Энсхеде"
            },
            "geotag": "2756071",
            "post_code": "7511"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Ercolano",
            "names": {
                "pl": "Ercolano",
                "de": "Ercolano",
                "en": "Ercolano",
                "ru": "Геркуланум"
            },
            "geotag": "3177363",
            "post_code": "80056"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Erfurt",
            "names": {
                "de": "Erfurt",
                "en": "Erfurt",
                "pl": "Erfurt",
                "ru": "Эрфурт"
            },
            "geotag": "2929670",
            "post_code": "99084"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Erkrath",
            "names": {
                "de": "Erkrath",
                "en": "Erkrath",
                "ru": "Эркрат"
            },
            "geotag": "2929600",
            "post_code": "40699"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Erlangen",
            "names": {
                "de": "Erlangen",
                "en": "Erlangen",
                "pl": "Erlangen",
                "ru": "Эрланген"
            },
            "geotag": "2929567",
            "post_code": "91052"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Eschwege",
            "names": {
                "de": "Eschwege",
                "pl": "Eschwege",
                "en": "Eschwege",
                "ru": "Эшвеге"
            },
            "geotag": "2928967",
            "post_code": "37269"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Eschweiler",
            "names": {
                "de": "Eschweiler",
                "pl": "Eschweiler",
                "en": "Eschweiler",
                "ru": "Эшвайлер"
            },
            "geotag": "2928963",
            "post_code": "52249"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Essen",
            "names": {
                "de": "Essen",
                "en": "Essen",
                "pl": "Essen",
                "ru": "Эссен"
            },
            "geotag": "2928810",
            "post_code": "2910"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Este",
            "names": {
                "pl": "Este",
                "de": "Este",
                "en": "Este",
                "ru": "Эсте"
            },
            "geotag": "3177337",
            "post_code": "35042"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Esztergom",
            "names": {
                "de": "Esztergom",
                "pl": "Ostrzyhom",
                "en": "Esztergom",
                "ru": "Эстергом"
            },
            "geotag": "3053163",
            "post_code": "2500"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Etterbeek",
            "names": {
                "en": "Etterbeek",
                "de": "Etterbeek",
                "ru": "Эттербек"
            },
            "geotag": "2798578",
            "post_code": "1040"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Eupen",
            "names": {
                "de": "Eupen",
                "en": "Eupen",
                "pl": "Eupen",
                "ru": "Эйпен"
            },
            "geotag": "2798573",
            "post_code": "4700"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Evere",
            "names": {
                "en": "Evere",
                "de": "Evere",
                "ru": "Эвере"
            },
            "geotag": "2798554",
            "post_code": "1140"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Ełk",
            "names": {
                "de": "Ełk",
                "pl": "Ełk",
                "en": "Ełk",
                "ru": "Элк"
            },
            "geotag": "772621",
            "post_code": "19-300"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Fabriano",
            "names": {
                "pl": "Fabriano",
                "en": "Fabriano",
                "de": "Fabriano",
                "ru": "Фабриано"
            },
            "geotag": "3177315",
            "post_code": "60044"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Fano",
            "names": {
                "pl": "Fano",
                "en": "Fano",
                "de": "Fano",
                "ru": "Фано"
            },
            "geotag": "3177219",
            "post_code": "61032"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Fasano",
            "names": {
                "pl": "Fasano",
                "de": "Fasano",
                "en": "Fasano",
                "ru": "Фазано"
            },
            "geotag": "3177171",
            "post_code": "72015"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Feldkirch",
            "names": {
                "de": "Feldkirch",
                "en": "Feldkirch",
                "ru": "Фельдкирх"
            },
            "geotag": "2779674",
            "post_code": "6800"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Fermo",
            "names": {
                "pl": "Fermo",
                "de": "Fermo",
                "en": "Fermo",
                "ru": "Фермо"
            },
            "geotag": "3177099",
            "post_code": "63900"
        },
        {
            "code": 17,
            "country_code": "TR",
            "label": "Fethiye",
            "names": {
                "ru": "Фетхие",
                "de": "Fethiye",
                "en": "Fethiye"
            },
            "geotag": "314967",
            "post_code": "16140"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Fidenza",
            "names": {
                "pl": "Fidenza",
                "de": "Fidenza",
                "en": "Fidenza",
                "ru": "Фиденцы"
            },
            "geotag": "3177029",
            "post_code": "43036"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Figueres",
            "names": {
                "en": "Figueres",
                "de": "Figueres",
                "pl": "Figueres",
                "ru": "Фигерас"
            },
            "geotag": "3122453",
            "post_code": "17600"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Fiumicino",
            "names": {
                "pl": "Fiumicino",
                "en": "Fiumicino",
                "de": "Fiumicino",
                "ru": "Фьюмичино"
            },
            "geotag": "3176923",
            "post_code": "00054"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Flensburg",
            "names": {
                "de": "Flensburg",
                "en": "Flensburg",
                "pl": "Flensburg",
                "ru": "Фленсбург"
            },
            "geotag": "2926271",
            "post_code": "24937"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Floridia",
            "names": {
                "pl": "Floridia",
                "de": "Floridia",
                "en": "Floridia",
                "ru": "Флоридии"
            },
            "geotag": "2524734",
            "post_code": "96014"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Flushing",
            "names": {
                "en": "Flushing",
                "de": "Vlissingen",
                "ru": "Флиссинген"
            },
            "geotag": "2745392",
            "post_code": "4381"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Foggia",
            "names": {
                "pl": "Foggia",
                "de": "Foggia",
                "en": "Foggia",
                "ru": "Фоджа"
            },
            "geotag": "3176885",
            "post_code": "71100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Foligno",
            "names": {
                "pl": "Foligno",
                "de": "Foligno",
                "en": "Foligno",
                "ru": "Фолиньо"
            },
            "geotag": "3176854",
            "post_code": "06034"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Follonica",
            "names": {
                "pl": "Follonica",
                "en": "Follonica",
                "ru": "Фоллоника"
            },
            "geotag": "3176849",
            "post_code": "58022"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Forchheim",
            "names": {
                "de": "Forchheim / Bayern",
                "pl": "Forchheim",
                "en": "Forchheim",
                "ru": "Форххайм"
            },
            "geotag": "2925910",
            "post_code": "79362"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Forlì",
            "names": {
                "de": "Forlì",
                "en": "Forlì",
                "pl": "Forlì",
                "ru": "Форли"
            },
            "geotag": "3176746",
            "post_code": "47121"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Frankenthal",
            "names": {
                "de": "Frankenthal",
                "en": "Frankenthal",
                "ru": "Франкенталь"
            },
            "geotag": "2925550",
            "post_code": "01909"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Frankfurt (Oder)",
            "names": {
                "de": "Frankfordt",
                "pl": "Frankfurt nad Odrą",
                "en": "Frankfurt (Oder)",
                "ru": "Франкфурт-на-Одере"
            },
            "geotag": "2925535",
            "post_code": "15230"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Frankfurt am Main",
            "names": {
                "en": "Frankfurt am Main",
                "de": "Frankfurt",
                "pl": "Frankfurt nad Menem",
                "ru": "Франкфурт"
            },
            "geotag": "2925533",
            "post_code": "60306"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Frattamaggiore",
            "names": {
                "pl": "Frattamaggiore",
                "en": "Frattamaggiore",
                "ru": "Фраттамаджоре"
            },
            "geotag": "3176561",
            "post_code": "80027"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Freiberg",
            "names": {
                "de": "Freiberg",
                "en": "Freiberg",
                "pl": "Freiberg",
                "ru": "Фрайберг"
            },
            "geotag": "2925192",
            "post_code": "8853"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Freising",
            "names": {
                "de": "Freising",
                "pl": "Fryzynga",
                "en": "Freising",
                "ru": "Фрайзинг"
            },
            "geotag": "2925034",
            "post_code": "85354"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Friedrichshafen",
            "names": {
                "de": "Friedrichshafen",
                "en": "Friedrichshafen",
                "pl": "Friedrichshafen",
                "ru": "Фридрихсхафен"
            },
            "geotag": "2924585",
            "post_code": "88045"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Frosinone",
            "names": {
                "pl": "Frosinone",
                "de": "Frosinone",
                "en": "Frosinone",
                "ru": "Фрозиноне"
            },
            "geotag": "3176515",
            "post_code": "03100"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Fulda",
            "names": {
                "de": "Fulda",
                "en": "Fulda",
                "pl": "Fulda",
                "ru": "Фульда"
            },
            "geotag": "2923822",
            "post_code": "36037"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Fürstenfeldbruck",
            "names": {
                "de": "Fürstenfeldbruck",
                "pl": "Fürstenfeldbruck",
                "en": "Fürstenfeldbruck",
                "ru": "Фюрстенфельдбрук"
            },
            "geotag": "2923625",
            "post_code": "82256"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Fürth",
            "names": {
                "de": "Fürth",
                "en": "Fürth",
                "pl": "Fürth",
                "ru": "Фюрт"
            },
            "geotag": "2923544",
            "post_code": "4707"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Füssen",
            "names": {
                "de": "Füssen",
                "pl": "Füssen",
                "en": "Füssen",
                "ru": "Фюссен"
            },
            "geotag": "2923507",
            "post_code": "87629"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Gaeta",
            "names": {
                "pl": "Gaeta",
                "de": "Gaeta",
                "en": "Gaeta",
                "ru": "Гаета"
            },
            "geotag": "3176438",
            "post_code": "04024"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Gallarate",
            "names": {
                "pl": "Gallarate",
                "en": "Gallarate",
                "ru": "Галларате"
            },
            "geotag": "3176391",
            "post_code": "21013"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Gallipoli",
            "names": {
                "en": "Gallipoli",
                "ru": "Гелиболу",
                "pl": "Gallipoli"
            },
            "geotag": "746983",
            "post_code": "73014"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Ganshoren",
            "names": {
                "en": "Ganshoren",
                "de": "Ganshoren",
                "ru": "Гансхорен"
            },
            "geotag": "2797844",
            "post_code": "1083"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Garbsen",
            "names": {
                "de": "Garbsen",
                "en": "Garbsen",
                "ru": "Гарбсен"
            },
            "geotag": "2922586",
            "post_code": "30823"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Garmisch-Partenkirchen",
            "names": {
                "pl": "Garmisch-Partenkirchen",
                "de": "Garmisch-Partenkirchen",
                "en": "Garmisch-Partenkirchen",
                "ru": "Гармиш-Партенкирхен"
            },
            "geotag": "2922530",
            "post_code": "82467"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Gdansk",
            "names": {
                "pl": "Gdańsk",
                "en": "Gdansk",
                "de": "Danzig",
                "ru": "Гданьск"
            },
            "geotag": "3099434",
            "post_code": "80-001"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Gdynia",
            "names": {
                "de": "Gdynia",
                "pl": "Gdynia",
                "en": "Gdynia",
                "ru": "Гдыня"
            },
            "geotag": "3099424",
            "post_code": "80-008"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Gebze",
            "names": {
                "de": "Gebze",
                "en": "Gebze",
                "pl": "Gebze",
                "ru": "Гебзе"
            },
            "geotag": "747014",
            "post_code": "41400"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Geel",
            "names": {
                "en": "Geel",
                "de": "Geel",
                "pl": "Geel",
                "ru": "Геел"
            },
            "geotag": "2797779",
            "post_code": "2440"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Geertruidenberg",
            "names": {
                "en": "Geertruidenberg",
                "de": "Geertruidenberg",
                "ru": "Гетруденберг"
            },
            "geotag": "2755669",
            "post_code": "4931"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Geldermalsen",
            "names": {
                "de": "Geldermalsen",
                "en": "Geldermalsen",
                "ru": "Гелдермалсен"
            },
            "geotag": "2755633",
            "post_code": "4191"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Gelsenkirchen",
            "names": {
                "de": "Gelsenkirchen",
                "en": "Gelsenkirchen",
                "pl": "Gelsenkirchen",
                "ru": "Гельзенкирхен"
            },
            "geotag": "2921466",
            "post_code": "45879"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Gembloux",
            "names": {
                "en": "Gembloux",
                "de": "Gembloux",
                "ru": "Жамблу"
            },
            "geotag": "2797713",
            "post_code": "5030"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Gemlik",
            "names": {
                "pl": "Gemlik",
                "de": "Gemlik",
                "en": "Gemlik",
                "ru": "Гемлик"
            },
            "geotag": "746958",
            "post_code": "16600"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Genk",
            "names": {
                "en": "Genk",
                "pl": "Genk",
                "de": "Genk",
                "ru": "Генк"
            },
            "geotag": "2797670",
            "post_code": "3600"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Gera",
            "names": {
                "de": "Gera",
                "en": "Gera",
                "pl": "Gera",
                "ru": "Гера"
            },
            "geotag": "2921232",
            "post_code": "07545"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Ghedi",
            "names": {
                "pl": "Ghedi",
                "en": "Ghedi",
                "ru": "Геди",
                "de": "Ghedi"
            },
            "geotag": "3176177",
            "post_code": "25016"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Ghent",
            "names": {
                "de": "Gent",
                "en": "Ghent",
                "pl": "Gandawa",
                "ru": "Гент"
            },
            "geotag": "2797656",
            "post_code": "9000"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Giarre",
            "names": {
                "pl": "Giarre",
                "de": "Giarre",
                "en": "Giarre",
                "ru": "Джарре"
            },
            "geotag": "2524618",
            "post_code": "95014"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Giessen",
            "names": {
                "de": "Gießen",
                "pl": "Gießen",
                "en": "Giessen",
                "ru": "Гисен"
            },
            "geotag": "2920512",
            "post_code": "35390"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Giovinazzo",
            "names": {
                "pl": "Giovinazzo",
                "de": "Giovinazzo",
                "en": "Giovinazzo",
                "ru": "Джовинаццо"
            },
            "geotag": "3176072",
            "post_code": "70054"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Girona",
            "names": {
                "en": "Girona",
                "de": "Girona",
                "pl": "Girona",
                "ru": "Херона"
            },
            "geotag": "3121456",
            "post_code": "17001"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Giżycko",
            "names": {
                "en": "Giżycko",
                "pl": "Giżycko",
                "ru": "Гижицко",
                "de": "Lötzen"
            },
            "geotag": "772195",
            "post_code": "11-500"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Gladbeck",
            "names": {
                "de": "Gladbeck",
                "en": "Gladbeck",
                "pl": "Gladbeck",
                "ru": "Гладбек"
            },
            "geotag": "2920236",
            "post_code": "45964"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Gliwice",
            "names": {
                "pl": "Gliwice",
                "de": "Gleiwitz",
                "en": "Gliwice",
                "ru": "Гливице"
            },
            "geotag": "3099230",
            "post_code": "44-100"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Gmina Świecie",
            "names": {
                "pl": "Świecie",
                "de": "Świecie",
                "en": "Gmina Świecie",
                "ru": "Свеце"
            },
            "geotag": "3084074",
            "post_code": "59-820"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Gniezno",
            "names": {
                "de": "Gniezno",
                "pl": "Gniezno",
                "en": "Gniezno",
                "ru": "Гнезно"
            },
            "geotag": "3099112",
            "post_code": "61-200"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Goes",
            "names": {
                "en": "Goes",
                "de": "Goes",
                "ru": "Гус"
            },
            "geotag": "2755476",
            "post_code": "4461"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Goirle",
            "names": {
                "en": "Goirle",
                "de": "Goirle",
                "ru": "Горле"
            },
            "geotag": "2755464",
            "post_code": "5051"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Goleniów",
            "names": {
                "pl": "Goleniów",
                "en": "Goleniów",
                "de": "Goleniów",
                "ru": "Голенюв"
            },
            "geotag": "3098966",
            "post_code": "72-100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Gorizia",
            "names": {
                "de": "Görz",
                "pl": "Gorycja",
                "en": "Gorizia",
                "ru": "Гориция"
            },
            "geotag": "3175986",
            "post_code": "34170"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Gorlice",
            "names": {
                "pl": "Gorlice",
                "en": "Gorlice",
                "de": "Gorlice",
                "ru": "Горлице"
            },
            "geotag": "771804",
            "post_code": "33-300"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Gorzów Wielkopolski",
            "names": {
                "de": "Gorzów Wielkopolski",
                "pl": "Gorzów Wielkopolski",
                "en": "Gorzów Wielkopolski",
                "ru": "Гожув-Велькопольский"
            },
            "geotag": "3098722",
            "post_code": "66-400"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Goslar",
            "names": {
                "en": "Goslar",
                "pl": "Goslar",
                "de": "Goslar",
                "ru": "Гослар"
            },
            "geotag": "2918840",
            "post_code": "38640"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Gotha",
            "names": {
                "de": "Gotha",
                "pl": "Gotha",
                "en": "Gotha",
                "ru": "Гота"
            },
            "geotag": "2918752",
            "post_code": "99867"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Gouda",
            "names": {
                "pl": "Gouda",
                "en": "Gouda",
                "de": "Gouda",
                "ru": "Гауда"
            },
            "geotag": "2755420",
            "post_code": "2801"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Gragnano",
            "names": {
                "pl": "Gragnano",
                "en": "Gragnano",
                "ru": "Граньяно"
            },
            "geotag": "3175952",
            "post_code": "80054"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Greifswald",
            "names": {
                "pl": "Greifswald",
                "en": "Greifswald",
                "de": "Greifswald",
                "ru": "Грайфсвальд"
            },
            "geotag": "2917788",
            "post_code": "17489"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Greiz",
            "names": {
                "de": "Greiz",
                "pl": "Greiz",
                "en": "Greiz",
                "ru": "Грайц"
            },
            "geotag": "2917737",
            "post_code": "07973"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Grevenbroich",
            "names": {
                "de": "Grevenbroich",
                "en": "Grevenbroich",
                "ru": "Гревенброх"
            },
            "geotag": "2917540",
            "post_code": "41515"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Groningen",
            "names": {
                "de": "Groningen",
                "en": "Groningen",
                "pl": "Groningen",
                "ru": "Гронинген"
            },
            "geotag": "2755251",
            "post_code": "9711"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Grottaglie",
            "names": {
                "pl": "Grottaglie",
                "en": "Grottaglie",
                "ru": "Гротталье"
            },
            "geotag": "3175773",
            "post_code": "74023"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Grudziądz",
            "names": {
                "de": "Graudenz",
                "en": "Grudziądz",
                "pl": "Grudziądz",
                "ru": "Грудзёндз"
            },
            "geotag": "3098218",
            "post_code": "86-300"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Gryfino",
            "names": {
                "pl": "Gryfino",
                "en": "Gryfino",
                "de": "Gryfino",
                "ru": "Грыфино"
            },
            "geotag": "3098200",
            "post_code": "74-100"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Gubin",
            "names": {
                "pl": "Gubin",
                "de": "Guben",
                "en": "Gubin",
                "ru": "Губин"
            },
            "geotag": "3098130",
            "post_code": "03172"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Gyula",
            "names": {
                "pl": "Gyula",
                "de": "Jula",
                "en": "Gyula",
                "ru": "Дьюла"
            },
            "geotag": "720334",
            "post_code": "5700"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Győr",
            "names": {
                "de": "Györ",
                "en": "Győr",
                "pl": "Győr",
                "ru": "Дьёр"
            },
            "geotag": "3052009",
            "post_code": "9000"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Gödöllő",
            "names": {
                "pl": "Gödöllő",
                "en": "Gödöllő",
                "de": "Getterle",
                "ru": "Гёдёллё"
            },
            "geotag": "3052236",
            "post_code": "2100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Göppingen",
            "names": {
                "de": "Göppingen",
                "en": "Göppingen",
                "pl": "Göppingen",
                "ru": "Гёппинген"
            },
            "geotag": "2919054",
            "post_code": "73033"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Görlitz",
            "names": {
                "de": "Görlitz",
                "en": "Görlitz",
                "pl": "Görlitz",
                "ru": "Гёрлиц"
            },
            "geotag": "2918987",
            "post_code": "02826"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Göttingen",
            "names": {
                "de": "Göttingen",
                "en": "Göttingen",
                "pl": "Getynga",
                "ru": "Гёттинген"
            },
            "geotag": "2918632",
            "post_code": "37073"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Gütersloh",
            "names": {
                "de": "Gütersloh",
                "en": "Gütersloh",
                "pl": "Gütersloh",
                "ru": "Гютерсло"
            },
            "geotag": "2913366",
            "post_code": "33311"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Głogów",
            "names": {
                "de": "Głogów",
                "pl": "Głogów",
                "en": "Głogów",
                "ru": "Глогув"
            },
            "geotag": "3099213",
            "post_code": "67-200"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Haaksbergen",
            "names": {
                "en": "Haaksbergen",
                "de": "Haaksbergen",
                "ru": "Хааксберген"
            },
            "geotag": "2755030",
            "post_code": "7481"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Haarlem",
            "names": {
                "de": "Haarlem",
                "en": "Haarlem",
                "pl": "Haarlem",
                "ru": "Харлем"
            },
            "geotag": "2755003",
            "post_code": "2011"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Hagen",
            "names": {
                "de": "Hagen",
                "pl": "Hagen",
                "en": "Hagen",
                "ru": "Хаген"
            },
            "geotag": "2912621",
            "post_code": "58089"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Hamburg",
            "names": {
                "de": "Hamburg",
                "en": "Hamburg",
                "pl": "Hamburg",
                "ru": "Гамбург"
            },
            "geotag": "2911298",
            "post_code": "20038"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Hamelin",
            "names": {
                "de": "Hameln",
                "en": "Hamelin",
                "pl": "Hameln",
                "ru": "Хамельн"
            },
            "geotag": "2911271",
            "post_code": "31785"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Hamm",
            "names": {
                "de": "Hamm",
                "en": "Hamm",
                "pl": "Hamm",
                "ru": "Хамм"
            },
            "geotag": "2911240",
            "post_code": "59063"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Hanover",
            "names": {
                "de": "Hannover",
                "en": "Hanover",
                "pl": "Hanower",
                "ru": "Ганновер"
            },
            "geotag": "2910831",
            "post_code": "30159"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Hardenberg",
            "names": {
                "en": "Hardenberg",
                "de": "Hardenberg",
                "ru": "Харденберге"
            },
            "geotag": "2754861",
            "post_code": "7771"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Harlingen",
            "names": {
                "en": "Harlingen",
                "de": "Harlingen",
                "pl": "Harlingen",
                "ru": "Харлинген"
            },
            "geotag": "2754817",
            "post_code": "8861"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Hasselt",
            "names": {
                "de": "Hasselt",
                "en": "Hasselt",
                "pl": "Hasselt",
                "ru": "Хасселт"
            },
            "geotag": "2796491",
            "post_code": "3500"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Havlíčkův Brod",
            "names": {
                "de": "Havlíčkův Brod",
                "pl": "Havlíčkův Brod",
                "en": "Havlíčkův Brod",
                "ru": "Гавличкув-Брод"
            },
            "geotag": "3075919",
            "post_code": "580 01"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Heemskerk",
            "names": {
                "en": "Heemskerk",
                "de": "Heemskerk",
                "ru": "Хеемскерк"
            },
            "geotag": "2754697",
            "post_code": "1961"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Heemstede",
            "names": {
                "en": "Heemstede",
                "de": "Heemstede",
                "ru": "Хемстеде"
            },
            "geotag": "2754692",
            "post_code": "2101"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Heerenveen",
            "names": {
                "de": "Heerenveen",
                "en": "Heerenveen",
                "ru": "Херенвен"
            },
            "geotag": "2754669",
            "post_code": "8441"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Heerhugowaard",
            "names": {
                "en": "Heerhugowaard",
                "de": "Heerhugowaard",
                "ru": "Херхюговард"
            },
            "geotag": "2754659",
            "post_code": "1701"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Heidelberg",
            "names": {
                "de": "Heidelberg",
                "en": "Heidelberg",
                "pl": "Heidelberg",
                "ru": "Хайдельберг"
            },
            "geotag": "2907911",
            "post_code": "69115"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Heidenheim",
            "names": {
                "de": "Heidenheim an der Brenz",
                "en": "Heidenheim",
                "pl": "Heidenheim an der Brenz",
                "ru": "Хайденхайм-ан-дер-Бренц"
            },
            "geotag": "2907851",
            "post_code": "89518"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Heilbronn",
            "names": {
                "en": "Heilbronn",
                "de": "Heilbronn",
                "ru": "Хайльбронн",
                "pl": "Heilbronn"
            },
            "geotag": "2907669",
            "post_code": "74072"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Helmond",
            "names": {
                "en": "Helmond",
                "pl": "Helmond",
                "de": "Helmond",
                "ru": "Хелмонд"
            },
            "geotag": "2754447",
            "post_code": "5701"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Helmstedt",
            "names": {
                "de": "Helmstedt",
                "pl": "Helmstedt",
                "en": "Helmstedt",
                "ru": "Хельмштедт"
            },
            "geotag": "2906676",
            "post_code": "38350"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Hemer",
            "names": {
                "de": "Hemer",
                "en": "Hemer",
                "pl": "Hemer",
                "ru": "Хемер"
            },
            "geotag": "2906595",
            "post_code": "58675"
        },
        {
            "code": 17,
            "country_code": "TR",
            "label": "Heraclea",
            "names": {
                "en": "Heraclea",
                "de": "Ereğli",
                "ru": "Эрегли"
            },
            "geotag": "315498",
            "post_code": "42310"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Herford",
            "names": {
                "de": "Herford",
                "en": "Herford",
                "ru": "Херфорд"
            },
            "geotag": "2906121",
            "post_code": "32049"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Herne",
            "names": {
                "de": "Herne",
                "en": "Herne",
                "pl": "Herne",
                "ru": "Херне"
            },
            "geotag": "2905891",
            "post_code": "1540"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Herstal",
            "names": {
                "pl": "Herstal",
                "en": "Herstal",
                "de": "Herstal",
                "ru": "Эрсталь"
            },
            "geotag": "2795930",
            "post_code": "4040"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Herten",
            "names": {
                "de": "Herten",
                "pl": "Herten",
                "en": "Herten",
                "ru": "Хертен"
            },
            "geotag": "2905560",
            "post_code": "3831"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Herzogenaurach",
            "names": {
                "de": "Herzogenaurach",
                "pl": "Herzogenaurach",
                "en": "Herzogenaurach",
                "ru": "Херцогенаурах"
            },
            "geotag": "2905457",
            "post_code": "91074"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Hilden",
            "names": {
                "ru": "Хильден",
                "en": "Hilden",
                "de": "Hilden"
            },
            "geotag": "2904795",
            "post_code": "40721"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Hildesheim",
            "names": {
                "de": "Hildesheim",
                "en": "Hildesheim",
                "pl": "Hildesheim",
                "ru": "Хильдесхайм"
            },
            "geotag": "2904789",
            "post_code": "31134"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Hilversum",
            "names": {
                "en": "Hilversum",
                "de": "Hilversum",
                "pl": "Hilversum",
                "ru": "Хилверсюм"
            },
            "geotag": "2754064",
            "post_code": "1211"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Hlohovec",
            "names": {
                "pl": "Hlohovec",
                "de": "Hlohovec",
                "en": "Hlohovec",
                "ru": "Глоговец"
            },
            "geotag": "3060095",
            "post_code": "691 43"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Hodonín",
            "names": {
                "de": "Hodonín",
                "pl": "Hodonín",
                "en": "Hodonín",
                "ru": "Годонин"
            },
            "geotag": "3075654",
            "post_code": "679 71"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Hof",
            "names": {
                "de": "Hof",
                "pl": "Hof",
                "en": "Hof",
                "ru": "Хоф"
            },
            "geotag": "2902768",
            "post_code": "9844"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Hoogeveen",
            "names": {
                "en": "Hoogeveen",
                "de": "Hoogeveen",
                "pl": "Hoogeveen",
                "ru": "Хоогевеен"
            },
            "geotag": "2753719",
            "post_code": "7901"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Hoorn",
            "names": {
                "en": "Hoorn",
                "de": "Hoorn",
                "ru": "Хорн"
            },
            "geotag": "2753638",
            "post_code": "8896"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Hoyerswerda",
            "names": {
                "de": "Hoyerswerda",
                "pl": "Wojerce",
                "en": "Hoyerswerda",
                "ru": "Хойерсверда"
            },
            "geotag": "2898304",
            "post_code": "02977"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Hradec Králové",
            "names": {
                "de": "Hradec Králové",
                "en": "Hradec Králové",
                "pl": "Hradec Králové",
                "ru": "Градец-Кралове"
            },
            "geotag": "3074967",
            "post_code": "500 02"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Hrubieszów",
            "names": {
                "pl": "Hrubieszów",
                "en": "Hrubieszów",
                "de": "Hrubieszów",
                "ru": "Хрубешув"
            },
            "geotag": "770966",
            "post_code": "22-500"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Huesca",
            "names": {
                "en": "Huesca",
                "pl": "Huesca",
                "de": "Huesca",
                "ru": "Уэска"
            },
            "geotag": "3120514",
            "post_code": "22001"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Husum",
            "names": {
                "de": "Husum",
                "en": "Husum",
                "pl": "Husum",
                "ru": "Хузум"
            },
            "geotag": "2897132",
            "post_code": "31632"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Huy",
            "names": {
                "en": "Huy",
                "de": "Huy",
                "pl": "Huy",
                "ru": "Юи"
            },
            "geotag": "2795113",
            "post_code": "4500"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Höxter",
            "names": {
                "de": "Höxter",
                "en": "Höxter",
                "pl": "Höxter",
                "ru": "Хёкстер"
            },
            "geotag": "2898321",
            "post_code": "37671"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Ibbenbueren",
            "names": {
                "de": "Ibbenbüren",
                "ru": "Иббенбюрен",
                "en": "Ibbenbueren"
            },
            "geotag": "2896817",
            "post_code": "49477"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Iesi",
            "names": {
                "ru": "Ези",
                "pl": "Jesi",
                "de": "Jesi",
                "en": "Iesi"
            },
            "geotag": "3175628",
            "post_code": "60035"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Iglesias",
            "names": {
                "pl": "Iglesias",
                "de": "Iglesias",
                "en": "Iglesias",
                "ru": "Иглезиас"
            },
            "geotag": "2524533",
            "post_code": "09227"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Igualada",
            "names": {
                "de": "Igualada",
                "en": "Igualada",
                "ru": "Игуалада"
            },
            "geotag": "3120431",
            "post_code": "08700"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Ilmenau",
            "names": {
                "de": "Ilmenau",
                "en": "Ilmenau",
                "ru": "Ильменау"
            },
            "geotag": "2896514",
            "post_code": "98693"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Imola",
            "names": {
                "de": "Imola",
                "en": "Imola",
                "pl": "Imola",
                "ru": "Имола"
            },
            "geotag": "3175537",
            "post_code": "3725"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Imperia",
            "names": {
                "pl": "Imperia",
                "de": "Imperia",
                "en": "Imperia",
                "ru": "Империя"
            },
            "geotag": "3175532",
            "post_code": "18100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Ingolstadt",
            "names": {
                "de": "Ingolstadt",
                "en": "Ingolstadt",
                "pl": "Ingolstadt",
                "ru": "Ингольштадт"
            },
            "geotag": "2895992",
            "post_code": "85049"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Innsbruck",
            "names": {
                "de": "Innsbruck",
                "en": "Innsbruck",
                "pl": "Innsbruck",
                "ru": "Инсбрук"
            },
            "geotag": "2775220",
            "post_code": "6020"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Inowrocław",
            "names": {
                "en": "Inowrocław",
                "pl": "Inowrocław",
                "de": "Inowrocław",
                "ru": "Иновроцлав"
            },
            "geotag": "3097872",
            "post_code": "88-100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Ischia",
            "names": {
                "ru": "Искья",
                "de": "Ischia",
                "en": "Ischia"
            },
            "geotag": "3175458",
            "post_code": "80077"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Iserlohn",
            "names": {
                "de": "Iserlohn",
                "en": "Iserlohn",
                "pl": "Iserlohn",
                "ru": "Изерлон"
            },
            "geotag": "2895669",
            "post_code": "58636"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Isernia",
            "names": {
                "pl": "Isernia",
                "en": "Isernia",
                "de": "Isernia",
                "ru": "Изерния"
            },
            "geotag": "3175445",
            "post_code": "86170"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Ivrea",
            "names": {
                "pl": "Ivrea",
                "de": "Ivrea",
                "en": "Ivrea",
                "ru": "Ивреа"
            },
            "geotag": "3175384",
            "post_code": "10015"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Izegem",
            "names": {
                "en": "Izegem",
                "de": "Izegem",
                "ru": "Изегем"
            },
            "geotag": "2795009",
            "post_code": "8870"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Iława",
            "names": {
                "de": "Iława",
                "en": "Iława",
                "pl": "Iława",
                "ru": "Илава"
            },
            "geotag": "3097902",
            "post_code": "48-300"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Jablonec nad Nisou",
            "names": {
                "de": "Jablonec nad Nisou",
                "pl": "Jablonec nad Nysą",
                "en": "Jablonec nad Nisou",
                "ru": "Яблонец"
            },
            "geotag": "3074603",
            "post_code": "466 01"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Jarocin",
            "names": {
                "pl": "Jarocin",
                "en": "Jarocin",
                "de": "Jarocin",
                "ru": "Яроцин"
            },
            "geotag": "3097528",
            "post_code": "09-130"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Jarosław",
            "names": {
                "pl": "Jarosław",
                "en": "Jarosław",
                "de": "Jarosław",
                "ru": "Ярослав"
            },
            "geotag": "770380",
            "post_code": "55-340"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Jena",
            "names": {
                "de": "Jena",
                "en": "Jena",
                "pl": "Jena",
                "ru": "Йена"
            },
            "geotag": "2895044",
            "post_code": "07743"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Jette",
            "names": {
                "en": "Jette",
                "de": "Jette",
                "ru": "Жет"
            },
            "geotag": "2794914",
            "post_code": "1090"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Jihlava",
            "names": {
                "de": "Jihlava",
                "en": "Jihlava",
                "pl": "Jihlava",
                "ru": "Йиглава"
            },
            "geotag": "3074199",
            "post_code": "586 01"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "K-Town",
            "names": {
                "de": "Kaiserslautern",
                "en": "K-Town",
                "pl": "Kaiserslautern",
                "ru": "Кайзерслаутерн"
            },
            "geotag": "2894003",
            "post_code": "67653"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Kalisz",
            "names": {
                "de": "Kalisz",
                "pl": "Kalisz",
                "en": "Kalisz",
                "ru": "Калиш"
            },
            "geotag": "3096880",
            "post_code": "06-461"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Kampen",
            "names": {
                "en": "Kampen",
                "de": "Kampen",
                "ru": "Кампен"
            },
            "geotag": "2753106",
            "post_code": "25999"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Kaposvár",
            "names": {
                "de": "Kaposvár",
                "en": "Kaposvár",
                "pl": "Kaposvár",
                "ru": "Капошвар"
            },
            "geotag": "3050616",
            "post_code": "7400"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Karaman",
            "names": {
                "de": "Karaman",
                "en": "Karaman",
                "pl": "Karaman",
                "ru": "Караман"
            },
            "geotag": "309527",
            "post_code": "23850"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Karlovy Vary",
            "names": {
                "de": "Karlsbad",
                "en": "Karlovy Vary",
                "pl": "Karlowe Wary",
                "ru": "Карловы Вары"
            },
            "geotag": "3073803",
            "post_code": "360 01"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Karlsruhe",
            "names": {
                "de": "Karlsruhe",
                "en": "Karlsruhe",
                "pl": "Karlsruhe",
                "ru": "Карлсруэ"
            },
            "geotag": "2892794",
            "post_code": "76006"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Kartuzy",
            "names": {
                "en": "Kartuzy",
                "pl": "Kartuzy",
                "de": "Kartuzy",
                "ru": "Картузы"
            },
            "geotag": "3096525",
            "post_code": "83-300"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Kassel",
            "names": {
                "de": "Kassel",
                "en": "Kassel",
                "pl": "Kassel",
                "ru": "Кассель"
            },
            "geotag": "2892518",
            "post_code": "34117"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Katowice",
            "names": {
                "pl": "Katowice",
                "de": "Kattowitz",
                "en": "Katowice",
                "ru": "Катовице"
            },
            "geotag": "3096472",
            "post_code": "40-001"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Kaufbeuren",
            "names": {
                "de": "Kaufbeuren",
                "pl": "Kaufbeuren",
                "en": "Kaufbeuren",
                "ru": "Кауфбойрен"
            },
            "geotag": "2892080",
            "post_code": "87600"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Kecskemét",
            "names": {
                "de": "Kecskemet",
                "en": "Kecskemét",
                "pl": "Kecskemét",
                "ru": "Кечкемет"
            },
            "geotag": "3050434",
            "post_code": "6000"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Kehl",
            "names": {
                "de": "Kehl",
                "en": "Kehl",
                "ru": "Кель"
            },
            "geotag": "2891951",
            "post_code": "77694"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Kerkrade",
            "names": {
                "en": "Kerkrade",
                "de": "Kirchrath",
                "pl": "Kerkrade",
                "ru": "Керкраде"
            },
            "geotag": "2752923",
            "post_code": "6461"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Kerpen",
            "names": {
                "de": "Kerpen",
                "en": "Kerpen",
                "pl": "Kerpen",
                "ru": "Керпен"
            },
            "geotag": "2891524",
            "post_code": "50169"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Kiel",
            "names": {
                "en": "Kiel",
                "pl": "Kilonia",
                "de": "Kiel",
                "ru": "Киль"
            },
            "geotag": "2891122",
            "post_code": "24103"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Kielce",
            "names": {
                "de": "Kielce",
                "en": "Kielce",
                "pl": "Kielce",
                "ru": "Кельце"
            },
            "geotag": "769250",
            "post_code": "25-558"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Kladno",
            "names": {
                "de": "Kladno",
                "en": "Kladno",
                "pl": "Kladno",
                "ru": "Кладно"
            },
            "geotag": "3073699",
            "post_code": "539 01"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Kleve",
            "names": {
                "de": "Kleve",
                "en": "Kleve",
                "pl": "Kleve",
                "ru": "Клеве"
            },
            "geotag": "2887835",
            "post_code": "47533"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Knokke-Heist",
            "names": {
                "pl": "Knokke-Heist",
                "de": "Knokke-Heist",
                "en": "Knokke-Heist",
                "ru": "Кнокке-Хейст"
            },
            "geotag": "2794210",
            "post_code": "8300"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Koblenz",
            "names": {
                "de": "Koblenz",
                "en": "Koblenz",
                "pl": "Koblencja",
                "ru": "Кобленц"
            },
            "geotag": "2886946",
            "post_code": "56068"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Koekelberg",
            "names": {
                "en": "Koekelberg",
                "de": "Koekelberg",
                "ru": "Кукельберг"
            },
            "geotag": "2794190",
            "post_code": "1081"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Koksijde",
            "names": {
                "en": "Koksijde",
                "de": "Koksijde",
                "ru": "Коксейде"
            },
            "geotag": "2794166",
            "post_code": "8670"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Kolín",
            "names": {
                "pl": "Kolín",
                "de": "Köln an der Elbe",
                "en": "Kolín",
                "ru": "Колин"
            },
            "geotag": "3073371",
            "post_code": "280 02"
        },
        {
            "code": 7,
            "country_code": "SK",
            "label": "Komárno",
            "names": {
                "de": "Komárno",
                "pl": "Komárno",
                "en": "Komárno",
                "ru": "Комарно"
            },
            "geotag": "3059436",
            "post_code": "768 71"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Komárom",
            "names": {
                "pl": "Komárom",
                "en": "Komárom",
                "de": "Komorn",
                "ru": "Комаром"
            },
            "geotag": "3049519",
            "post_code": "2900"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Konin",
            "names": {
                "en": "Konin",
                "ru": "Конин",
                "pl": "Konin",
                "de": "Konin"
            },
            "geotag": "3095321",
            "post_code": "95-200"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Konstanz",
            "names": {
                "de": "Kostnitz",
                "en": "Konstanz",
                "pl": "Konstancja",
                "ru": "Констанц"
            },
            "geotag": "2885679",
            "post_code": "78462"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Kornwestheim",
            "names": {
                "de": "Kornwestheim",
                "pl": "Kornwestheim",
                "en": "Kornwestheim",
                "ru": "Корнвестхайм"
            },
            "geotag": "2885408",
            "post_code": "70806"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Kortrijk",
            "names": {
                "en": "Kortrijk",
                "pl": "Kortrijk",
                "de": "Kortrijk",
                "ru": "Кортрейк"
            },
            "geotag": "2794055",
            "post_code": "8500"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Koszalin",
            "names": {
                "pl": "Koszalin",
                "de": "Koszalin",
                "en": "Koszalin",
                "ru": "Кошалин"
            },
            "geotag": "3095049",
            "post_code": "75-001"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Koło",
            "names": {
                "en": "Koło",
                "pl": "Koło",
                "de": "Koło",
                "ru": "Коло"
            },
            "geotag": "3095797",
            "post_code": "97-330"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Kołobrzeg",
            "names": {
                "de": "Kołobrzeg",
                "en": "Kołobrzeg",
                "pl": "Kołobrzeg",
                "ru": "Колобжег"
            },
            "geotag": "3095795",
            "post_code": "78-100"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Kościan",
            "names": {
                "de": "Kościan",
                "pl": "Kościan",
                "en": "Kościan",
                "ru": "Косьцян"
            },
            "geotag": "3095151",
            "post_code": "64-000"
        },
        {
            "code": 6,
            "country_code": "SK",
            "label": "Košice",
            "names": {
                "de": "Kosice",
                "en": "Košice",
                "pl": "Koszyce",
                "ru": "Кошице"
            },
            "geotag": "724443",
            "post_code": "391 17"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Krakow",
            "names": {
                "de": "Krakau",
                "en": "Krakow",
                "pl": "Kraków",
                "ru": "Краков"
            },
            "geotag": "3094802",
            "post_code": "30-001"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Krefeld",
            "names": {
                "de": "Krefeld",
                "en": "Krefeld",
                "pl": "Krefeld",
                "ru": "Крефельд"
            },
            "geotag": "2884509",
            "post_code": "47798"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Kroměříž",
            "names": {
                "de": "Kroměříž",
                "pl": "Kromieryż",
                "en": "Kroměříž",
                "ru": "Кромержиж"
            },
            "geotag": "3072649",
            "post_code": "767 01"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Kulmbach",
            "names": {
                "de": "Kulmbach",
                "pl": "Kulmbach",
                "en": "Kulmbach",
                "ru": "Кульмбах"
            },
            "geotag": "2882588",
            "post_code": "95326"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Kutno",
            "names": {
                "en": "Kutno",
                "pl": "Kutno",
                "de": "Kutno",
                "ru": "Кутно"
            },
            "geotag": "3094170",
            "post_code": "99-300"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Köthen",
            "names": {
                "de": "Köthen",
                "pl": "Köthen",
                "en": "Köthen",
                "ru": "Кётен"
            },
            "geotag": "2885237",
            "post_code": "06366"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Kętrzyn",
            "names": {
                "de": "Kętrzyn",
                "pl": "Kętrzyn",
                "en": "Kętrzyn",
                "ru": "Кентшин"
            },
            "geotag": "769274",
            "post_code": "11-400"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Kłodzko",
            "names": {
                "pl": "Kłodzko",
                "de": "Kłodzko",
                "en": "Kłodzko",
                "ru": "Клодзко"
            },
            "geotag": "3096053",
            "post_code": "57-300"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "La Louvière",
            "names": {
                "en": "La Louvière",
                "pl": "La Louvière",
                "de": "La Louvière",
                "ru": "Ла-Лувьер"
            },
            "geotag": "2793508",
            "post_code": "7100"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "La Pineda",
            "names": {
                "ru": "Ла Пинеда",
                "en": "La Pineda",
                "de": "La Pineda"
            },
            "geotag": "3119231",
            "post_code": "43481"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "La Spezia",
            "names": {
                "de": "La Spezia",
                "en": "La Spezia",
                "pl": "La Spezia",
                "ru": "Специя"
            },
            "geotag": "3175081",
            "post_code": "19100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Ladispoli",
            "names": {
                "pl": "Ladispoli",
                "en": "Ladispoli",
                "de": "Ladispoli",
                "ru": "Ладисполи"
            },
            "geotag": "3175298",
            "post_code": "00055"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Lahr",
            "names": {
                "de": "Lahr/Schwarzwald",
                "en": "Lahr",
                "ru": "Лар",
                "pl": "Lahr/Schwarzwald"
            },
            "geotag": "2881885",
            "post_code": "77933"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Lanciano",
            "names": {
                "pl": "Lanciano",
                "de": "Lanciano",
                "en": "Lanciano",
                "ru": "Ланчано"
            },
            "geotag": "3175173",
            "post_code": "66034"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Landau",
            "names": {
                "en": "Landau",
                "de": "Landau in der Pfalz",
                "pl": "Landau",
                "ru": "Ландау"
            },
            "geotag": "2881646",
            "post_code": "8672"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Landsberg am Lech",
            "names": {
                "de": "Landsberg am Lech",
                "pl": "Landsberg am Lech",
                "en": "Landsberg am Lech",
                "ru": "Ландсберг-ам-Лех"
            },
            "geotag": "2881509",
            "post_code": "86899"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Landshut",
            "names": {
                "de": "Landshut",
                "pl": "Landshut",
                "en": "Landshut",
                "ru": "Ландсхут"
            },
            "geotag": "2881485",
            "post_code": "4273"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Langenfeld",
            "names": {
                "en": "Langenfeld",
                "ru": "Лангенфельд",
                "de": "Langenfeld"
            },
            "geotag": "2881085",
            "post_code": "91474"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Lecce",
            "names": {
                "pl": "Lecce",
                "de": "Lecce",
                "en": "Lecce",
                "ru": "Лечче"
            },
            "geotag": "3174953",
            "post_code": "73100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Lecco",
            "names": {
                "pl": "Lecco",
                "en": "Lecco",
                "de": "Lecco",
                "ru": "Лекко"
            },
            "geotag": "3174945",
            "post_code": "23900"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Leerdam",
            "names": {
                "en": "Leerdam",
                "de": "Leerdam",
                "ru": "Лердам"
            },
            "geotag": "2751808",
            "post_code": "4141"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Leeuwarden",
            "names": {
                "de": "Leeuwarden",
                "en": "Leeuwarden",
                "pl": "Leeuwarden",
                "ru": "Леуварден"
            },
            "geotag": "2751792",
            "post_code": "8911"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Legionowo",
            "names": {
                "pl": "Legionowo",
                "en": "Legionowo",
                "de": "Legionowo",
                "ru": "Легьоново"
            },
            "geotag": "766555",
            "post_code": "05-101"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Legnago",
            "names": {
                "pl": "Legnago",
                "de": "Legnago",
                "en": "Legnago",
                "ru": "Леньяго"
            },
            "geotag": "3174922",
            "post_code": "37045"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Leiden",
            "names": {
                "de": "Leiden",
                "en": "Leiden",
                "pl": "Lejda",
                "ru": "Лейден"
            },
            "geotag": "2751773",
            "post_code": "2311"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Leipzig",
            "names": {
                "de": "Leipzig",
                "en": "Leipzig",
                "pl": "Lipsk",
                "ru": "Лейпциг"
            },
            "geotag": "2879139",
            "post_code": "04103"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Lentini",
            "names": {
                "pl": "Lentini",
                "de": "Lentini",
                "en": "Lentini",
                "ru": "Лентини"
            },
            "geotag": "2524410",
            "post_code": "96016"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Leonberg",
            "names": {
                "de": "Leonberg",
                "en": "Leonberg",
                "ru": "Леонберг"
            },
            "geotag": "2878695",
            "post_code": "71229"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Leszno",
            "names": {
                "pl": "Leszno",
                "de": "Leszno",
                "en": "Leszno",
                "ru": "Лешно"
            },
            "geotag": "3093524",
            "post_code": "99-300"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Leuven",
            "names": {
                "de": "Löwen",
                "en": "Leuven",
                "pl": "Leuven",
                "ru": "Лёвен"
            },
            "geotag": "2792482",
            "post_code": "3000"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Leverkusen",
            "names": {
                "de": "Leverkusen",
                "en": "Leverkusen",
                "pl": "Leverkusen",
                "ru": "Леверкузен"
            },
            "geotag": "2878234",
            "post_code": "51371"
        },
        {
            "code": 7,
            "country_code": "SK",
            "label": "Levice",
            "names": {
                "de": "Levice",
                "en": "Levice",
                "ru": "Левице",
                "pl": "Levice"
            },
            "geotag": "3059101",
            "post_code": "12070"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Lidzbark Warmiński",
            "names": {
                "de": "Lidzbark Warmiński",
                "en": "Lidzbark Warmiński",
                "ru": "Лидзбарк-Варминьский",
                "pl": "Lidzbark Warmiński"
            },
            "geotag": "766307",
            "post_code": "11-100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Limbiate",
            "names": {
                "pl": "Limbiate",
                "en": "Limbiate",
                "ru": "Лимбьяте"
            },
            "geotag": "3174719",
            "post_code": "20812"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Limburg an der Lahn",
            "names": {
                "de": "Limburg an der Lahn",
                "en": "Limburg an der Lahn",
                "ru": "Лимбург-ан-дер-Лан"
            },
            "geotag": "2877648",
            "post_code": "65549"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Lindau",
            "names": {
                "de": "Lindau",
                "en": "Lindau",
                "pl": "Lindau",
                "ru": "Линдау"
            },
            "geotag": "2877550",
            "post_code": "3820"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Lingen",
            "names": {
                "de": "Lingen",
                "pl": "Lingen",
                "en": "Lingen",
                "ru": "Линген"
            },
            "geotag": "2877088",
            "post_code": "49808"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Linz",
            "names": {
                "de": "Linz",
                "en": "Linz",
                "pl": "Linz",
                "ru": "Линц"
            },
            "geotag": "2772400",
            "post_code": "9562"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Lippstadt",
            "names": {
                "de": "Lippstadt",
                "pl": "Lippstadt",
                "en": "Lippstadt",
                "ru": "Липпштадт"
            },
            "geotag": "2876865",
            "post_code": "59555"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Lissone",
            "names": {
                "pl": "Lissone",
                "en": "Lissone",
                "ru": "Лиссоне"
            },
            "geotag": "3174679",
            "post_code": "20851"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Livorno",
            "names": {
                "en": "Livorno",
                "de": "Livorno",
                "pl": "Livorno",
                "ru": "Ливорно"
            },
            "geotag": "3174659",
            "post_code": "57100"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Liège",
            "names": {
                "de": "Lüttich",
                "en": "Liège",
                "pl": "Liège",
                "ru": "Льеж"
            },
            "geotag": "2792413",
            "post_code": "4000"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Lodi",
            "names": {
                "pl": "Lodi",
                "en": "Lodi",
                "de": "Lodi",
                "ru": "Лоди"
            },
            "geotag": "3174638",
            "post_code": "26900"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Lodz",
            "names": {
                "de": "Lodz",
                "en": "Lodz",
                "pl": "Łódź",
                "ru": "Лодзь"
            },
            "geotag": "3093133",
            "post_code": "90-001"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Loerrach",
            "names": {
                "de": "Lörrach",
                "en": "Loerrach",
                "pl": "Lörrach",
                "ru": "Лёррах"
            },
            "geotag": "2875881",
            "post_code": "79539"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Logroño",
            "names": {
                "de": "Logrono",
                "en": "Logroño",
                "pl": "Logroño",
                "ru": "Логроньо"
            },
            "geotag": "3118150",
            "post_code": "26001"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Lohr a. Main",
            "names": {
                "de": "Lohr am Main",
                "en": "Lohr a. Main",
                "ru": "Лор-ам-Майн"
            },
            "geotag": "2876147",
            "post_code": "97816"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Loja",
            "names": {
                "pl": "Loja",
                "de": "Loja",
                "en": "Loja",
                "ru": "Лоха"
            },
            "geotag": "3654667",
            "post_code": "3680"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Lommel",
            "names": {
                "de": "Lommel",
                "en": "Lommel",
                "ru": "Ломмел"
            },
            "geotag": "2792179",
            "post_code": "3920"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Losser",
            "names": {
                "en": "Losser",
                "de": "Losser",
                "ru": "Лоссер"
            },
            "geotag": "2751424",
            "post_code": "7581"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Louny",
            "names": {
                "de": "Louny",
                "pl": "Louny",
                "en": "Louny",
                "ru": "Лоуни"
            },
            "geotag": "3071507",
            "post_code": "440 01"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Lowicz",
            "names": {
                "pl": "Łowicz",
                "en": "Lowicz",
                "de": "Łowicz",
                "ru": "Лович"
            },
            "geotag": "3093066",
            "post_code": "99-400"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Lubin",
            "names": {
                "pl": "Lubin",
                "en": "Lubin",
                "de": "Lüben",
                "ru": "Любин"
            },
            "geotag": "3092931",
            "post_code": "56-300"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Lubliniec",
            "names": {
                "pl": "Lubliniec",
                "en": "Lubliniec",
                "de": "Lublinitz",
                "ru": "Люблинец"
            },
            "geotag": "3092906",
            "post_code": "42-700"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Lucca",
            "names": {
                "de": "Lucca",
                "en": "Lucca",
                "pl": "Lukka",
                "ru": "Лукка"
            },
            "geotag": "3174530",
            "post_code": "55100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Lucera",
            "names": {
                "pl": "Lucera",
                "de": "Lucera",
                "en": "Lucera",
                "ru": "Лучера"
            },
            "geotag": "3174526",
            "post_code": "71036"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Ludwigsburg",
            "names": {
                "de": "Ludwigsburg",
                "en": "Ludwigsburg",
                "pl": "Ludwigsburg",
                "ru": "Людвигсбург"
            },
            "geotag": "2875392",
            "post_code": "71634"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Ludwigshafen am Rhein",
            "names": {
                "de": "Ludwigshafen am Rhein",
                "en": "Ludwigshafen am Rhein",
                "pl": "Ludwigshafen",
                "ru": "Людвигсхафен-на-Рейне"
            },
            "geotag": "2875376",
            "post_code": "67059"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Lugo",
            "names": {
                "de": "Lugo",
                "pl": "Lugo",
                "en": "Lugo",
                "ru": "Луго"
            },
            "geotag": "3117814",
            "post_code": "27001"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Lustenau",
            "names": {
                "de": "Lustenau",
                "en": "Lustenau",
                "ru": "Лустенау"
            },
            "geotag": "2772173",
            "post_code": "6890"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Lübeck",
            "names": {
                "de": "Lübeck",
                "en": "Lübeck",
                "pl": "Lubeka",
                "ru": "Любек"
            },
            "geotag": "2875601",
            "post_code": "23539"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Lüdenscheid",
            "names": {
                "de": "Lüdenscheid",
                "en": "Lüdenscheid",
                "pl": "Lüdenscheid",
                "ru": "Люденшайд"
            },
            "geotag": "2875457",
            "post_code": "58507"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Lüneburg",
            "names": {
                "de": "Lüneburg",
                "en": "Lüneburg",
                "pl": "Lüneburg",
                "ru": "Люнебург"
            },
            "geotag": "2875115",
            "post_code": "21335"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Lünen",
            "names": {
                "de": "Lünen",
                "en": "Lünen",
                "ru": "Люнен"
            },
            "geotag": "2875107",
            "post_code": "44532"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "L’Aquila",
            "names": {
                "de": "L'Aquila",
                "en": "L’Aquila",
                "pl": "L'Aquila",
                "ru": "Л’Аквила"
            },
            "geotag": "3175121",
            "post_code": "67100"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Maaseik",
            "names": {
                "en": "Maaseik",
                "de": "Maaseik",
                "ru": "Маасейк"
            },
            "geotag": "2791964",
            "post_code": "3680"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Maastricht",
            "names": {
                "ru": "Маастрихт",
                "de": "Maastricht",
                "en": "Maastricht"
            },
            "geotag": "2751283",
            "post_code": "6211"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Macerata",
            "names": {
                "pl": "Macerata",
                "de": "Macerata",
                "en": "Macerata",
                "ru": "Мачерата"
            },
            "geotag": "3174380",
            "post_code": "62100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Maddaloni",
            "names": {
                "pl": "Maddaloni",
                "en": "Maddaloni",
                "ru": "Маддалони"
            },
            "geotag": "3174358",
            "post_code": "81024"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Magdeburg",
            "names": {
                "de": "Magdeburg",
                "en": "Magdeburg",
                "pl": "Magdeburg",
                "ru": "Магдебург"
            },
            "geotag": "2874545",
            "post_code": "39014"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Mainz",
            "names": {
                "de": "Mainz",
                "en": "Mainz",
                "pl": "Moguncja",
                "ru": "Майнц"
            },
            "geotag": "2874225",
            "post_code": "55116"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Malbork",
            "names": {
                "de": "Malbork",
                "en": "Malbork",
                "pl": "Malbork",
                "ru": "Мальборк"
            },
            "geotag": "3092472",
            "post_code": "83-322"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Manduria",
            "names": {
                "pl": "Manduria",
                "en": "Manduria",
                "ru": "Мандурия"
            },
            "geotag": "3174096",
            "post_code": "74024"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Manfredonia",
            "names": {
                "pl": "Manfredonia",
                "de": "Manfredonia",
                "en": "Manfredonia",
                "ru": "Манфредония"
            },
            "geotag": "3174092",
            "post_code": "71043"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Manlleu",
            "names": {
                "en": "Manlleu",
                "de": "Manlleu",
                "ru": "Манльеу"
            },
            "geotag": "3117539",
            "post_code": "08560"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Mannheim",
            "names": {
                "de": "Mannheim",
                "en": "Mannheim",
                "pl": "Mannheim",
                "ru": "Мангейм"
            },
            "geotag": "2873891",
            "post_code": "68159"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Manresa",
            "names": {
                "pl": "Manresa",
                "de": "Manresa",
                "en": "Manresa",
                "ru": "Манреса"
            },
            "geotag": "3117533",
            "post_code": "08240"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Marcianise",
            "names": {
                "pl": "Marcianise",
                "en": "Marcianise",
                "ru": "Марчанизе"
            },
            "geotag": "3173995",
            "post_code": "81025"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Marigliano",
            "names": {
                "pl": "Marigliano",
                "en": "Marigliano",
                "ru": "Марильяно"
            },
            "geotag": "3173945",
            "post_code": "80034"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Marsala",
            "names": {
                "de": "Marsala",
                "en": "Marsala",
                "pl": "Marsala",
                "ru": "Марсала"
            },
            "geotag": "2524245",
            "post_code": "91025"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Mascalucia",
            "names": {
                "pl": "Mascalucia",
                "de": "Mascalucia",
                "en": "Mascalucia",
                "ru": "Маскалуча"
            },
            "geotag": "2524236",
            "post_code": "95030"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Matera",
            "names": {
                "en": "Matera",
                "de": "Matera",
                "pl": "Matera",
                "ru": "Матера"
            },
            "geotag": "3173721",
            "post_code": "75100"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Mechelen",
            "names": {
                "de": "Mecheln",
                "en": "Mechelen",
                "pl": "Mechelen",
                "ru": "Мехелен"
            },
            "geotag": "2791537",
            "post_code": "2800"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Meda",
            "names": {
                "en": "Meda",
                "pl": "Meda",
                "ru": "Мед"
            },
            "geotag": "3173671",
            "post_code": "32368"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Meerbusch",
            "names": {
                "ru": "Мербуш",
                "en": "Meerbusch",
                "de": "Meerbusch"
            },
            "geotag": "2872504",
            "post_code": "40667"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Meiningen",
            "names": {
                "de": "Meiningen",
                "pl": "Meiningen",
                "en": "Meiningen",
                "ru": "Майнинген"
            },
            "geotag": "2872225",
            "post_code": "6812"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Memmingen",
            "names": {
                "de": "Memmingen",
                "pl": "Memmingen",
                "en": "Memmingen",
                "ru": "Мемминген"
            },
            "geotag": "2871992",
            "post_code": "87700"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Menen",
            "names": {
                "en": "Menen",
                "de": "Menen",
                "ru": "Менен"
            },
            "geotag": "2791343",
            "post_code": "8930"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Meppel",
            "names": {
                "en": "Meppel",
                "de": "Meppel",
                "pl": "Meppel",
                "ru": "Меппел"
            },
            "geotag": "2750947",
            "post_code": "7941"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Meran",
            "names": {
                "pl": "Merano",
                "de": "Meran",
                "en": "Meran",
                "ru": "Мерано"
            },
            "geotag": "3173577",
            "post_code": "39012"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Merseburg",
            "names": {
                "de": "Merseburg",
                "en": "Merseburg",
                "pl": "Merseburg",
                "ru": "Мерзебург"
            },
            "geotag": "2871736",
            "post_code": "06217"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Messina",
            "names": {
                "de": "Messina",
                "en": "Messina",
                "pl": "Mesyna",
                "ru": "Мессина"
            },
            "geotag": "2524170",
            "post_code": "98100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Mestre",
            "names": {
                "en": "Mestre",
                "ru": "Местре",
                "de": "Mestre bei Venedig"
            },
            "geotag": "3173529",
            "post_code": "30171"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Middelburg",
            "names": {
                "en": "Middelburg",
                "pl": "Middelburg",
                "de": "Middelburg",
                "ru": "Мидделбург"
            },
            "geotag": "2750896",
            "post_code": "9992"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Middelharnis",
            "names": {
                "en": "Middelharnis",
                "de": "Middelharnis",
                "ru": "Мидделхарнис"
            },
            "geotag": "2750884",
            "post_code": "3241"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Mielec",
            "names": {
                "pl": "Mielec",
                "en": "Mielec",
                "de": "Mielec",
                "ru": "Мелец"
            },
            "geotag": "764849",
            "post_code": "38-300"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Mikołów",
            "names": {
                "pl": "Mikołów",
                "de": "Nikolai",
                "en": "Mikołów",
                "ru": "Миколув"
            },
            "geotag": "3091831",
            "post_code": "43-190"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Milazzo",
            "names": {
                "en": "Milazzo",
                "pl": "Milazzo",
                "de": "Milazzo",
                "ru": "Милаццо"
            },
            "geotag": "2524155",
            "post_code": "98057"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Minden",
            "names": {
                "de": "Minden",
                "en": "Minden",
                "pl": "Minden",
                "ru": "Минден"
            },
            "geotag": "2871039",
            "post_code": "32423"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Mira",
            "names": {
                "pl": "Mira",
                "en": "Mira",
                "ru": "Мира"
            },
            "geotag": "3173385",
            "post_code": "16393"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Mirandola",
            "names": {
                "pl": "Mirandola",
                "de": "Mirandola",
                "en": "Mirandola",
                "ru": "Мирандола"
            },
            "geotag": "3173370",
            "post_code": "41037"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Mirano",
            "names": {
                "pl": "Mirano",
                "en": "Mirano",
                "ru": "Мирано"
            },
            "geotag": "3173369",
            "post_code": "30035"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Miskolc",
            "names": {
                "de": "Miskolc",
                "en": "Miskolc",
                "pl": "Miszkolc",
                "ru": "Мишкольц"
            },
            "geotag": "717582",
            "post_code": "3500"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Międzyrzec Podlaski",
            "names": {
                "pl": "Międzyrzec Podlaski",
                "en": "Międzyrzec Podlaski",
                "de": "Międzyrzec Podlaski",
                "ru": "Мендзыжец-Подляски"
            },
            "geotag": "764862",
            "post_code": "21-560"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Międzyrzecz",
            "names": {
                "pl": "Międzyrzecz",
                "en": "Międzyrzecz",
                "de": "Międzyrzecz",
                "ru": "Мендзыжеч"
            },
            "geotag": "3091969",
            "post_code": "66-000"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Modena",
            "names": {
                "de": "Modena",
                "en": "Modena",
                "pl": "Modena",
                "ru": "Модена"
            },
            "geotag": "3173331",
            "post_code": "41100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Modica",
            "names": {
                "pl": "Modica",
                "de": "Modica",
                "en": "Modica",
                "ru": "Модика"
            },
            "geotag": "2524119",
            "post_code": "97015"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Modugno",
            "names": {
                "pl": "Modugno",
                "en": "Modugno",
                "ru": "Модуньо"
            },
            "geotag": "3173326",
            "post_code": "70026"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Moers",
            "names": {
                "de": "Moers",
                "en": "Moers",
                "ru": "Мёрс"
            },
            "geotag": "2870221",
            "post_code": "47441"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Mohács",
            "names": {
                "pl": "Mohacz",
                "de": "Mohatsch",
                "en": "Mohács",
                "ru": "Мохач"
            },
            "geotag": "3047967",
            "post_code": "7700"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Mol",
            "names": {
                "en": "Mol",
                "de": "Mol",
                "ru": "Мол"
            },
            "geotag": "2791067",
            "post_code": "2400"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Molfetta",
            "names": {
                "de": "Molfetta",
                "en": "Molfetta",
                "pl": "Molfetta",
                "ru": "Мольфетта"
            },
            "geotag": "3173287",
            "post_code": "70056"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Monfalcone",
            "names": {
                "pl": "Monfalcone",
                "de": "Monfalcone",
                "en": "Monfalcone",
                "ru": "Монфальконе"
            },
            "geotag": "3173153",
            "post_code": "34074"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Monopoli",
            "names": {
                "pl": "Monopoli",
                "de": "Monopoli",
                "en": "Monopoli",
                "ru": "Монополи"
            },
            "geotag": "3173131",
            "post_code": "70043"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Monreale",
            "names": {
                "en": "Monreale",
                "pl": "Monreale",
                "de": "Monreale",
                "ru": "Монреаль"
            },
            "geotag": "2524085",
            "post_code": "90046"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Mons",
            "names": {
                "de": "Mons",
                "en": "Mons",
                "pl": "Mons",
                "ru": "Монс"
            },
            "geotag": "2790869",
            "post_code": "7000"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Monterotondo",
            "names": {
                "pl": "Monterotondo",
                "en": "Monterotondo",
                "ru": "Монтеротондо"
            },
            "geotag": "3172768",
            "post_code": "00015"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Montevarchi",
            "names": {
                "pl": "Montevarchi",
                "en": "Montevarchi",
                "ru": "Монтеварки"
            },
            "geotag": "3172718",
            "post_code": "52025"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Monza",
            "names": {
                "de": "Monza",
                "en": "Monza",
                "pl": "Monza",
                "ru": "Монца"
            },
            "geotag": "3172629",
            "post_code": "20900"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Mosonmagyaróvár",
            "names": {
                "pl": "Mosonmagyaróvár",
                "en": "Mosonmagyaróvár",
                "de": "Wieselburg-Ungarisch Altenburg",
                "ru": "Мошонмадьяровар"
            },
            "geotag": "3047896",
            "post_code": "9200"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Most",
            "names": {
                "de": "Most",
                "pl": "Most",
                "en": "Most",
                "ru": "Мост"
            },
            "geotag": "3070291",
            "post_code": "434 01"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Mouscron",
            "names": {
                "en": "Mouscron",
                "pl": "Mouscron",
                "de": "Mouscron",
                "ru": "Мускрон"
            },
            "geotag": "2790595",
            "post_code": "7700"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Mysłowice",
            "names": {
                "pl": "Mysłowice",
                "en": "Mysłowice",
                "de": "Mysłowice",
                "ru": "Мысловице"
            },
            "geotag": "3091232",
            "post_code": "41-400"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Mödling",
            "names": {
                "de": "Mödling",
                "pl": "Mödling",
                "en": "Mödling",
                "ru": "Мёдлинг"
            },
            "geotag": "2771335",
            "post_code": "2340"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Mönchengladbach",
            "names": {
                "de": "Mönchengladbach",
                "en": "Mönchengladbach",
                "pl": "Mönchengladbach",
                "ru": "Мёнхенгладбах"
            },
            "geotag": "2869894",
            "post_code": "41061"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Mühlhausen",
            "names": {
                "de": "Mühlhausen",
                "en": "Mühlhausen",
                "pl": "Mühlhausen/Thüringen",
                "ru": "Мюльхаузен"
            },
            "geotag": "2867996",
            "post_code": "69242"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Mülheim",
            "names": {
                "de": "Muelheim an der Ruhr",
                "en": "Mülheim",
                "pl": "Mülheim an der Ruhr",
                "ru": "Мюльхайм-на-Руре"
            },
            "geotag": "2867838",
            "post_code": "45403"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Müllheim",
            "names": {
                "de": "Müllheim",
                "pl": "Müllheim",
                "en": "Müllheim",
                "ru": "Мюльхайм"
            },
            "geotag": "2867770",
            "post_code": "79379"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Münster",
            "names": {
                "de": "Münster / Nordrhein-Westf.",
                "en": "Münster",
                "pl": "Münster",
                "ru": "Мюнстер"
            },
            "geotag": "2867543",
            "post_code": "6232"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Mělník",
            "names": {
                "de": "Mělník",
                "pl": "Mělník",
                "en": "Mělník",
                "ru": "Мельник"
            },
            "geotag": "3070862",
            "post_code": "285 06"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Mława",
            "names": {
                "en": "Mława",
                "ru": "Млава",
                "de": "Mielau"
            },
            "geotag": "764634",
            "post_code": "06-500"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Nagykanizsa",
            "names": {
                "de": "Großkirchen",
                "en": "Nagykanizsa",
                "pl": "Nagykanizsa",
                "ru": "Надьканижа"
            },
            "geotag": "3047679",
            "post_code": "8800"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Namur",
            "names": {
                "de": "Namür",
                "en": "Namur",
                "pl": "Namur",
                "ru": "Намюр"
            },
            "geotag": "2790471",
            "post_code": "5000"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Naumburg",
            "names": {
                "de": "Naumburg",
                "pl": "Naumburg",
                "en": "Naumburg",
                "ru": "Наумбург"
            },
            "geotag": "2866906",
            "post_code": "34311"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Nettuno",
            "names": {
                "pl": "Nettuno",
                "en": "Nettuno",
                "de": "Nettuno",
                "ru": "Неттуно"
            },
            "geotag": "3172287",
            "post_code": "00048"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Neu-Ulm",
            "names": {
                "de": "Neu-Ulm",
                "pl": "Neu-Ulm",
                "en": "Neu-Ulm",
                "ru": "Ной-Ульм"
            },
            "geotag": "2863941",
            "post_code": "89231"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Neubrandenburg",
            "names": {
                "de": "Neubrandenburg",
                "pl": "Neubrandenburg",
                "en": "Neubrandenburg",
                "ru": "Нойбранденбург"
            },
            "geotag": "2866135",
            "post_code": "17033"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Neumünster",
            "names": {
                "de": "Neumünster",
                "pl": "Neumünster",
                "en": "Neumünster",
                "ru": "Ноймюнстер"
            },
            "geotag": "2864475",
            "post_code": "24534"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Neuruppin",
            "names": {
                "de": "Neuruppin",
                "en": "Neuruppin",
                "pl": "Neuruppin",
                "ru": "Нойруппин"
            },
            "geotag": "2864276",
            "post_code": "16816"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Neuss",
            "names": {
                "de": "Neuss",
                "en": "Neuss",
                "pl": "Neuss",
                "ru": "Нойс"
            },
            "geotag": "2864118",
            "post_code": "41460"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Neustrelitz",
            "names": {
                "de": "Neustrelitz",
                "en": "Neustrelitz",
                "pl": "Neustrelitz",
                "ru": "Нойштрелиц"
            },
            "geotag": "2864005",
            "post_code": "17235"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Neuwied",
            "names": {
                "de": "Neuwied",
                "en": "Neuwied",
                "pl": "Neuwied",
                "ru": "Нойвид"
            },
            "geotag": "2863840",
            "post_code": "56564"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Nicaea",
            "names": {
                "de": "İznik",
                "en": "Nicaea",
                "ru": "Изник"
            },
            "geotag": "745026",
            "post_code": "16860"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Nichelino",
            "names": {
                "pl": "Nichelino",
                "de": "Nichelino",
                "en": "Nichelino",
                "ru": "Никелино"
            },
            "geotag": "3172269",
            "post_code": "10042"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Nijmegen",
            "names": {
                "de": "Nijmegen",
                "en": "Nijmegen",
                "pl": "Nijmegen",
                "ru": "Неймеген"
            },
            "geotag": "2750053",
            "post_code": "6511"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Niscemi",
            "names": {
                "pl": "Niscemi",
                "de": "Niscemi",
                "en": "Niscemi",
                "ru": "Нишеми"
            },
            "geotag": "2524006",
            "post_code": "93015"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Nivelles",
            "names": {
                "en": "Nivelles",
                "de": "Nivelles",
                "pl": "Nivelles",
                "ru": "Нивель"
            },
            "geotag": "2790101",
            "post_code": "1400"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Norderstedt",
            "names": {
                "de": "Norderstedt",
                "en": "Norderstedt",
                "pl": "Norderstedt",
                "ru": "Нордерштедт"
            },
            "geotag": "2862026",
            "post_code": "22844"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Nordhausen",
            "names": {
                "de": "Nordhausen",
                "en": "Nordhausen",
                "pl": "Nordhausen",
                "ru": "Нордхаузен"
            },
            "geotag": "2861982",
            "post_code": "99734"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Noto",
            "names": {
                "en": "Noto",
                "pl": "Noto",
                "de": "Noto",
                "ru": "Ното"
            },
            "geotag": "2523998",
            "post_code": "96017"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Novara",
            "names": {
                "de": "Novara",
                "en": "Novara",
                "pl": "Novara",
                "ru": "Новара"
            },
            "geotag": "3172189",
            "post_code": "28100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Novi Ligure",
            "names": {
                "pl": "Novi Ligure",
                "de": "Novi Ligure",
                "en": "Novi Ligure",
                "ru": "Нови-Лигуре"
            },
            "geotag": "3172170",
            "post_code": "15067"
        },
        {
            "code": 7,
            "country_code": "SK",
            "label": "Nové Zámky",
            "names": {
                "de": "Nové Zámky",
                "en": "Nové Zámky",
                "ru": "Нове-Замки"
            },
            "geotag": "3058472",
            "post_code": "784 01"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Nowy Sącz",
            "names": {
                "pl": "Nowy Sącz",
                "de": "Nowy Sącz",
                "en": "Nowy Sącz",
                "ru": "Новы-Сонч"
            },
            "geotag": "763534",
            "post_code": "33-300"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Nowy Targ",
            "names": {
                "pl": "Nowy Targ",
                "en": "Nowy Targ",
                "de": "Nowy Targ",
                "ru": "Новы-Тарг"
            },
            "geotag": "763523",
            "post_code": "34-400"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Nuoro",
            "names": {
                "en": "Nuoro",
                "de": "Nuoro",
                "pl": "Nuoro",
                "ru": "Нуоро"
            },
            "geotag": "3172154",
            "post_code": "08100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Nuremberg",
            "names": {
                "en": "Nuremberg",
                "de": "Nürnberg",
                "pl": "Norymberga",
                "ru": "Нюрнберг"
            },
            "geotag": "2861650",
            "post_code": "90402"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Nysa",
            "names": {
                "de": "Neisse-Neuland",
                "pl": "Nysa",
                "en": "Nysa",
                "ru": "Ныса"
            },
            "geotag": "3090436",
            "post_code": "48-300"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Nördlingen",
            "names": {
                "de": "Nördlingen",
                "pl": "Nördlingen",
                "en": "Nördlingen",
                "ru": "Нёрдлинген"
            },
            "geotag": "2861914",
            "post_code": "86720"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Oberhausen",
            "names": {
                "de": "Oberhausen",
                "en": "Oberhausen",
                "pl": "Oberhausen",
                "ru": "Оберхаузен"
            },
            "geotag": "2860410",
            "post_code": "2301"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Offenburg",
            "names": {
                "de": "Offenburg",
                "pl": "Offenburg",
                "en": "Offenburg",
                "ru": "Оффенбург"
            },
            "geotag": "2857798",
            "post_code": "8761"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Oisterwijk",
            "names": {
                "en": "Oisterwijk",
                "de": "Oisterwijk",
                "ru": "Ойстервейк"
            },
            "geotag": "2749680",
            "post_code": "5061"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Olbia",
            "names": {
                "en": "Olbia",
                "ru": "Ольбия",
                "de": "Olbia"
            },
            "geotag": "3172087",
            "post_code": "07026"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Oldenburg",
            "names": {
                "de": "Oldenburg",
                "en": "Oldenburg",
                "pl": "Oldenburg",
                "ru": "Ольденбург"
            },
            "geotag": "2857458",
            "post_code": "26121"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Oldenzaal",
            "names": {
                "de": "Oldenzaal",
                "en": "Oldenzaal",
                "ru": "Олдензал"
            },
            "geotag": "2749644",
            "post_code": "7571"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Olecko",
            "names": {
                "de": "Treuburg",
                "en": "Olecko",
                "ru": "Олецко"
            },
            "geotag": "763291",
            "post_code": "19-400"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Olomouc",
            "names": {
                "de": "Olomouc",
                "en": "Olomouc",
                "pl": "Ołomuniec",
                "ru": "Оломоуц"
            },
            "geotag": "3069011",
            "post_code": "772 00"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Olot",
            "names": {
                "en": "Olot",
                "de": "Olot",
                "ru": "Олот"
            },
            "geotag": "3115093",
            "post_code": "17800"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Olsztyn",
            "names": {
                "de": "Olsztyn",
                "en": "Olsztyn",
                "ru": "Ольштын",
                "pl": "Olsztyn"
            },
            "geotag": "763166",
            "post_code": "42-256"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Oosterhout",
            "names": {
                "en": "Oosterhout",
                "de": "Oosterhout",
                "ru": "Остерхоут"
            },
            "geotag": "2749450",
            "post_code": "6678"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Oostkamp",
            "names": {
                "en": "Oostkamp",
                "de": "Oostkamp",
                "ru": "Осткамп"
            },
            "geotag": "2789751",
            "post_code": "8020"
        },
        {
            "code": 7,
            "country_code": "SK",
            "label": "Opava",
            "names": {
                "de": "Opava",
                "pl": "Opawa",
                "en": "Opava",
                "ru": "Опава"
            },
            "geotag": "3068927",
            "post_code": "58-420"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Opole",
            "names": {
                "pl": "Opole",
                "de": "Oppeln",
                "en": "Opole",
                "ru": "Ополе"
            },
            "geotag": "3090048",
            "post_code": "95-045"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Oranienburg",
            "names": {
                "de": "Oranienburg",
                "pl": "Oranienburg",
                "en": "Oranienburg",
                "ru": "Ораниенбург"
            },
            "geotag": "2857129",
            "post_code": "16515"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Orbassano",
            "names": {
                "pl": "Orbassano",
                "en": "Orbassano",
                "de": "Orbassano",
                "ru": "Орбассано"
            },
            "geotag": "3171986",
            "post_code": "10043"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Oristano",
            "names": {
                "de": "Oristano",
                "en": "Oristano",
                "pl": "Oristano",
                "ru": "Ористано"
            },
            "geotag": "2523964",
            "post_code": "09170"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Oschersleben",
            "names": {
                "de": "Oschersleben",
                "ru": "Ошерслебен",
                "en": "Oschersleben"
            },
            "geotag": "2856930",
            "post_code": "39387"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Osimo",
            "names": {
                "pl": "Osimo",
                "de": "Osimo",
                "en": "Osimo",
                "ru": "Осимо"
            },
            "geotag": "3171848",
            "post_code": "60027"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Osmaniye",
            "names": {
                "de": "Osmaniye",
                "en": "Osmaniye",
                "pl": "Osmaniye",
                "ru": "Османие"
            },
            "geotag": "303195",
            "post_code": "08690"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Osnabrück",
            "names": {
                "de": "Osnabrück",
                "en": "Osnabrück",
                "pl": "Osnabrück",
                "ru": "Оснабрюк"
            },
            "geotag": "2856883",
            "post_code": "49074"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Oss",
            "names": {
                "en": "Oss",
                "de": "Oss",
                "ru": "Осс"
            },
            "geotag": "2749234",
            "post_code": "5341"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Ostrowiec Świętokrzyski",
            "names": {
                "pl": "Ostrowiec nad Kamienną",
                "en": "Ostrowiec Świętokrzyski",
                "de": "Ostrowiec Świętokrzyski",
                "ru": "Островец-Свентокшиский"
            },
            "geotag": "762863",
            "post_code": "27-400"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Ostrołęka",
            "names": {
                "en": "Ostrołęka",
                "pl": "Ostrołęka",
                "de": "Ostrołęka",
                "ru": "Остроленка"
            },
            "geotag": "762909",
            "post_code": "98-338"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Ostróda",
            "names": {
                "de": "Osterode",
                "en": "Ostróda",
                "pl": "Ostróda",
                "ru": "Оструда"
            },
            "geotag": "3089779",
            "post_code": "38835"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Ostrów Wielkopolski",
            "names": {
                "pl": "Ostrowo",
                "en": "Ostrów Wielkopolski",
                "de": "Ostrów Wielkopolski",
                "ru": "Острув-Велькопольский"
            },
            "geotag": "3089684",
            "post_code": "88-121"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Ostuni",
            "names": {
                "pl": "Ostuni",
                "en": "Ostuni",
                "de": "Ostuni",
                "ru": "Остуни"
            },
            "geotag": "3171786",
            "post_code": "72017"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Otwock",
            "names": {
                "pl": "Otwock",
                "en": "Otwock",
                "de": "Otwock",
                "ru": "Отвоцк"
            },
            "geotag": "762788",
            "post_code": "05-400"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Oudenaarde",
            "names": {
                "en": "Oudenaarde",
                "de": "Oudenaarde",
                "ru": "Ауденарде"
            },
            "geotag": "2789529",
            "post_code": "9700"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Oświęcim",
            "names": {
                "pl": "Oświęcim",
                "de": "Auschwitz",
                "en": "Oświęcim",
                "ru": "Освенцим"
            },
            "geotag": "3089658",
            "post_code": "32-600"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Pabianice",
            "names": {
                "pl": "Pabianice",
                "de": "Pabianice",
                "en": "Pabianice",
                "ru": "Пабьянице"
            },
            "geotag": "3089578",
            "post_code": "92-200"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Pachino",
            "names": {
                "pl": "Pachino",
                "de": "Pachino",
                "en": "Pachino",
                "ru": "Пакино"
            },
            "geotag": "2523938",
            "post_code": "96018"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Paderborn",
            "names": {
                "de": "Paderborn",
                "en": "Paderborn",
                "pl": "Paderborn",
                "ru": "Падерборн"
            },
            "geotag": "2855745",
            "post_code": "33098"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Padova",
            "names": {
                "de": "Padua",
                "en": "Padova",
                "pl": "Padwa",
                "ru": "Падуя"
            },
            "geotag": "3171728",
            "post_code": "35100"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Palafrugell",
            "names": {
                "en": "Palafrugell",
                "de": "Palafrugell",
                "ru": "Палафружель"
            },
            "geotag": "3114567",
            "post_code": "17200"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Palermo",
            "names": {
                "de": "Palermo",
                "en": "Palermo",
                "pl": "Palermo",
                "ru": "Палермо"
            },
            "geotag": "2523920",
            "post_code": "90100"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Parchim",
            "names": {
                "ru": "Пархим",
                "en": "Parchim",
                "de": "Parchim"
            },
            "geotag": "2855441",
            "post_code": "19370"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Pardubice",
            "names": {
                "de": "Pardubice",
                "en": "Pardubice",
                "pl": "Pardubice",
                "ru": "Пардубице"
            },
            "geotag": "3068582",
            "post_code": "530 12"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Parma",
            "names": {
                "de": "Parma",
                "en": "Parma",
                "pl": "Parma",
                "ru": "Парма"
            },
            "geotag": "3171457",
            "post_code": "43100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Passau",
            "names": {
                "en": "Passau",
                "de": "Passau",
                "pl": "Pasawa",
                "ru": "Пассау"
            },
            "geotag": "2855328",
            "post_code": "9640"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Pavia",
            "names": {
                "en": "Pavia",
                "pl": "Pawia",
                "de": "Pavia",
                "ru": "Павия"
            },
            "geotag": "3171366",
            "post_code": "25213"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Peine",
            "names": {
                "ru": "Пайне",
                "en": "Peine",
                "de": "Peine"
            },
            "geotag": "2855047",
            "post_code": "31224"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Perugia",
            "names": {
                "en": "Perugia",
                "de": "Perugia",
                "pl": "Perugia",
                "ru": "Перуджа"
            },
            "geotag": "3171180",
            "post_code": "06100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Pesaro",
            "names": {
                "pl": "Pesaro",
                "de": "Pesaro",
                "en": "Pesaro",
                "ru": "Пезаро"
            },
            "geotag": "3171173",
            "post_code": "61100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Pescara",
            "names": {
                "pl": "Pescara",
                "de": "Pescara",
                "en": "Pescara",
                "ru": "Пескара"
            },
            "geotag": "3171168",
            "post_code": "65100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Pforzheim",
            "names": {
                "de": "Pforzheim",
                "en": "Pforzheim",
                "pl": "Pforzheim",
                "ru": "Пфорцхайм"
            },
            "geotag": "2853969",
            "post_code": "75172"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Piacenza",
            "names": {
                "de": "Piacenza",
                "en": "Piacenza",
                "pl": "Piacenza",
                "ru": "Пьяченца"
            },
            "geotag": "3171058",
            "post_code": "29100"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Piaseczno",
            "names": {
                "en": "Piaseczno",
                "pl": "Piaseczno",
                "de": "Piaseczno",
                "ru": "Пясечно"
            },
            "geotag": "762423",
            "post_code": "87-603"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Pietrasanta",
            "names": {
                "pl": "Pietrasanta",
                "de": "Pietrasanta",
                "en": "Pietrasanta",
                "ru": "Пиетрасанта"
            },
            "geotag": "3170778",
            "post_code": "55045"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Pinerolo",
            "names": {
                "pl": "Pinerolo",
                "de": "Pinerolo",
                "en": "Pinerolo",
                "ru": "Пинероло"
            },
            "geotag": "3170694",
            "post_code": "10064"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Piombino",
            "names": {
                "en": "Piombino",
                "pl": "Piombino",
                "de": "Piombino",
                "ru": "Пьомбино"
            },
            "geotag": "3170674",
            "post_code": "57025"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Piotrkow Trybunalski",
            "names": {
                "pl": "Piotrków Trybunalski",
                "en": "Piotrkow Trybunalski",
                "de": "Piotrków Trybunalski",
                "ru": "Пётркув-Трыбунальский"
            },
            "geotag": "3088972",
            "post_code": "97-300"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Pirmasens",
            "names": {
                "de": "Pirmasens",
                "en": "Pirmasens",
                "ru": "Пирмазенс"
            },
            "geotag": "2853574",
            "post_code": "66953"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Pisa",
            "names": {
                "en": "Pisa",
                "de": "Pisa",
                "pl": "Piza",
                "ru": "Пиза"
            },
            "geotag": "3170647",
            "post_code": "56100"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Pistoia",
            "names": {
                "de": "Pistoia",
                "en": "Pistoia",
                "pl": "Pistoia",
                "ru": "Пистойя"
            },
            "geotag": "3170621",
            "post_code": "51100"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Plauen",
            "names": {
                "pl": "Plauen",
                "de": "Plauen",
                "en": "Plauen",
                "ru": "Плауэн"
            },
            "geotag": "2853292",
            "post_code": "08523"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Poggibonsi",
            "names": {
                "pl": "Poggibonsi",
                "de": "Poggibonsi",
                "en": "Poggibonsi",
                "ru": "Поджибонси"
            },
            "geotag": "3170504",
            "post_code": "53036"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Police",
            "names": {
                "pl": "Police",
                "de": "Police",
                "en": "Police",
                "ru": "Полице"
            },
            "geotag": "3088461",
            "post_code": "675 34"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Polkowice",
            "names": {
                "de": "Polkowice",
                "pl": "Polkowice",
                "en": "Polkowice",
                "ru": "Польковице"
            },
            "geotag": "3088435",
            "post_code": "59-100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Pordenone",
            "names": {
                "pl": "Pordenone",
                "de": "Pordenone",
                "en": "Pordenone",
                "ru": "Порденоне"
            },
            "geotag": "3170147",
            "post_code": "33170"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Portici",
            "names": {
                "pl": "Portici",
                "de": "Portici",
                "en": "Portici",
                "ru": "Портичи"
            },
            "geotag": "3170116",
            "post_code": "80055"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Potsdam",
            "names": {
                "de": "Potsdam",
                "en": "Potsdam",
                "pl": "Poczdam",
                "ru": "Потсдам"
            },
            "geotag": "2852458",
            "post_code": "14461"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Poznan",
            "names": {
                "de": "Poßen",
                "ru": "Познань",
                "en": "Poznan",
                "pl": "Poznań"
            },
            "geotag": "3088171",
            "post_code": "21-413"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Prato",
            "names": {
                "de": "Prato",
                "pl": "Prato",
                "en": "Prato",
                "ru": "Прато"
            },
            "geotag": "3169921",
            "post_code": "42015"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Prostějov",
            "names": {
                "de": "Prossnitz",
                "pl": "Prościejów",
                "en": "Prostějov",
                "ru": "Простеёв"
            },
            "geotag": "3067421",
            "post_code": "796 01"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Pruszków",
            "names": {
                "pl": "Pruszków",
                "en": "Pruszków",
                "de": "Pruszków",
                "ru": "Прушкув"
            },
            "geotag": "761228",
            "post_code": "98-160"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Przeworsk",
            "names": {
                "pl": "Przeworsk",
                "en": "Przeworsk",
                "de": "Przeworsk",
                "ru": "Пшеворск"
            },
            "geotag": "761131",
            "post_code": "37-200"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Pszczyna",
            "names": {
                "de": "Pszczyna",
                "pl": "Pszczyna",
                "en": "Pszczyna",
                "ru": "Пщина"
            },
            "geotag": "3087705",
            "post_code": "43-100"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Purmerend",
            "names": {
                "en": "Purmerend",
                "de": "Purmerend",
                "ru": "Пюрмеренд"
            },
            "geotag": "2748413",
            "post_code": "1441"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Putignano",
            "names": {
                "pl": "Putignano",
                "en": "Putignano",
                "ru": "Путиньяно"
            },
            "geotag": "3169742",
            "post_code": "70017"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Puławy",
            "names": {
                "pl": "Nowo-Aleksandria",
                "en": "Puławy",
                "de": "Puławy",
                "ru": "Новая Александрия"
            },
            "geotag": "760924",
            "post_code": "24-100"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Pułtusk",
            "names": {
                "en": "Pułtusk",
                "pl": "Pułtusk",
                "de": "Pułtusk",
                "ru": "Пултуск"
            },
            "geotag": "760917",
            "post_code": "06-100"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Pécs",
            "names": {
                "de": "Pecs",
                "en": "Pécs",
                "pl": "Pecz",
                "ru": "Печ"
            },
            "geotag": "3046526",
            "post_code": "7600"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Písek",
            "names": {
                "de": "Písek",
                "pl": "Písek",
                "en": "Písek",
                "ru": "Писек"
            },
            "geotag": "3068293",
            "post_code": "397 01"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Płock",
            "names": {
                "en": "Płock",
                "pl": "Płock",
                "de": "Płock",
                "ru": "Плоцк"
            },
            "geotag": "3088825",
            "post_code": "09-400"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Płońsk",
            "names": {
                "en": "Płońsk",
                "pl": "Płońsk",
                "de": "Płońsk",
                "ru": "Плоньск"
            },
            "geotag": "762021",
            "post_code": "00-100"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Příbram",
            "names": {
                "de": "Příbram",
                "pl": "Przybram",
                "en": "Příbram",
                "ru": "Пршибрам"
            },
            "geotag": "3067542",
            "post_code": "664 84"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Quedlinburg",
            "names": {
                "de": "Quedlinburg",
                "en": "Quedlinburg",
                "pl": "Quedlinburg",
                "ru": "Кведлинбург"
            },
            "geotag": "2851465",
            "post_code": "06484"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Raalte",
            "names": {
                "en": "Raalte",
                "de": "Raalte",
                "ru": "Раалт"
            },
            "geotag": "2748371",
            "post_code": "8101"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Racibórz",
            "names": {
                "pl": "Racibórz",
                "de": "Ratibor",
                "en": "Racibórz",
                "ru": "Рацибуж"
            },
            "geotag": "3087584",
            "post_code": "47-400"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Radom",
            "names": {
                "de": "Radom",
                "pl": "Radom",
                "en": "Radom",
                "ru": "Радом"
            },
            "geotag": "760778",
            "post_code": "26-600"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Radomsko",
            "names": {
                "pl": "Radomsko",
                "de": "Radomsko",
                "en": "Radomsko",
                "ru": "Радомско"
            },
            "geotag": "3087497",
            "post_code": "97-500"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Ragusa",
            "names": {
                "de": "Ragusa",
                "pl": "Ragusa",
                "en": "Ragusa",
                "ru": "Рагуза"
            },
            "geotag": "2523650",
            "post_code": "97100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Rapallo",
            "names": {
                "pl": "Rapallo",
                "de": "Rapallo",
                "en": "Rapallo",
                "ru": "Рапалло"
            },
            "geotag": "3169602",
            "post_code": "16035"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Rastatt",
            "names": {
                "de": "Rastatt",
                "en": "Rastatt",
                "ru": "Раштатт"
            },
            "geotag": "2850257",
            "post_code": "76437"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Ratingen",
            "names": {
                "de": "Ratingen",
                "en": "Ratingen",
                "ru": "Ратинген"
            },
            "geotag": "2850174",
            "post_code": "40832"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Ravenna",
            "names": {
                "de": "Ravenna",
                "en": "Ravenna",
                "pl": "Rawenna",
                "ru": "Равенна"
            },
            "geotag": "3169561",
            "post_code": "48100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Ravensburg",
            "names": {
                "de": "Ravensburg",
                "pl": "Ravensburg",
                "en": "Ravensburg",
                "ru": "Равенсбург"
            },
            "geotag": "2849802",
            "post_code": "88212"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Rawicz",
            "names": {
                "pl": "Rawicz",
                "en": "Rawicz",
                "de": "Rawicz",
                "ru": "Равич"
            },
            "geotag": "3087307",
            "post_code": "97-403"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Recklinghausen",
            "names": {
                "de": "Recklinghausen",
                "en": "Recklinghausen",
                "pl": "Recklinghausen",
                "ru": "Реклингхаузен"
            },
            "geotag": "2849647",
            "post_code": "45657"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Regensburg",
            "names": {
                "de": "Regensburg",
                "en": "Regensburg",
                "pl": "Ratyzbona",
                "ru": "Регенсбург"
            },
            "geotag": "2849483",
            "post_code": "93047"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Reggio Calabria",
            "names": {
                "en": "Reggio Calabria",
                "pl": "Reggio di Calabria",
                "de": "Reggio di Calabria",
                "ru": "Реджо-ди-Калабрия"
            },
            "geotag": "2523630",
            "post_code": "89100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Remscheid",
            "names": {
                "de": "Remscheid",
                "en": "Remscheid",
                "pl": "Remscheid",
                "ru": "Ремшайд"
            },
            "geotag": "2848273",
            "post_code": "42853"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Rendsburg",
            "names": {
                "de": "Rendsburg",
                "en": "Rendsburg",
                "pl": "Rendsburg",
                "ru": "Рендсбург"
            },
            "geotag": "2848245",
            "post_code": "24768"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Reus",
            "names": {
                "de": "Reus",
                "en": "Reus",
                "pl": "Reus",
                "ru": "Реус"
            },
            "geotag": "3111933",
            "post_code": "43200"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Reutlingen",
            "names": {
                "de": "Reutlingen",
                "en": "Reutlingen",
                "pl": "Reutlingen",
                "ru": "Ройтлинген"
            },
            "geotag": "2847736",
            "post_code": "72760"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Rheine",
            "names": {
                "en": "Rheine",
                "de": "Rheine",
                "ru": "Райне"
            },
            "geotag": "2847645",
            "post_code": "48429"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Rheinfelden",
            "names": {
                "de": "Rheinfelden",
                "pl": "Rheinfelden",
                "en": "Rheinfelden",
                "ru": "Райнфельден"
            },
            "geotag": "2847639",
            "post_code": "79618"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Rho",
            "names": {
                "pl": "Rho",
                "de": "Rho",
                "en": "Rho",
                "ru": "Ро"
            },
            "geotag": "3169447",
            "post_code": "20017"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Ribera",
            "names": {
                "pl": "Ribera",
                "de": "Ribera",
                "en": "Ribera",
                "ru": "Рибера"
            },
            "geotag": "2523619",
            "post_code": "01427"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Riccione",
            "names": {
                "pl": "Riccione",
                "de": "Riccione",
                "en": "Riccione",
                "ru": "Риччоне"
            },
            "geotag": "3169424",
            "post_code": "47838"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Rieti",
            "names": {
                "pl": "Rieti",
                "de": "Rieti",
                "en": "Rieti",
                "ru": "Риети"
            },
            "geotag": "3169412",
            "post_code": "02100"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Rimini",
            "names": {
                "de": "Rimini",
                "en": "Rimini",
                "pl": "Rimini",
                "ru": "Римини"
            },
            "geotag": "3169361",
            "post_code": "47900"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Rivoli",
            "names": {
                "pl": "Rivoli",
                "de": "Rivoli",
                "en": "Rivoli",
                "ru": "Риволи"
            },
            "geotag": "3169231",
            "post_code": "10098"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Roermond",
            "names": {
                "de": "Roermond",
                "en": "Roermond",
                "pl": "Roermond",
                "ru": "Рурмонд"
            },
            "geotag": "2748000",
            "post_code": "6041"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Roeselare",
            "names": {
                "en": "Roeselare",
                "pl": "Roeselare",
                "de": "Roeselare",
                "ru": "Руселаре"
            },
            "geotag": "2787889",
            "post_code": "8800"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Roosendaal",
            "names": {
                "en": "Roosendaal",
                "de": "Roosendaal",
                "ru": "Розендал"
            },
            "geotag": "2747930",
            "post_code": "4701"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Rosenheim",
            "names": {
                "de": "Rosenheim",
                "en": "Rosenheim",
                "pl": "Rosenheim",
                "ru": "Розенхайм"
            },
            "geotag": "2844988",
            "post_code": "9805"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Roses",
            "names": {
                "en": "Roses",
                "de": "Roses",
                "ru": "Росас"
            },
            "geotag": "3111348",
            "post_code": "17480"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Rostock",
            "names": {
                "de": "Rostock",
                "en": "Rostock",
                "pl": "Rostock",
                "ru": "Росток"
            },
            "geotag": "2844588",
            "post_code": "8530"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Roth",
            "names": {
                "de": "Roth",
                "en": "Roth",
                "pl": "Roth",
                "ru": "Рот"
            },
            "geotag": "2844265",
            "post_code": "91154"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Rotterdam",
            "names": {
                "de": "Rotterdam",
                "en": "Rotterdam",
                "pl": "Rotterdam",
                "ru": "Роттердам"
            },
            "geotag": "2747891",
            "post_code": "3011"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Rottweil",
            "names": {
                "de": "Rottweil",
                "pl": "Rottweil",
                "en": "Rottweil",
                "ru": "Ротвайль"
            },
            "geotag": "2843636",
            "post_code": "78628"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Rovereto",
            "names": {
                "pl": "Rovereto",
                "de": "Rovereto",
                "en": "Rovereto",
                "ru": "Роверето"
            },
            "geotag": "3168854",
            "post_code": "26010"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Rovigo",
            "names": {
                "de": "Rovigo",
                "pl": "Rovigo",
                "en": "Rovigo",
                "ru": "Ровиго"
            },
            "geotag": "3168843",
            "post_code": "45100"
        },
        {
            "code": 6,
            "country_code": "SK",
            "label": "Rožňava",
            "names": {
                "pl": "Rožňava",
                "de": "Rosenau",
                "en": "Rožňava",
                "ru": "Рожнява"
            },
            "geotag": "723713",
            "post_code": "9062"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Ruda Śląska",
            "names": {
                "pl": "Ruda Śląska",
                "en": "Ruda Śląska",
                "de": "Ruda O.S.",
                "ru": "Руда-Слёнская"
            },
            "geotag": "3086800",
            "post_code": "41-700"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Rybnik",
            "names": {
                "pl": "Rybnik",
                "en": "Rybnik",
                "de": "Rybnik",
                "ru": "Рыбник"
            },
            "geotag": "3086586",
            "post_code": "99-150"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Rydułtowy",
            "names": {
                "pl": "Rydułtowy",
                "en": "Rydułtowy",
                "de": "Rydułtowy",
                "ru": "Рыдултовы"
            },
            "geotag": "3086531",
            "post_code": "44-280"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Rzeszów",
            "names": {
                "pl": "Rzeszów",
                "de": "Rzeszów",
                "en": "Rzeszów",
                "ru": "Жешув"
            },
            "geotag": "759734",
            "post_code": "35-212"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Saarbrücken",
            "names": {
                "de": "Saarbrücken",
                "en": "Saarbrücken",
                "pl": "Saarbrücken",
                "ru": "Саарбрюккен"
            },
            "geotag": "2842647",
            "post_code": "66111"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Saarlouis",
            "names": {
                "de": "Saarlouis",
                "en": "Saarlouis",
                "ru": "Зарлуи"
            },
            "geotag": "2842632",
            "post_code": "66740"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Saint-Gilles",
            "names": {
                "en": "Saint-Gilles",
                "de": "Saint-Gilles/Sint-Gillis",
                "ru": "Сен-Жиль"
            },
            "geotag": "2787413",
            "post_code": "1060"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Salerno",
            "names": {
                "en": "Salerno",
                "ru": "Салерно",
                "de": "Salern"
            },
            "geotag": "3168673",
            "post_code": "84100"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Salou",
            "names": {
                "en": "Salou",
                "de": "Salou",
                "ru": "Салоу"
            },
            "geotag": "3110986",
            "post_code": "43840"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Salzburg",
            "names": {
                "de": "Salzburg",
                "en": "Salzburg",
                "pl": "Salzburg",
                "ru": "Зальцбург"
            },
            "geotag": "2766824",
            "post_code": "5020"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Salzgitter",
            "names": {
                "de": "Salzgitter",
                "en": "Salzgitter",
                "pl": "Salzgitter",
                "ru": "Зальцгиттер"
            },
            "geotag": "2842150",
            "post_code": "38226"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Sandomierz",
            "names": {
                "pl": "Sandomierz",
                "en": "Sandomierz",
                "de": "Sandomierz",
                "ru": "Сандомир"
            },
            "geotag": "759603",
            "post_code": "27-600"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Sanok",
            "names": {
                "pl": "Sanok",
                "en": "Sanok",
                "de": "Saanig",
                "ru": "Санок"
            },
            "geotag": "759591",
            "post_code": "38-500"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Santa Maria Capua Vetere",
            "names": {
                "pl": "Santa Maria Capua Vetere",
                "de": "Santa Maria Capua Vetere",
                "en": "Santa Maria Capua Vetere",
                "ru": "Санта-Мария-Капуа-Ветере"
            },
            "geotag": "3167561",
            "post_code": "81055"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Sarno",
            "names": {
                "pl": "Sarno",
                "de": "Sarno",
                "en": "Sarno",
                "ru": "Сарно"
            },
            "geotag": "3167116",
            "post_code": "84087"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Sassari",
            "names": {
                "de": "Sassari",
                "en": "Sassari",
                "pl": "Sassari",
                "ru": "Сассари"
            },
            "geotag": "3167096",
            "post_code": "07100"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Sassuolo",
            "names": {
                "pl": "Sassuolo",
                "en": "Sassuolo",
                "ru": "Сассуоло"
            },
            "geotag": "3167053",
            "post_code": "41049"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Savona",
            "names": {
                "pl": "Savona",
                "de": "Savona",
                "en": "Savona",
                "ru": "Савона"
            },
            "geotag": "3167022",
            "post_code": "17100"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Scandicci",
            "names": {
                "pl": "Scandicci",
                "en": "Scandicci",
                "ru": "Скандиччи"
            },
            "geotag": "3166988",
            "post_code": "50018"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Schiedam",
            "names": {
                "en": "Schiedam",
                "de": "Schiedam",
                "pl": "Schiedam",
                "ru": "Схидам"
            },
            "geotag": "2747596",
            "post_code": "3111"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Schio",
            "names": {
                "pl": "Schio",
                "de": "Schio",
                "en": "Schio",
                "ru": "Скио"
            },
            "geotag": "3166917",
            "post_code": "36015"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Schweinfurt",
            "names": {
                "de": "Schweinfurt",
                "pl": "Schweinfurt",
                "en": "Schweinfurt",
                "ru": "Швайнфурт"
            },
            "geotag": "2834498",
            "post_code": "97412"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Schwerin",
            "names": {
                "de": "Schwerin",
                "en": "Schwerin",
                "pl": "Schwerin",
                "ru": "Шверин"
            },
            "geotag": "2834282",
            "post_code": "15755"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Schwäbisch Gmünd",
            "names": {
                "de": "Schwäbisch Gmünd",
                "en": "Schwäbisch Gmünd",
                "ru": "Швебиш-Гмюнд"
            },
            "geotag": "2835482",
            "post_code": "73525"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Scicli",
            "names": {
                "pl": "Scicli",
                "de": "Scicli",
                "en": "Scicli",
                "ru": "Шикли"
            },
            "geotag": "2523192",
            "post_code": "97018"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Senigallia",
            "names": {
                "de": "Senigallia",
                "pl": "Senigallia",
                "en": "Senigallia",
                "ru": "Сенигаллия"
            },
            "geotag": "3166740",
            "post_code": "60019"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Seraing",
            "names": {
                "en": "Seraing",
                "pl": "Seraing",
                "de": "Seraing",
                "ru": "Серен"
            },
            "geotag": "2786824",
            "post_code": "4100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Seriate",
            "names": {
                "pl": "Seriate",
                "en": "Seriate",
                "ru": "Сериате"
            },
            "geotag": "3166706",
            "post_code": "24068"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Siedlce",
            "names": {
                "en": "Siedlce",
                "pl": "Siedlce",
                "de": "Siedlce",
                "ru": "Седльце"
            },
            "geotag": "759412",
            "post_code": "59-300"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Siegburg",
            "names": {
                "de": "Siegburg",
                "pl": "Siegburg",
                "en": "Siegburg",
                "ru": "Зигбург"
            },
            "geotag": "2832521",
            "post_code": "53721"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Siegen",
            "names": {
                "de": "Siegen",
                "en": "Siegen",
                "pl": "Siegen",
                "ru": "Зиген"
            },
            "geotag": "2832495",
            "post_code": "57072"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Siemianowice Śląskie",
            "names": {
                "pl": "Siemianowice Śląskie",
                "en": "Siemianowice Śląskie",
                "de": "Siemianowice Śląskie",
                "ru": "Семяновице-Слёнске"
            },
            "geotag": "3086024",
            "post_code": "40-151"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Siemiatycze",
            "names": {
                "pl": "Siemiatycze",
                "en": "Siemiatycze",
                "ru": "Семятыче"
            },
            "geotag": "759320",
            "post_code": "17-300"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Sienna",
            "names": {
                "en": "Sienna",
                "de": "Siena",
                "pl": "Siena",
                "ru": "Сиена"
            },
            "geotag": "3166548",
            "post_code": "53100"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Sieradz",
            "names": {
                "pl": "Sieradz",
                "en": "Sieradz",
                "de": "Sieradz",
                "ru": "Серадз"
            },
            "geotag": "3085978",
            "post_code": "98-200"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Sigmaringen",
            "names": {
                "de": "Sigmaringen",
                "en": "Sigmaringen",
                "pl": "Sigmaringen",
                "ru": "Зигмаринген"
            },
            "geotag": "2832232",
            "post_code": "72488"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Sindelfingen",
            "names": {
                "de": "Sindelfingen",
                "pl": "Sindelfingen",
                "en": "Sindelfingen",
                "ru": "Зиндельфинген"
            },
            "geotag": "2831948",
            "post_code": "71063"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Sint-Niklaas",
            "names": {
                "en": "Sint-Niklaas",
                "pl": "Sint-Niklaas",
                "de": "Sint-Niklaas",
                "ru": "Синт-Никлас"
            },
            "geotag": "2786578",
            "post_code": "9100"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Sint-Truiden",
            "names": {
                "en": "Sint-Truiden",
                "pl": "Sint-Truiden",
                "de": "Sint-Truiden",
                "ru": "Синт-Трёйден"
            },
            "geotag": "2786545",
            "post_code": "3800"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Sitges",
            "names": {
                "pl": "Sitges",
                "en": "Sitges",
                "de": "Sitges",
                "ru": "Ситжес"
            },
            "geotag": "3108877",
            "post_code": "08870"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Siófok",
            "names": {
                "pl": "Siófok",
                "de": "Siofok",
                "en": "Siófok",
                "ru": "Шиофок"
            },
            "geotag": "3045332",
            "post_code": "8600"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Skierniewice",
            "names": {
                "pl": "Skierniewice",
                "de": "Skierniewice",
                "en": "Skierniewice",
                "ru": "Скерневице"
            },
            "geotag": "759123",
            "post_code": "96-100"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Sneek",
            "names": {
                "en": "Sneek",
                "de": "Sneek",
                "ru": "Снек"
            },
            "geotag": "2747063",
            "post_code": "8601"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Soest",
            "names": {
                "de": "Soest",
                "en": "Soest",
                "pl": "Soest",
                "ru": "Зост"
            },
            "geotag": "2831708",
            "post_code": "59494"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Sokolov",
            "names": {
                "de": "Sokolov",
                "pl": "Sokolov",
                "en": "Sokolov",
                "ru": "Соколов"
            },
            "geotag": "3065617",
            "post_code": "356 01"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Solingen",
            "names": {
                "de": "Solingen",
                "en": "Solingen",
                "pl": "Solingen",
                "ru": "Золинген"
            },
            "geotag": "2831580",
            "post_code": "42651"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Sondrio",
            "names": {
                "en": "Sondrio",
                "de": "Sondrio",
                "pl": "Sondrio",
                "ru": "Сондрио"
            },
            "geotag": "3166397",
            "post_code": "23100"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Sopot",
            "names": {
                "de": "Sopot",
                "en": "Sopot",
                "pl": "Sopot",
                "ru": "Сопот"
            },
            "geotag": "3085151",
            "post_code": "81-702"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Sopron",
            "names": {
                "de": "Sopron",
                "en": "Sopron",
                "pl": "Sopron",
                "ru": "Шопрон"
            },
            "geotag": "3045190",
            "post_code": "9400"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Sora",
            "names": {
                "en": "Sora",
                "pl": "Sora",
                "de": "Sora",
                "ru": "Сора"
            },
            "geotag": "3166387",
            "post_code": "08588"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Sosnowiec",
            "names": {
                "pl": "Sosnowiec",
                "en": "Sosnowiec",
                "de": "Sosnowiec",
                "ru": "Сосновец"
            },
            "geotag": "3085128",
            "post_code": "95-010"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Spires",
            "names": {
                "de": "Speyer",
                "en": "Spires",
                "pl": "Spira",
                "ru": "Шпайер"
            },
            "geotag": "2830582",
            "post_code": "67346"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Spoleto",
            "names": {
                "pl": "Spoleto",
                "en": "Spoleto",
                "de": "Spoleto",
                "ru": "Сполето"
            },
            "geotag": "3166236",
            "post_code": "06049"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Stade",
            "names": {
                "de": "Stade",
                "en": "Stade",
                "pl": "Stade",
                "ru": "Штаде"
            },
            "geotag": "2829901",
            "post_code": "21680"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Stalowa Wola",
            "names": {
                "pl": "Stalowa Wola",
                "en": "Stalowa Wola",
                "de": "Stalowa Wola",
                "ru": "Сталёва-Воля"
            },
            "geotag": "758445",
            "post_code": "37-450"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Starachowice",
            "names": {
                "pl": "Starachowice",
                "en": "Starachowice",
                "de": "Starachowice",
                "ru": "Стараховице"
            },
            "geotag": "758390",
            "post_code": "27-200"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Stargard",
            "names": {
                "pl": "Stargard Szczeciński",
                "de": "Stargard",
                "en": "Stargard",
                "ru": "Старгард"
            },
            "geotag": "3084840",
            "post_code": "73-102"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Stendal",
            "names": {
                "de": "Stendal",
                "pl": "Stendal",
                "en": "Stendal",
                "ru": "Штендаль"
            },
            "geotag": "2827479",
            "post_code": "39576"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Steyr",
            "names": {
                "de": "Steyr",
                "pl": "Steyr",
                "en": "Steyr",
                "ru": "Штайр"
            },
            "geotag": "2764359",
            "post_code": "4400"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Stralsund",
            "names": {
                "de": "Stralsund",
                "en": "Stralsund",
                "pl": "Stralsund",
                "ru": "Штральзунд"
            },
            "geotag": "2826287",
            "post_code": "18435"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Straubing",
            "names": {
                "de": "Straubing",
                "pl": "Straubing",
                "en": "Straubing",
                "ru": "Штраубинг"
            },
            "geotag": "2826099",
            "post_code": "94315"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Stuttgart",
            "names": {
                "de": "Stuttgart",
                "en": "Stuttgart",
                "pl": "Stuttgart",
                "ru": "Штутгарт"
            },
            "geotag": "2825297",
            "post_code": "70173"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Suhl",
            "names": {
                "de": "Suhl",
                "pl": "Suhl",
                "en": "Suhl",
                "ru": "Зуль"
            },
            "geotag": "2824948",
            "post_code": "98527"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Sulmona",
            "names": {
                "pl": "Sulmona",
                "de": "Sulmona",
                "en": "Sulmona",
                "ru": "Сулмона"
            },
            "geotag": "3166034",
            "post_code": "67039"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Suwałki",
            "names": {
                "en": "Suwałki",
                "pl": "Suwałki",
                "de": "Suwałki",
                "ru": "Сувалки"
            },
            "geotag": "757718",
            "post_code": "16-400"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Svitavy",
            "names": {
                "de": "Svitavy",
                "pl": "Svitavy",
                "en": "Svitavy",
                "ru": "Свитави"
            },
            "geotag": "3064454",
            "post_code": "568 02"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Swidnica",
            "names": {
                "pl": "Świdnica",
                "en": "Swidnica",
                "de": "Schweidnitz",
                "ru": "Свидница"
            },
            "geotag": "3084093",
            "post_code": "58-100"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Szamotuły",
            "names": {
                "pl": "Szamotuły",
                "de": "Samter",
                "en": "Szamotuły",
                "ru": "Шамотулы"
            },
            "geotag": "3083878",
            "post_code": "64-500"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Szarvas",
            "names": {
                "de": "Hirschfeld",
                "pl": "Szarvas",
                "en": "Szarvas",
                "ru": "Сарваш"
            },
            "geotag": "715466",
            "post_code": "04932"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Szczecin",
            "names": {
                "pl": "Szczecin",
                "de": "Stettin",
                "en": "Szczecin",
                "ru": "Щецин"
            },
            "geotag": "3083829",
            "post_code": "87-860"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Szekszárd",
            "names": {
                "pl": "Szekszárd",
                "de": "Sechshard",
                "en": "Szekszárd",
                "ru": "Сексард"
            },
            "geotag": "3044760",
            "post_code": "7100"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Szentendre",
            "names": {
                "pl": "Szentendre",
                "en": "Szentendre",
                "de": "Szentendre",
                "ru": "Сентендре"
            },
            "geotag": "3044681",
            "post_code": "2000"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Szolnok",
            "names": {
                "de": "Szolnok",
                "en": "Szolnok",
                "pl": "Szolnok",
                "ru": "Сольнок"
            },
            "geotag": "715126",
            "post_code": "5000"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Szombathely",
            "names": {
                "de": "Szombathely",
                "en": "Szombathely",
                "pl": "Szombathely",
                "ru": "Сомбатхей"
            },
            "geotag": "3044310",
            "post_code": "9700"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Székesfehérvár",
            "names": {
                "de": "Stuhlweißenburg",
                "en": "Székesfehérvár",
                "pl": "Székesfehérvár",
                "ru": "Секешфехервар"
            },
            "geotag": "3044774",
            "post_code": "8000"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Sátoraljaújhely",
            "names": {
                "de": "Neustadt am Zeltberg",
                "pl": "Sátoraljaújhely",
                "en": "Sátoraljaújhely",
                "ru": "Шаторальяуйхей"
            },
            "geotag": "715839",
            "post_code": "3944"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Słubice",
            "names": {
                "de": "Zliwitz",
                "pl": "Zliwice",
                "en": "Słubice",
                "ru": "Слубице"
            },
            "geotag": "3085495",
            "post_code": "69-100"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Słupsk",
            "names": {
                "de": "Słupsk",
                "en": "Słupsk",
                "pl": "Słupsk",
                "ru": "Слупск"
            },
            "geotag": "3085450",
            "post_code": "76-200"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Taranto",
            "names": {
                "de": "Tarent",
                "en": "Taranto",
                "pl": "Tarent",
                "ru": "Таранто"
            },
            "geotag": "3165926",
            "post_code": "74100"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Tarnobrzeg",
            "names": {
                "pl": "Tarnobrzeg",
                "en": "Tarnobrzeg",
                "de": "Tarnobrzeg",
                "ru": "Тарнобжег"
            },
            "geotag": "757033",
            "post_code": "39-400"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Tarnów",
            "names": {
                "pl": "Tarnów",
                "en": "Tarnów",
                "de": "Tarnów",
                "ru": "Тарнув"
            },
            "geotag": "757026",
            "post_code": "57-200"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Tarragona",
            "names": {
                "de": "Tarragona",
                "en": "Tarragona",
                "pl": "Tarragona",
                "ru": "Таррагона"
            },
            "geotag": "3108288",
            "post_code": "43001"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Tata",
            "names": {
                "pl": "Tata",
                "en": "Tata",
                "de": "Totis",
                "ru": "Тата"
            },
            "geotag": "3044083",
            "post_code": "2835"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Tatabánya",
            "names": {
                "de": "Tatabánya",
                "en": "Tatabánya",
                "pl": "Tatabánya",
                "ru": "Татабанья"
            },
            "geotag": "3044082",
            "post_code": "2800"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Tczew",
            "names": {
                "en": "Tczew",
                "ru": "Тчев",
                "pl": "Tczew",
                "de": "Tczew"
            },
            "geotag": "3083426",
            "post_code": "83-110"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Teplice",
            "names": {
                "de": "Teplice",
                "pl": "Cieplice",
                "en": "Teplice",
                "ru": "Теплице"
            },
            "geotag": "3064288",
            "post_code": "415 01"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Teramo",
            "names": {
                "pl": "Teramo",
                "de": "Teramo",
                "en": "Teramo",
                "ru": "Терамо"
            },
            "geotag": "3165803",
            "post_code": "64100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Terlizzi",
            "names": {
                "pl": "Terlizzi",
                "en": "Terlizzi",
                "ru": "Терлицци"
            },
            "geotag": "3165788",
            "post_code": "70038"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Termoli",
            "names": {
                "pl": "Termoli",
                "en": "Termoli",
                "de": "Termoli",
                "ru": "Термоли"
            },
            "geotag": "3165773",
            "post_code": "86039"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Terneuzen",
            "names": {
                "de": "Terneuzen",
                "en": "Terneuzen",
                "ru": "Тернезен"
            },
            "geotag": "2746420",
            "post_code": "4531"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Terni",
            "names": {
                "de": "Terni",
                "en": "Terni",
                "pl": "Terni",
                "ru": "Терни"
            },
            "geotag": "3165771",
            "post_code": "05100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Terracina",
            "names": {
                "pl": "Terracina",
                "de": "Terracina",
                "en": "Terracina",
                "ru": "Террачина"
            },
            "geotag": "3165762",
            "post_code": "04019"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Terrassa",
            "names": {
                "en": "Terrassa",
                "pl": "Terrassa",
                "de": "Terrassa",
                "ru": "Террасса"
            },
            "geotag": "3108286",
            "post_code": "08220"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Teruel",
            "names": {
                "en": "Teruel",
                "pl": "Teruel",
                "de": "Teruel",
                "ru": "Теруэль"
            },
            "geotag": "3108126",
            "post_code": "44001"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Tervuren",
            "names": {
                "en": "Tervuren",
                "de": "Tervuren",
                "ru": "Тервюрен"
            },
            "geotag": "2785622",
            "post_code": "3080"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Thiene",
            "names": {
                "pl": "Thiene",
                "en": "Thiene",
                "ru": "Тьене"
            },
            "geotag": "3165698",
            "post_code": "36016"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Tiel",
            "names": {
                "de": "Tiel",
                "en": "Tiel",
                "ru": "Тил"
            },
            "geotag": "2746331",
            "post_code": "4001"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Tilburg",
            "names": {
                "en": "Tilburg",
                "pl": "Tilburg",
                "de": "Tilburg",
                "ru": "Тилбург"
            },
            "geotag": "2746301",
            "post_code": "5011"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Tokat Province",
            "names": {
                "ru": "Токат",
                "de": "Tokat",
                "en": "Tokat Province"
            },
            "geotag": "738743",
            "post_code": "43780"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Tomaszów Mazowiecki",
            "names": {
                "pl": "Tomaszów Mazowiecki",
                "en": "Tomaszów Mazowiecki",
                "de": "Tomaszów Mazowiecki",
                "ru": "Томашув-Мазовецкий"
            },
            "geotag": "756867",
            "post_code": "97-200"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Tongeren",
            "names": {
                "de": "Tongeren",
                "en": "Tongeren",
                "pl": "Tongeren",
                "ru": "Тонгерен"
            },
            "geotag": "2785389",
            "post_code": "3700"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Torgau",
            "names": {
                "de": "Torgau",
                "pl": "Torgau",
                "en": "Torgau",
                "ru": "Торгау"
            },
            "geotag": "2821807",
            "post_code": "04860"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Torhout",
            "names": {
                "en": "Torhout",
                "de": "Torhout",
                "ru": "Торхоут"
            },
            "geotag": "2785364",
            "post_code": "8820"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Torre Annunziata",
            "names": {
                "pl": "Torre Annunziata",
                "en": "Torre Annunziata",
                "ru": "Торре-Аннунциата"
            },
            "geotag": "3165475",
            "post_code": "80058"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Tortosa",
            "names": {
                "en": "Tortosa",
                "de": "Tortosa",
                "pl": "Tortosa",
                "ru": "Тортоса"
            },
            "geotag": "3107677",
            "post_code": "43500"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Torun",
            "names": {
                "pl": "Toruń",
                "de": "Torun",
                "en": "Torun",
                "ru": "Торунь"
            },
            "geotag": "3083271",
            "post_code": "87-100"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Tournai",
            "names": {
                "de": "Tournai",
                "en": "Tournai",
                "pl": "Tournai",
                "ru": "Турне"
            },
            "geotag": "2785341",
            "post_code": "7500"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Trani",
            "names": {
                "pl": "Trani",
                "de": "Trani",
                "en": "Trani",
                "ru": "Трани"
            },
            "geotag": "3165322",
            "post_code": "76125"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Trapani",
            "names": {
                "en": "Trapani",
                "de": "Trapani",
                "pl": "Trapani",
                "ru": "Трапани"
            },
            "geotag": "2522876",
            "post_code": "91100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Traunstein",
            "names": {
                "de": "Traunstein",
                "pl": "Traunstein",
                "en": "Traunstein",
                "ru": "Траунштайн"
            },
            "geotag": "2821515",
            "post_code": "3632"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Trento",
            "names": {
                "de": "Trient",
                "en": "Trento",
                "pl": "Trydent",
                "ru": "Тренто"
            },
            "geotag": "3165243",
            "post_code": "38100"
        },
        {
            "code": 7,
            "country_code": "SK",
            "label": "Trenčín",
            "names": {
                "de": "Trenčín",
                "en": "Trenčín",
                "pl": "Trenczyn",
                "ru": "Тренчин"
            },
            "geotag": "3057140",
            "post_code": "294 01"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Treviglio",
            "names": {
                "pl": "Treviglio",
                "en": "Treviglio",
                "ru": "Тревильо"
            },
            "geotag": "3165207",
            "post_code": "24047"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Treviso",
            "names": {
                "de": "Treviso",
                "en": "Treviso",
                "ru": "Тревизо",
                "pl": "Treviso"
            },
            "geotag": "3165201",
            "post_code": "31100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Trier",
            "names": {
                "de": "Trier",
                "en": "Trier",
                "pl": "Trewir",
                "ru": "Трир"
            },
            "geotag": "2821164",
            "post_code": "54290"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Trieste",
            "names": {
                "de": "Triest",
                "en": "Trieste",
                "pl": "Triest",
                "ru": "Триест"
            },
            "geotag": "3165185",
            "post_code": "34100"
        },
        {
            "code": 7,
            "country_code": "SK",
            "label": "Trnava",
            "names": {
                "de": "Trnava",
                "en": "Trnava",
                "pl": "Trnawa",
                "ru": "Трнава"
            },
            "geotag": "3057124",
            "post_code": "674 01"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Troisdorf",
            "names": {
                "de": "Troisdorf",
                "en": "Troisdorf",
                "ru": "Тройсдорф"
            },
            "geotag": "2821029",
            "post_code": "53840"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Tubbergen",
            "names": {
                "en": "Tubbergen",
                "de": "Tubbergen",
                "ru": "Тубберген"
            },
            "geotag": "2746133",
            "post_code": "7651"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Turnhout",
            "names": {
                "en": "Turnhout",
                "de": "Turnhout",
                "pl": "Turnhout",
                "ru": "Тюрнхаут"
            },
            "geotag": "2785141",
            "post_code": "2300"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Tuttlingen",
            "names": {
                "de": "Tuttlingen",
                "en": "Tuttlingen",
                "ru": "Тутлинген"
            },
            "geotag": "2820693",
            "post_code": "78532"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Two Bridges",
            "names": {
                "de": "Zweibrücken",
                "en": "Two Bridges",
                "pl": "Zweibrücken",
                "ru": "Цвайбрюккен"
            },
            "geotag": "2803620",
            "post_code": "66482"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Tychy",
            "names": {
                "pl": "Tychy",
                "en": "Tychy",
                "de": "Tichau",
                "ru": "Тыхы"
            },
            "geotag": "3082914",
            "post_code": "43-100"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Tábor",
            "names": {
                "pl": "Tabor",
                "de": "Tabor",
                "en": "Tábor",
                "ru": "Табор"
            },
            "geotag": "3064379",
            "post_code": "390 01"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Tübingen",
            "names": {
                "de": "Tübingen",
                "en": "Tübingen",
                "pl": "Tybinga",
                "ru": "Тюбинген"
            },
            "geotag": "2820860",
            "post_code": "72070"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Třebíč",
            "names": {
                "pl": "Třebíč",
                "de": "Trebitsch-Stadt",
                "en": "Třebíč",
                "ru": "Тршебич"
            },
            "geotag": "3064104",
            "post_code": "674 01"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Uccle",
            "names": {
                "de": "Uccle/Ukkel",
                "en": "Uccle",
                "ru": "Уккел"
            },
            "geotag": "2785123",
            "post_code": "1180"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Uden",
            "names": {
                "en": "Uden",
                "de": "Uden",
                "ru": "Уден"
            },
            "geotag": "2746005",
            "post_code": "5401"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Uelzen",
            "names": {
                "en": "Uelzen",
                "de": "Uelzen",
                "ru": "Ильцен"
            },
            "geotag": "2820456",
            "post_code": "29525"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Uherské Hradiště",
            "names": {
                "de": "Ungarisch-Hradisch",
                "pl": "Uherské Hradiště",
                "en": "Uherské Hradiště",
                "ru": "Угерске-Градиште"
            },
            "geotag": "3063739",
            "post_code": "686 01"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Ulm",
            "names": {
                "de": "Ulm",
                "en": "Ulm",
                "pl": "Ulm",
                "ru": "Ульм"
            },
            "geotag": "2820256",
            "post_code": "89040"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Unna",
            "names": {
                "de": "Unna",
                "en": "Unna",
                "ru": "Унна"
            },
            "geotag": "2820087",
            "post_code": "59423"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Unterschleissheim",
            "names": {
                "ru": "Унтершлайсхайм",
                "de": "Unterschleißheim",
                "en": "Unterschleissheim"
            },
            "geotag": "2818766",
            "post_code": "85716"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Uslar",
            "names": {
                "de": "Uslar",
                "en": "Uslar",
                "ru": "Услар"
            },
            "geotag": "2818094",
            "post_code": "37170"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Ustka",
            "names": {
                "de": "Ustka",
                "pl": "Ustka",
                "en": "Ustka",
                "ru": "Устка"
            },
            "geotag": "3082756",
            "post_code": "76-270"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Utrecht",
            "names": {
                "de": "Utrecht",
                "en": "Utrecht",
                "pl": "Utrecht",
                "ru": "Утрехт"
            },
            "geotag": "2745912",
            "post_code": "3454"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Valenza",
            "names": {
                "pl": "Valenza",
                "de": "Valenza",
                "en": "Valenza",
                "ru": "Валенса"
            },
            "geotag": "3164920",
            "post_code": "15048"
        },
        {
            "code": 21,
            "country_code": "ES",
            "label": "Valls",
            "names": {
                "en": "Valls",
                "pl": "Valls",
                "de": "Valls",
                "ru": "Вальс"
            },
            "geotag": "3106492",
            "post_code": "43800"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Varese",
            "names": {
                "pl": "Varese",
                "en": "Varese",
                "de": "Varese",
                "ru": "Варезе"
            },
            "geotag": "3164699",
            "post_code": "21100"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Vasto",
            "names": {
                "pl": "Vasto",
                "de": "Vasto",
                "en": "Vasto",
                "ru": "Васто"
            },
            "geotag": "3164672",
            "post_code": "66054"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Veghel",
            "names": {
                "en": "Veghel",
                "de": "Veghel",
                "ru": "Вегел"
            },
            "geotag": "2745726",
            "post_code": "5461"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Velbert",
            "names": {
                "de": "Velbert",
                "en": "Velbert",
                "ru": "Фельберт"
            },
            "geotag": "2817724",
            "post_code": "42549"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Venlo",
            "names": {
                "de": "Venlo",
                "en": "Venlo",
                "pl": "Venlo",
                "ru": "Венло"
            },
            "geotag": "2745641",
            "post_code": "5911"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Ventimiglia",
            "names": {
                "pl": "Ventimiglia",
                "de": "Ventimiglia",
                "en": "Ventimiglia",
                "ru": "Вентимилья"
            },
            "geotag": "3164582",
            "post_code": "18039"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Vercelli",
            "names": {
                "pl": "Vercelli",
                "de": "Vercelli",
                "en": "Vercelli",
                "ru": "Верчелли"
            },
            "geotag": "3164565",
            "post_code": "13100"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Verona",
            "names": {
                "de": "Verona",
                "en": "Verona",
                "pl": "Werona",
                "ru": "Верона"
            },
            "geotag": "3164527",
            "post_code": "37100"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Verviers",
            "names": {
                "de": "Verviers",
                "en": "Verviers",
                "pl": "Verviers",
                "ru": "Вервье"
            },
            "geotag": "2784821",
            "post_code": "4800"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Veszprém",
            "names": {
                "de": "Veszprem",
                "en": "Veszprém",
                "pl": "Veszprém",
                "ru": "Веспрем"
            },
            "geotag": "3042929",
            "post_code": "8200"
        },
        {
            "code": 14,
            "country_code": "IT",
            "label": "Viareggio",
            "names": {
                "pl": "Viareggio",
                "de": "Viareggio",
                "en": "Viareggio",
                "ru": "Виареджио"
            },
            "geotag": "3164433",
            "post_code": "55049"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Vibo Valentia",
            "names": {
                "pl": "Vibo Valentia",
                "de": "Vibo Valentia",
                "en": "Vibo Valentia",
                "ru": "Вибо-Валентия"
            },
            "geotag": "2522776",
            "post_code": "89900"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Vicenza",
            "names": {
                "de": "Vicenza",
                "en": "Vicenza",
                "pl": "Vicenza",
                "ru": "Виченца"
            },
            "geotag": "3164419",
            "post_code": "36100"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Viersen",
            "names": {
                "de": "Viersen",
                "en": "Viersen",
                "ru": "Фирзен"
            },
            "geotag": "2817311",
            "post_code": "41747"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Vigevano",
            "names": {
                "pl": "Vigevano",
                "en": "Vigevano",
                "de": "Vigevano",
                "ru": "Виджевано"
            },
            "geotag": "3164376",
            "post_code": "27029"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Vigo",
            "names": {
                "de": "Vigo",
                "en": "Vigo",
                "pl": "Vigo",
                "ru": "Виго"
            },
            "geotag": "3105976",
            "post_code": "33790"
        },
        {
            "code": 15,
            "country_code": "IT",
            "label": "Villaricca",
            "names": {
                "pl": "Villaricca",
                "en": "Villaricca",
                "ru": "Вилларикка"
            },
            "geotag": "3164153",
            "post_code": "80010"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Villingen-Schwenningen",
            "names": {
                "de": "Villingen-Schwenningen",
                "en": "Villingen-Schwenningen",
                "pl": "Villingen-Schwenningen",
                "ru": "Филлинген-Швеннинген"
            },
            "geotag": "2817220",
            "post_code": "78048"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Vimercate",
            "names": {
                "pl": "Vimercate",
                "de": "Vimercate",
                "en": "Vimercate",
                "ru": "Вимеркате"
            },
            "geotag": "3164083",
            "post_code": "20871"
        },
        {
            "code": 13,
            "country_code": "IT",
            "label": "Vittorio Veneto",
            "names": {
                "pl": "Vittorio Veneto",
                "en": "Vittorio Veneto",
                "de": "Vittorio Veneto",
                "ru": "Витторио-Венето"
            },
            "geotag": "3164028",
            "post_code": "31029"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Vác",
            "names": {
                "de": "Vác",
                "pl": "Vác",
                "en": "Vác",
                "ru": "Вац"
            },
            "geotag": "3043293",
            "post_code": "2600"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Wadowice",
            "names": {
                "pl": "Wadowice",
                "en": "Wadowice",
                "de": "Wadowice",
                "ru": "Вадовице"
            },
            "geotag": "3082722",
            "post_code": "34-100"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Wageningen",
            "names": {
                "de": "Wageningen",
                "en": "Wageningen",
                "ru": "Вагенинген"
            },
            "geotag": "2745088",
            "post_code": "6701"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Waregem",
            "names": {
                "en": "Waregem",
                "pl": "Waregem",
                "ru": "Варегем"
            },
            "geotag": "2784068",
            "post_code": "8790"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Waterloo",
            "names": {
                "de": "Waterloo",
                "en": "Waterloo",
                "pl": "Waterloo",
                "ru": "Ватерлоо"
            },
            "geotag": "2783985",
            "post_code": "1410"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Watermael-Boitsfort",
            "names": {
                "de": "Watermael-Boitsfort/Watermaal-Bosvoorde",
                "en": "Watermael-Boitsfort",
                "ru": "Ватермаль-Буафор"
            },
            "geotag": "2783979",
            "post_code": "1170"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Wavre",
            "names": {
                "en": "Wavre",
                "de": "Wavre",
                "pl": "Wavre",
                "ru": "Вавр"
            },
            "geotag": "2783941",
            "post_code": "1300"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Wałbrzych",
            "names": {
                "de": "Wałbrzych",
                "pl": "Wałbrzych",
                "en": "Wałbrzych",
                "ru": "Валбжих"
            },
            "geotag": "3082707",
            "post_code": "58-206"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Weert",
            "names": {
                "en": "Weert",
                "de": "Weert",
                "ru": "Верт"
            },
            "geotag": "2744911",
            "post_code": "2880"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Weesp",
            "names": {
                "en": "Weesp",
                "de": "Weesp",
                "ru": "Весп"
            },
            "geotag": "2744904",
            "post_code": "1381"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Weil am Rhein",
            "names": {
                "de": "Weil am Rhein",
                "en": "Weil am Rhein",
                "pl": "Weil am Rhein",
                "ru": "Вайль-ам-Райн"
            },
            "geotag": "2812636",
            "post_code": "79576"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Weil der Stadt",
            "names": {
                "de": "Weil der Stadt",
                "en": "Weil der Stadt",
                "ru": "Вайль-дер-Штадт"
            },
            "geotag": "2812625",
            "post_code": "71263"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Weimar",
            "names": {
                "de": "Weimar",
                "en": "Weimar",
                "pl": "Weimar",
                "ru": "Веймар"
            },
            "geotag": "2812482",
            "post_code": "35096"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Weinheim",
            "names": {
                "de": "Weinheim",
                "en": "Weinheim",
                "ru": "Вайнхайм"
            },
            "geotag": "2812174",
            "post_code": "69469"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Wejherowo",
            "names": {
                "en": "Wejherowo",
                "pl": "Wejherowo",
                "de": "Wejherowo",
                "ru": "Вейхерово"
            },
            "geotag": "3082473",
            "post_code": "84-200"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Wels",
            "names": {
                "de": "Wels",
                "pl": "Wels",
                "en": "Wels",
                "ru": "Вельс"
            },
            "geotag": "2761524",
            "post_code": "9361"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Wernigerode",
            "names": {
                "de": "Wernigerode",
                "en": "Wernigerode",
                "ru": "Вернигероде"
            },
            "geotag": "2810808",
            "post_code": "38855"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Wesel",
            "names": {
                "de": "Wesel",
                "pl": "Wesel",
                "en": "Wesel",
                "ru": "Везель"
            },
            "geotag": "2810678",
            "post_code": "46483"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Wetzlar",
            "names": {
                "de": "Wetzlar",
                "en": "Wetzlar",
                "pl": "Wetzlar",
                "ru": "Вецлар"
            },
            "geotag": "2809889",
            "post_code": "35576"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Wevelgem",
            "names": {
                "en": "Wevelgem",
                "de": "Wevelgem",
                "ru": "Вевельгеме"
            },
            "geotag": "2783759",
            "post_code": "8560"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Wieliczka",
            "names": {
                "de": "Wieliczka",
                "pl": "Wieliczka",
                "en": "Wieliczka",
                "ru": "Величка"
            },
            "geotag": "755889",
            "post_code": "32-020"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Wieluń",
            "names": {
                "pl": "Wieluń",
                "de": "Wieluń",
                "en": "Wieluń",
                "ru": "Велюнь"
            },
            "geotag": "3082197",
            "post_code": "98-300"
        },
        {
            "code": 18,
            "country_code": "AT",
            "label": "Wiener Neustadt",
            "names": {
                "de": "Wr. Neustadt",
                "pl": "Wiener Neustadt",
                "en": "Wiener Neustadt",
                "ru": "Винер-Нойштадт"
            },
            "geotag": "2761353",
            "post_code": "2700"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Wierden",
            "names": {
                "en": "Wierden",
                "de": "Wierden",
                "ru": "Виерден"
            },
            "geotag": "2744549",
            "post_code": "7641"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Wiesbaden",
            "names": {
                "de": "Wiesbaden",
                "en": "Wiesbaden",
                "pl": "Wiesbaden",
                "ru": "Висбаден"
            },
            "geotag": "2809346",
            "post_code": "65183"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Wijchen",
            "names": {
                "de": "Wijchen",
                "en": "Wijchen",
                "ru": "Вийчен"
            },
            "geotag": "2744514",
            "post_code": "6601"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Wilhelmshaven",
            "names": {
                "de": "Wilhelmshaven",
                "en": "Wilhelmshaven",
                "pl": "Wilhelmshaven",
                "ru": "Вильгельмсхафен"
            },
            "geotag": "2808720",
            "post_code": "26382"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Winnenden",
            "names": {
                "de": "Winnenden",
                "en": "Winnenden",
                "ru": "Винненден"
            },
            "geotag": "2807872",
            "post_code": "71364"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Winschoten",
            "names": {
                "en": "Winschoten",
                "pl": "Winschoten",
                "de": "Winschoten",
                "ru": "Винсхотен"
            },
            "geotag": "2744344",
            "post_code": "9671"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Wipperfürth",
            "names": {
                "de": "Wipperfürth",
                "en": "Wipperfürth",
                "ru": "Випперфюрт"
            },
            "geotag": "2807594",
            "post_code": "51688"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Wismar",
            "names": {
                "de": "Wismar",
                "pl": "Wyszomierz",
                "en": "Wismar",
                "ru": "Висмар"
            },
            "geotag": "2807465",
            "post_code": "23966"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Witten",
            "names": {
                "de": "Witten",
                "en": "Witten",
                "pl": "Witten",
                "ru": "Виттен"
            },
            "geotag": "2807363",
            "post_code": "58452"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Wodzisław Śląski",
            "names": {
                "pl": "Wodzisław Śląski",
                "en": "Wodzisław Śląski",
                "de": "Wodzisław Śląski",
                "ru": "Водзислав-Слёнски"
            },
            "geotag": "3081677",
            "post_code": "44-300"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Woerden",
            "names": {
                "en": "Woerden",
                "pl": "Woerden",
                "de": "Woerden",
                "ru": "Вурден"
            },
            "geotag": "2744248",
            "post_code": "3441"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Wolfenbüttel",
            "names": {
                "de": "Wolfenbüttel",
                "en": "Wolfenbüttel",
                "ru": "Вольфенбюттель"
            },
            "geotag": "2806914",
            "post_code": "38281"
        },
        {
            "code": 9,
            "country_code": "DE",
            "label": "Wolfsburg",
            "names": {
                "de": "Wolfsburg",
                "ru": "Вольфсбург",
                "en": "Wolfsburg"
            },
            "geotag": "2806654",
            "post_code": "38440"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Woluwe-Saint-Lambert",
            "names": {
                "en": "Woluwe-Saint-Lambert",
                "de": "Woluwe-Saint-Lambert/Sint-Lambrechts-Woluwe",
                "ru": "Волюве-Сен-Ламбер"
            },
            "geotag": "2783476",
            "post_code": "1200"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Worms",
            "names": {
                "de": "Worms",
                "en": "Worms",
                "pl": "Wormacja",
                "ru": "Вормс"
            },
            "geotag": "2806142",
            "post_code": "67547"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Wroclaw",
            "names": {
                "de": "Wroclaw",
                "en": "Wroclaw",
                "pl": "Wrocław",
                "ru": "Вроцлав"
            },
            "geotag": "3081368",
            "post_code": "50-001"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Wuelfrath",
            "names": {
                "de": "Wülfrath",
                "en": "Wuelfrath",
                "ru": "Вюльфрат"
            },
            "geotag": "2805910",
            "post_code": "42489"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Wuppertal",
            "names": {
                "de": "Wuppertal",
                "en": "Wuppertal",
                "pl": "Wuppertal",
                "ru": "Вупперталь"
            },
            "geotag": "2805753",
            "post_code": "42103"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Würzburg",
            "names": {
                "de": "Würzburg",
                "en": "Würzburg",
                "pl": "Würzburg",
                "ru": "Вюрцбург"
            },
            "geotag": "2805615",
            "post_code": "97070"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Włocławek",
            "names": {
                "en": "Włocławek",
                "pl": "Włocławek",
                "de": "Włocławek",
                "ru": "Влоцлавек"
            },
            "geotag": "3081741",
            "post_code": "87-800"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Xanten",
            "names": {
                "de": "Xanten",
                "pl": "Xanten",
                "en": "Xanten",
                "ru": "Ксантен"
            },
            "geotag": "2805385",
            "post_code": "46509"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Yalova",
            "names": {
                "pl": "Yalova",
                "de": "Yalova",
                "en": "Yalova",
                "ru": "Ялова"
            },
            "geotag": "738025",
            "post_code": "17900"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Zabrze",
            "names": {
                "de": "Zabrze",
                "pl": "Zabrze",
                "en": "Zabrze",
                "ru": "Забже"
            },
            "geotag": "3080985",
            "post_code": "41-800"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Zakopane",
            "names": {
                "pl": "Zakopane",
                "de": "Zakopane",
                "en": "Zakopane",
                "ru": "Закопане"
            },
            "geotag": "3080866",
            "post_code": "34-500"
        },
        {
            "code": 12,
            "country_code": "HU",
            "label": "Zalaegerszeg",
            "names": {
                "de": "Egersee",
                "en": "Zalaegerszeg",
                "pl": "Zalaegerszeg",
                "ru": "Залаэгерсег"
            },
            "geotag": "3042638",
            "post_code": "8900"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Zamość",
            "names": {
                "pl": "Zamość",
                "de": "Zamość",
                "en": "Zamość",
                "ru": "Замосць"
            },
            "geotag": "753866",
            "post_code": "89-200"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Zandvoort",
            "names": {
                "en": "Zandvoort",
                "pl": "Zandvoort",
                "ru": "Зандвоорт",
                "de": "Zandvoort"
            },
            "geotag": "2744042",
            "post_code": "2041"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Zawiercie",
            "names": {
                "pl": "Zawiercie",
                "en": "Zawiercie",
                "de": "Zawiercie",
                "ru": "Заверце"
            },
            "geotag": "3080526",
            "post_code": "42-400"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Zedelgem",
            "names": {
                "en": "Zedelgem",
                "pl": "Zedelgem",
                "ru": "Зедельгем"
            },
            "geotag": "2783308",
            "post_code": "8210"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Zeist",
            "names": {
                "en": "Zeist",
                "de": "Zeist",
                "ru": "Зейст"
            },
            "geotag": "2743977",
            "post_code": "3701"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Zgierz",
            "names": {
                "pl": "Zgierz",
                "en": "Zgierz",
                "de": "Zgierz",
                "ru": "Згеж"
            },
            "geotag": "3080251",
            "post_code": "90-100"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Zgorzelec",
            "names": {
                "pl": "Zgorzelec",
                "de": "Zgorzelec",
                "en": "Zgorzelec",
                "ru": "Згожелец"
            },
            "geotag": "3080231",
            "post_code": "59-900"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Zielona Góra",
            "names": {
                "pl": "Zielona Góra",
                "de": "Zielona Góra",
                "en": "Zielona Góra",
                "ru": "Зелёна-Гура"
            },
            "geotag": "3080165",
            "post_code": "95-020"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Zittau",
            "names": {
                "de": "Zittau",
                "en": "Zittau",
                "pl": "Żytawa",
                "ru": "Циттау"
            },
            "geotag": "2804008",
            "post_code": "02763"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Zlín",
            "names": {
                "pl": "Zlín",
                "en": "Zlín",
                "de": "Zlín",
                "ru": "Злин"
            },
            "geotag": "3061370",
            "post_code": "760 01"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Znojmo",
            "names": {
                "de": "Znaym",
                "en": "Znojmo",
                "pl": "Znojmo",
                "ru": "Зноймо"
            },
            "geotag": "3061344",
            "post_code": "669 02"
        },
        {
            "code": 10,
            "country_code": "DE",
            "label": "Zulpich",
            "names": {
                "de": "Zülpich",
                "en": "Zulpich",
                "ru": "Цюльпих"
            },
            "geotag": "2803723",
            "post_code": "53909"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Zutphen",
            "names": {
                "en": "Zutphen",
                "de": "Zutphen",
                "ru": "Зютфен"
            },
            "geotag": "2743608",
            "post_code": "7201"
        },
        {
            "code": 20,
            "country_code": "BE",
            "label": "Zwevegem",
            "names": {
                "en": "Zwevegem",
                "de": "Zwevegem",
                "ru": "Звевегем"
            },
            "geotag": "2783089",
            "post_code": "8550"
        },
        {
            "code": 8,
            "country_code": "DE",
            "label": "Zwickau",
            "names": {
                "de": "Zwickau",
                "en": "Zwickau",
                "pl": "Zwickau",
                "ru": "Цвиккау"
            },
            "geotag": "2803560",
            "post_code": "08056"
        },
        {
            "code": 19,
            "country_code": "NL",
            "label": "Zwolle",
            "names": {
                "de": "Zwolle",
                "en": "Zwolle",
                "pl": "Zwolle",
                "ru": "Зволле"
            },
            "geotag": "2743477",
            "post_code": "8011"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Ząbkowice Śląskie",
            "names": {
                "pl": "Ząbkowice Śląskie",
                "de": "Ząbkowice Śląskie",
                "en": "Ząbkowice Śląskie",
                "ru": "Зомбковице-Слёнске"
            },
            "geotag": "3081046",
            "post_code": "57-200"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Złotoryja",
            "names": {
                "pl": "Złotoryja",
                "de": "Złotoryja",
                "en": "Złotoryja",
                "ru": "Злоторыя"
            },
            "geotag": "3080074",
            "post_code": "59-500"
        },
        {
            "code": 16,
            "country_code": "TR",
            "label": "Çorlu",
            "names": {
                "de": "Çorlu",
                "pl": "Çorlu",
                "en": "Çorlu",
                "ru": "Чорлу"
            },
            "geotag": "748893",
            "post_code": "59850"
        },
        {
            "code": 11,
            "country_code": "HU",
            "label": "Érd",
            "names": {
                "pl": "Érd",
                "de": "Érd",
                "en": "Érd",
                "ru": "Эрд"
            },
            "geotag": "3053281",
            "post_code": "2030"
        },
        {
            "code": 4,
            "country_code": "CZ",
            "label": "Česká Lípa",
            "names": {
                "de": "Ceska Lipa",
                "pl": "Czeska Lipa",
                "en": "Česká Lípa",
                "ru": "Ческа-Липа"
            },
            "geotag": "3077929",
            "post_code": "470 01"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Český Těšín",
            "names": {
                "pl": "Czeski Cieszyn",
                "de": "Teschen",
                "en": "Český Těšín",
                "ru": "Чески-Тешин"
            },
            "geotag": "3077882",
            "post_code": "737 01"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Łomża",
            "names": {
                "pl": "Łomża",
                "en": "Łomża",
                "de": "Łomża",
                "ru": "Ломжа"
            },
            "geotag": "766027",
            "post_code": "18-400"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Łęczyca",
            "names": {
                "pl": "Łęczyca",
                "de": "Łęczyca",
                "en": "Łęczyca",
                "ru": "Ленчица"
            },
            "geotag": "3093726",
            "post_code": "56-209"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Świnoujście",
            "names": {
                "de": "Świnoujście",
                "pl": "Świnoujście",
                "en": "Świnoujście",
                "ru": "Свиноуйсьце"
            },
            "geotag": "3083955",
            "post_code": "72-600"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Świętochłowice",
            "names": {
                "pl": "Świętochłowice",
                "en": "Świętochłowice",
                "de": "Świętochłowice",
                "ru": "Свентохловице"
            },
            "geotag": "3083988",
            "post_code": "41-600"
        },
        {
            "code": 3,
            "country_code": "PL",
            "label": "Żagań",
            "names": {
                "de": "Żagań",
                "pl": "Żagań",
                "en": "Żagań",
                "ru": "Жагань"
            },
            "geotag": "3080944",
            "post_code": "68-100"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Żory",
            "names": {
                "pl": "Żory",
                "en": "Żory",
                "de": "Sohrau",
                "ru": "Жоры"
            },
            "geotag": "3080004",
            "post_code": "44-240"
        },
        {
            "code": 1,
            "country_code": "PL",
            "label": "Żyrardów",
            "names": {
                "pl": "Żyrardów",
                "en": "Żyrardów",
                "de": "Żyrardów",
                "ru": "Жирардув"
            },
            "geotag": "752967",
            "post_code": "96-300"
        },
        {
            "code": 2,
            "country_code": "PL",
            "label": "Żywiec",
            "names": {
                "de": "Żywiec",
                "pl": "Żywiec",
                "en": "Żywiec",
                "ru": "Живец"
            },
            "geotag": "3079855",
            "post_code": "34-300"
        },
        {
            "code": 5,
            "country_code": "CZ",
            "label": "Žatec",
            "names": {
                "de": "Zatec",
                "en": "Žatec",
                "pl": "Žatec",
                "ru": "Жатец"
            },
            "geotag": "3061822",
            "post_code": "588 62"
        },
        {
            "code": 6,
            "country_code": "SK",
            "label": "Žilina",
            "names": {
                "de": "Žilina",
                "en": "Žilina",
                "pl": "Żylina",
                "ru": "Жилина"
            },
            "geotag": "3056508",
            "post_code": "741 01"
        },
        {
            "country_code": "PL",
            "label": "Warsaw",
            "post_code": "00-001"
        },
        {
            "country_code": "CZ",
            "label": "Prague",
            "post_code": "100-00"
        },
        {
            "country_code": "SL",
            "label": "Ljubljana",
            "post_code": "1000"
        },
        {
            "country_code": "IT",
            "label": "Rome",
            "post_code": "00100"
        },
        {
            "country_code": "TR",
            "label": "Ankara",
            "post_code": "06000"
        },
        {
            "country_code": "AT",
            "label": "Vein",
            "post_code": "1010"
        },
        {
            "country_code": "NL",
            "label": "Amsterdam",
            "post_code": "1045"
        },
        {
            "country_code": "BE",
            "label": "Brussels",
            "post_code": "1000"
        },
        {
            "country_code": "ES",
            "label": "Madrid",
            "post_code": "28001"
        },
        {
            "code": 1,
            "country_code": "CN",
            "label": "Fujian",
            "names": "Фуцзянь"
        },
        {
            "code": 1,
            "country_code": "CN",
            "label": "Zhejiang",
            "names": "Чжецзян"
        },
        {
            "code": 1,
            "country_code": "CN",
            "label": "Shanghai",
            "names": "Шанхай"
        },
        {
            "code": 1,
            "country_code": "CN",
            "label": "Hubei",
            "names": "Хубэй"
        },
        {
            "code": 1,
            "country_code": "CN",
            "label": "Henan",
            "names": "Хэнань"
        },
        {
            "code": 1,
            "country_code": "CN",
            "label": "Shandong",
            "names": "Шаньдун"
        },
        {
            "code": 1,
            "country_code": "CN",
            "label": "Hebei",
            "names": "Хэбэй"
        }
    ]
